import QueryString from 'query-string';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import { TabsContainer, TabsPanel } from '../tabs/TabsContainer';
import CONTENT_CONTROLLER from '../../controllers/content';
import FILING_CONTROLLER from '../../controllers/filing';
import FILING_CORRECTIONS_CONTROLLER from '../../controllers/filingCorrections';
import FILING_OPTIONS_CONTROLLER from '../../controllers/filingOptions';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import USER_QUESTIONS_CONTROLLER from '../../controllers/userQuestions';
import MANAGED_UX_FORMS_CONTROLLER from '../../controllers/managedUxForms';
import MANUAL_DOCUMENTS_CONTROLLER from '../../controllers/manualDocuments';
import RETURN_APPROVALS_CONTROLLER from '../../controllers/returnApprovals';
import ENUMS, { ReturnDisplayType, ECListingFlowPerTransactionTypesEnum, FilingTypeEnum, LocalListingFlowEnum, VATBookFlowEnum , ExtrastatFlowEnum, VATReturnDetailsTabs, FeatureFlagEnum, ECTypeEnums, IntrastatFlowEnum, CloseReturnTypeEnum} from '../../utils/enums';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import FilingFrequencySelector from '../selectors/filing/FilingFrequencySelector';
import TransactionFilter from '../selectors/filing/TransactionFilter';
import CorrectionPeriodSelector from '../selectors/filing/CorrectionPeriodSelector';
import FilingPreparation from './FilingPreparation';
import FilingValues from './FilingValues';
import PrepareFile from './PrepareFile';
import ReturnByTransactions from './returnByTransactions/ReturnByTransactions';
import ReportingOptionListingLines from './reports/ReportingOptionListingLines';
import UserQuestionsForm, {FORM_NAME as USER_QUESTIONS_FORM} from './UserQuestionsForm';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import StaticApplicationMessage from '../inAppMessages/StaticApplicationMessage';
import BoxValueValidationModal from '../modals/BoxValueValidationModal';
import FilingHelper from './filingHelper';
import ConfirmationModal from '../modals/ConfirmationModal';
import getClientConfig from '../../utils/getClientConfig';
import { VatReturnAsyncGeneration } from '../../utils/appConfig';
import { isAutoSubmissionEnabled } from '../../utils/autoSubmissionConfig';
import { canInitiateDirectSubmissionGated } from '../../utils/directSubmissionAccess';
import {
  isReturnApprovalInScope,
  getApprovalGate,
  doesRegenerateVoidApproval,
  VAT_RETURN_REGENERATE_MESSAGE_KEY,
  VAT_RETURN_REGENERATE_VOIDS_APPROVAL_MESSAGE_KEY
} from '../../utils/returnApprovalConfig';
import ReturnApprovalControls from '../returnApprovals/ReturnApprovalControls';
import { checkFeatureFlagForReturnType, getOssReturnTypes } from '../../utils/featureFlagMappingForReturnType';

import Logger, { LOG_LEVELS, ALL_MESSAGES } from '../../utils/logger';

import ReturnGenerationControls from './ReturnGenerationControls';
import ReturnPreview from './ReturnPreview';
import { saveBlobAs } from '../downloaders/FileSaveAs';
import { MTD_SUBMIT_FILING_LOG_SCOPE } from '../../utils/mtdSubmissionResponse';
import MTDSubmitFiling from './MTDSubmitFiling';
import NLSubmitFiling from './NLSubmitFiling';
import NLSubmissionFilingV2 from './NLSubmissionFilingV2';
import DESubmitFiling from './DESubmitFiling';
import OSSGroupFilters from '../selectors/filing/OSSGroupFilters';
import ReactComponentHelper from '../helper/ReactComponentHelper';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';
import { SLoader } from '@avalara/skylab-sdk/react';
const log = new Logger('FILING_PAGE', LOG_LEVELS.DEBUG);

const EMPTY_OBJECT = {};

const holdingCompanyCountries = [ 'ES', 'ESGC' ];
const defaultDueDate = '1899-01-01';
const ITCountryCode = 'IT';
const PLCountryCode = 'PL';
const ReturnTypeXML = 'XML';
const English = 'en';
const showSimpifiedIntrastat = false; //Default to false, since not working
const { enableCorrections, vrRestApiHost, synchronousOnlyVatReturnCountries }  = getClientConfig();
const NO_SELECTION = -1;
const salesTypes = [0, 3, 6];
const purchaseTypes = [1, 4, 7];
const callOfStocksType = ["9", "10", "11"];  //flash sale type of call of stocks (EC type 12) will be part of EC sales
const getDefaultValue = (value) => value || '';  // this is to reduce Cognitive Complexity
const siCountryCode = 'SI';

const GB_FORM_NAME = 'FixedFormat';
const GB_FILE_NAMES = ['VAT Return GB', 'VAT_GB'];
const XML_FORM_NAME = 'XML';
const NL_VAT_FILE_NAMES = ['VAT Return NL', 'VAT_NL', 'VAT_Corr_NL'];
const DE_VAT_FILE_NAMES = ['VAT Return DE', 'VAT_DE', 'VAT_Corr_DE'];
const DE_VAT_FORM_NAME = 'ERIC submission';
const SYNCHRONOUS_ONLY_VAT_RETURN_COUNTRIES = synchronousOnlyVatReturnCountries
  ? synchronousOnlyVatReturnCountries.split(',').map(c => c.trim()).filter(Boolean)
  : [];

class FilingPage extends Component {

  constructor(props) {
    super(props);

    this.selectedFilingFrequency = null;
    this.selectedCorrectionPeriod = undefined;
    this.selectedCorrectionPeriodIndex = -1;
    this.startDate = null;
    this.endDate = null;
    this.vatnumber = null;
    this.onEcTypeChangeHandler = this.onEcTypeChangeHandler.bind(this);
    this.generateFinalReportData = this.generateFinalReportData.bind(this);
    this.onListingLineDelete = this.onListingLineDelete.bind(this);
    this.onListingLineModify = this.onListingLineModify.bind(this);
    this.onVATImport = this.onVATImport.bind(this);
    this.onVATImportDataReplace = this.onVATImportDataReplace.bind(this);
    this.onAddLine = this.onAddLine.bind(this);
    this.onListingLineDeleteCorrections = this.onListingLineDeleteCorrections.bind(this);
    this.onAddLineCorrections = this.onAddLineCorrections.bind(this);
    this.handleAfterTabSelected = this.handleAfterTabSelected.bind(this);
    this.handleOnBoxValueChange = this.handleOnBoxValueChange.bind(this);
    this.buildPeriodScopedFilename = this.buildPeriodScopedFilename.bind(this);
    this.getVATBookReportFilename = this.getVATBookReportFilename.bind(this);
    this.vatBookFetchContent = this.vatBookFetchContent.bind(this);
    this.onFilingQuestionsSubmit = this.onFilingQuestionsSubmit.bind(this);
    this.onPrepareFileSubmit = this.onPrepareFileSubmit.bind(this);
    this.prepareUserAndDatabaseFields = this.prepareUserAndDatabaseFields.bind(this);
    this.resetFormData = this.resetFormData.bind(this);
    this.setupEditableLinesData = this.setupEditableLinesData.bind(this);
    this.getLisitngLinesData = this.getLisitngLinesData.bind(this);
    this.onVATReturnTabHandler = this.onVATReturnTabHandler.bind(this); //Tab change handler for VATReturnDetails screen
    this.vatBooksGenerateClickHandler = this.vatBooksGenerateClickHandler.bind(this);
    // Intrastat generation handlers (enableNewIntrastatOpenReturnPage feature)
    this.intrastatGenerateClickHandler = this.intrastatGenerateClickHandler.bind(this);
    this.intrastatReGenerateClickHandler = this.intrastatReGenerateClickHandler.bind(this);
    this.intrastatRegenerateConfirmationModalYesHandler = this.intrastatRegenerateConfirmationModalYesHandler.bind(this);
    this.intrastatRegenerateConfirmationModalCancelHandler = this.intrastatRegenerateConfirmationModalCancelHandler.bind(this);
    this.intrastatSubmitClickHandler = this.intrastatSubmitClickHandler.bind(this);
    this.downloadIntrastat = this.downloadIntrastat.bind(this);
    this.intrastatSubmitConfirmationModalYesHandler = this.intrastatSubmitConfirmationModalYesHandler.bind(this);
    this.intrastatSubmitConfirmationModalCancelHandler = this.intrastatSubmitConfirmationModalCancelHandler.bind(this);
    // VAT Return generation handlers (enableAsyncVatReturnOpenReturnPage feature)
    this.vatReturnGenerateClickHandler = this.vatReturnGenerateClickHandler.bind(this);
    this.vatReturnReGenerateClickHandler = this.vatReturnReGenerateClickHandler.bind(this);
    this.vatReturnRegenerateConfirmationModalYesHandler = this.vatReturnRegenerateConfirmationModalYesHandler.bind(this);
    this.vatReturnRegenerateConfirmationModalCancelHandler = this.vatReturnRegenerateConfirmationModalCancelHandler.bind(this);
    this.vatReturnSubmitClickHandler = this.vatReturnSubmitClickHandler.bind(this);
    this.downloadVatReturn = this.downloadVatReturn.bind(this);
    this.vatReturnSubmitConfirmationModalYesHandler = this.vatReturnSubmitConfirmationModalYesHandler.bind(this);
    this.vatReturnSubmitConfirmationModalCancelHandler = this.vatReturnSubmitConfirmationModalCancelHandler.bind(this);
    this.vatReturnFetchContent = this.vatReturnFetchContent.bind(this);
    this.buildVatReturnDetails = this.buildVatReturnDetails.bind(this);
    this.handleVatReturnApiResponse = this.handleVatReturnApiResponse.bind(this);
    this.getVatReturnReportFilename = this.getVatReturnReportFilename.bind(this);
    this.getVatReturnCountrySpecificButton = this.getVatReturnCountrySpecificButton.bind(this);
    // VAT Return async generation auto-fetch polling
    this.startVatReturnGenerationPolling = this.startVatReturnGenerationPolling.bind(this);
    this.stopVatReturnGenerationPolling = this.stopVatReturnGenerationPolling.bind(this);
    this.failVatReturnGenerationPolling = this.failVatReturnGenerationPolling.bind(this);
    this.pollVatReturnGenerationOnce = this.pollVatReturnGenerationOnce.bind(this);
    this.applyVatReturnReadyState = this.applyVatReturnReadyState.bind(this);
    this.vatReturnPollIntervalId = 0;
    this.vatReturnPollStartedAt = 0;
    this.vatReturnPollErrorCount = 0;
    this.closeAndSubmitVatBook = this.closeAndSubmitVatBook.bind(this);
    this.downloadVatBook = this.downloadVatBook.bind(this);
    this.vatBooksSubmitClickHandler = this.vatBooksSubmitClickHandler.bind(this);
    this.vatBooksPdfPreviewSubmitClickHandler = this.vatBooksPdfPreviewSubmitClickHandler.bind(this);
    this.vatBooksReGenerateClickHandler = this.vatBooksReGenerateClickHandler.bind(this);
    this.vatBooksRegenerateConfirmationModalCancelHandler = this.vatBooksRegenerateConfirmationModalCancelHandler.bind(this);
    this.vatBooksRegenerateConfirmationModalYesHandler= this.vatBooksRegenerateConfirmationModalYesHandler.bind(this);
    this.setUpParamsBeforePageLoad = this.setUpParamsBeforePageLoad.bind(this);
    this.onSaveToWorkflow = this.onSaveToWorkflow.bind(this);
    this.onInitiateAutoSubmission = this.onInitiateAutoSubmission.bind(this);
    this.onGoToTaskList = this.onGoToTaskList.bind(this);
    this.applyReloadPage = this.applyReloadPage.bind(this);
    this.resetFormDataOnFilingOptionChange = false;
    this.handleAutoCorrection= this.handleAutoCorrection.bind(this);

    this.formData = {
      vatReturns: undefined,
      ecListing: undefined
    };

    this.state = {
      ecTypeSalesData: [],
      ecTypePurchaseData: [],
      ecTypeCallOfStocksData: [],
      correctionsSalesData: [],
      correctionsPurchaseData: [],
      ectypeOptions: [],
      editableFilingValues: [],
      showFilingPreview: false,
      reportLanguage: "",
      selectedLanguage: "",
      drawTranslated: 0,
      currentTab: undefined,
      currentVATReturnTabIndex:-1, //TabId for VatReturnDetails screen either 'Finalise&File' or 'ViewReturnByTransaction'
      vatReturnTransactions: [],
      localListingData : [],
      reverseChargeListingData :[],
      boxValidationWarningMessage: [],
      boxValidationManualCorrection: [],
      boxValidationIsAutoCorrected: false,
      modifiedAvailableFilingLanguages:[],
      vatBooksShowRegenerate: false,
      vatBooksShowGenerate: false,
      vatBooksShowDownload: false,
      showVatBooksRegenerateConfirmationModal: false,
      returnGenerationPending: false,
      showReturnGenerationControls: false,
      returnsDocumentURL: "",
      returnsDocumentPdfPreviewURL: "",
      outputTypeSelection: "",
      reportTypeFrequencies:[],
      extension: ".xml",
      extensionPdfPreview: ".pdf",
      mimeType: "application/xml",
      mimeTypePdfPreview: "application/pdf",
      // Intrastat generation controls (enableNewIntrastatOpenReturnPage feature)
      intrastatReturnGenerationPending: false,
      intrastatShowGenerate: true,
      intrastatShowRegenerate: false,
      intrastatShowDownload: false,
      showIntrastatReturnGenerationControls: false,
      showIntrastatRegenerateConfirmationModal: false,
      showIntrastatSubmitConfirmationModal: false,  // In constructor state
      intrastatReturnsDocumentURL: "",
      intrastatReturnsDocumentPdfPreviewURL: "",
      intrastatExtension: ".xml",
      intrastatMimeType: "application/xml",
      intrastatFileName: "",
      // VAT Return generation controls (enableAsyncVatReturnOpenReturnPage feature)
      vatReturnGenerationPending: false,
      vatReturnAutoFetchFailed: false,
      vatReturnShowGenerate: true,
      vatReturnShowRegenerate: false,
      vatReturnShowDownload: false,
      showVatReturnGenerationControls: false,
      showVatReturnRegenerateConfirmationModal: false,
      showVatReturnSubmitConfirmationModal: false,
      vatReturnReturnsDocumentURL: "",
      vatReturnReturnsDocumentPdfPreviewURL: "",
      vatReturnExtension: ".xml",
      vatReturnMimeType: "application/xml",
      vatReturnFileName: "",
      isInitiatingAutoSubmission: false,
      reportAlreadySubmitted: false
    };
  }

  resetFormData() {
    this.formData = {
      vatReturns: undefined,
      ecListing: undefined
    };
  }

  prepareUserAndDatabaseFields(fieldValues={}) {
    let userFields = [];
    let databaseFields = [];
    if(arguments.length === 0) {
      fieldValues = this.props.userFormFields || {};
    }
    //Get the form field values
    for (let group in this.props.userQuestions) {
      const questions = this.props.userQuestions[group];

      const questionsAndAnswers = questions.map((question) => {
          return {
              name: question.BoxID,
              dbName: question.BoxDbID,
              value: fieldValues[question.BoxID] !== undefined ? fieldValues[question.BoxID] : question.BoxValue
            };
          });

      //Hidden questions were removed when we got the list from the server. We will now add them back in before sending the response back to the server
      if (this.props.hiddenUserQuestions[group] )
      {
          this.props.hiddenUserQuestions[group].map(d => {
            questionsAndAnswers.push({
              name: d.BoxID,
              dbName: d.BoxDbID,
              value: d.BoxValue
            })
        })
      }
      const answers = questionsAndAnswers.filter(qna => qna.value !== undefined && !qna.value.endsWith("[]") && !qna.value.startsWith('[]'));
      if (group === 'Database Fields') {
        databaseFields = databaseFields.concat(answers);
      }
      else {
        userFields = userFields.concat(answers);
      }

        log.debug('prepareUserAndDatabaseFields: databaseFields',databaseFields);
    }

    let expandedDBFields = databaseFields.reduce((expandedFieldArray, field) => {
      log.debug('field: ', field);
      const boxIds = JSON.parse(field.name);
      const fields = boxIds.map((boxId) => {
        return Object.assign({}, field, {name: boxId});
      });
      return expandedFieldArray.concat(fields);
    }, []);
    return {
      userFields: userFields,
      databaseFields: databaseFields,
      expandedDatabaseFields: expandedDBFields
    };
  }

  onFilingQuestionsSubmit (formName) {
    let userFormData = this.formData || {};
    let fieldsData = this.prepareUserAndDatabaseFields() || {};
    userFormData[formName] = {
        fieldValues: this.props.userFormFields,
        userFields: fieldsData.userFields,
        databaseFields: fieldsData.databaseFields,
        expandedDBFields: fieldsData.expandedDatabaseFields
    };
    this.formData = userFormData;
  }

  getIntrastatReportFilename() {
    const intrastatData = this.props.filing.data?.intrastat || {};
    const filingDocumentNameGenerator = FilingHelper.fileNameFactory(FilingTypeEnum.INTRASTAT);
    const intrastatForceSystemFileName = this.state.intrastatFileName && this.props.featureFlag?.[FeatureFlagEnum.USE_SYSTEM_FILENAME_FOR_DOWNLOAD_WHEN_PRESENT];
    
    return intrastatForceSystemFileName ? this.state.intrastatFileName : filingDocumentNameGenerator({
      countryCode: this.props.selectedFilingOption && this.props.selectedFilingOption.countryCode,
      startDate: intrastatData.startDate,
      endDate: intrastatData.endDate,
      documentExtension: this.state.intrastatExtension ? this.state.intrastatExtension.replace('.', '') : '',
      systemFileName: this.state.intrastatFileName,
      outputType: this.props.selectedFilingOption && this.props.selectedFilingOption.outputType,
      filingPeriodName: this.selectedFilingFrequency && this.selectedFilingFrequency.id ? ENUMS.getPeriodicityFromId(this.selectedFilingFrequency.id) : ''
    }) || 'intrastat_report';
  }

  // Builds a period-scoped filename of the form
  // `<prefix>_<countryCode>_<frequency>_<yearMonth>_<companyId>_<companyName>`.
  // Shared between VAT Books (prefix `VAB`) and zip-bundled VAT Returns (prefix `VatReturn`).
  buildPeriodScopedFilename(prefix) {
    const params = this.props.match && this.props.match.params;
    const COUNTRY = params.countryCode || '';
    const frequency = this.selectedFilingFrequency || {};
    const FREQ = frequency.languageString ? LANGUAGES_CONTROLLER.format(this.props.languages, frequency.languageString) : '';
    const YEAR_MONTH = params.startDate.substr(0, 7).replace('-', '');
    const COMPANY_ID = params.companyId || '';
    const company = (this.props.companyList && this.props.companyList.filter((e) => e.id + '' === params.companyId + '')) || [];
    const COMPANY_NAME = company.length !== 0 ? company[0].name : '';
    return `${prefix}_${COUNTRY}_${FREQ}_${YEAR_MONTH}_${COMPANY_ID}_${COMPANY_NAME}`;
  }

  getVATBookReportFilename() {
    return this.buildPeriodScopedFilename('VAB');
  }

  handleOnBoxValueChange(box, updatedValue) {
    let filingValues = this.state.editableFilingValues || {};
    let boxes = filingValues.boxes ? [...filingValues.boxes] : [];
    let matchedIndex = -1;
    boxes.every((entry, index) => {
      if(entry.boxName === box.boxName &&
        entry.boxType === box.boxType &&
        entry.returnFrequency === box.returnFrequency) {
          matchedIndex = index;
          return false;
        } else {
          return true;
        }
    });
    if(matchedIndex !== -1) {
      boxes[matchedIndex] = Object.assign({}, boxes[matchedIndex], {boxValue: Number.parseFloat(updatedValue, 10)});
      this.setState({
        editableFilingValues: Object.assign({}, this.state.editableFilingValues, {boxes: boxes})
      });
    }
  }

  filingFrequencySelectionHandler(filingFrequency) {
    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    let flowType = parsedQueryParams.flow;
    const queryParams = QueryString.parse(this.props.location.search) || {};
    let newStartDate = this.newStartDateCalculater(filingFrequency);
    this.updateUrlWithNewStartDate({ frequency: filingFrequency && filingFrequency.id }, newStartDate);
    this.selectedFilingFrequency = filingFrequency;
    this.selectedCorrectionPeriod = undefined;
    this.selectedCorrectionPeriodIndex = -1;
    this.reloadPage(filingFrequency, flowType, queryParams.simplifiedIntrastat, queryParams.returnDisplayType, true, queryParams.grouped);
  }

  onTransactionFilterChange(value) {
    const queryParams = QueryString.parse(this.props.location.search) || {};
    const filingFrequency = this.props.reportTypeFrequencies[queryParams.frequency];
    this.addSearchParameter({ returnDisplayType: value });
    if (!FILING_CORRECTIONS_CONTROLLER.isGroupedDisplayType(value)) {
      this.selectedCorrectionPeriod = undefined;
      this.selectedCorrectionPeriodIndex = -1;
    }
    this.reloadPage(filingFrequency, queryParams.flow, queryParams.simplifiedIntrastat, value, false, queryParams.grouped);
  }

  onOSSGroupingFilterChange(value) {
    const queryParams = QueryString.parse(this.props.location.search) || {};
    const filingFrequency = this.props.reportTypeFrequencies[queryParams.frequency];
    this.addSearchParameter({ grouped: value });
    this.reloadPage(filingFrequency, queryParams.flow, queryParams.simplifiedIntrastat, queryParams.returnDisplayType, false, value);
  }

  onCorrectionPeriodChange(value) {
    this.selectedCorrectionPeriodIndex = +value;
    this.selectedCorrectionPeriod = (+value !== NO_SELECTION) ? this.props.correctionPeriods[+value] : undefined;
    const queryParams = QueryString.parse(this.props.location.search) || {};
    const filingFrequency = this.props.reportTypeFrequencies[queryParams.frequency];
    this.reloadPage(filingFrequency, queryParams.flow, queryParams.simplifiedIntrastat, queryParams.returnDisplayType, false, queryParams.grouped);
  }

  addSearchParameter(parameter){
    //Reset the selected report type to the default
    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    log.debug('QueryParams: ', parameter);
    log.debug('parsedQueryParams: ', parsedQueryParams);

    const newQueryParams = Object.assign({}, parsedQueryParams, parameter);
    log.debug('newQueryParams:', newQueryParams);

    this.props.history.push({
      search: QueryString.stringify(newQueryParams, { arrayFormat: 'index' })
    });
  }

  updateUrlWithNewStartDate(parameter, newStartDate) {
    let url = '/filing/'
      + this.props.match.params.countryCode + '/'
      + this.props.match.params.companyId + '/'
      + this.props.match.params.filingTypeId + '/'
      + this.props.match.params.dueDate + '/'
      + newStartDate + '/'
      + this.props.match.params.endDate + '/'
      + this.props.match.params.filterMonth + '/'
      + this.props.match.params.filterYear;

    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    log.debug('QueryParams: ', parameter);
    log.debug('parsedQueryParams: ', parsedQueryParams);

    const newQueryParams = Object.assign({}, parsedQueryParams, parameter);
    log.debug('newQueryParams:', newQueryParams);

    this.props.history.push({
      search: QueryString.stringify(newQueryParams, { arrayFormat: 'index' }),
      pathname: url
    });
  }

  newStartDateCalculater(filingFrequency) {
    const params = this.props.match && this.props.match.params;
    let frequencyPeriod, frequencyOffset;
    let startDateToSet = params.startDate;
    let endDateToSet = params.endDate;

    if (params.filingTypeId !== FilingTypeEnum.EXTRASTAT) {
      frequencyPeriod = (filingFrequency && filingFrequency.id !== -1) ? ENUMS.getPeriodicityFromId(filingFrequency.id) : null;
      if (frequencyPeriod !== null && frequencyPeriod !== undefined) {
        frequencyOffset = ENUMS.getFrequencyOffset(frequencyPeriod);
        if (frequencyOffset !== undefined && frequencyOffset !== -1) {
          startDateToSet = moment.utc(endDateToSet, 'YYYY-MM-DD').subtract(frequencyOffset - 1, 'months').startOf('month').format('YYYY-MM-DD');
        }
      }
    }
    return startDateToSet;
  }

  reloadPage(filingFrequency, reportFlow, isSimplifiedIntrastat, returnDisplayType, isFilingFrequencyUpdated = true, grouped = "1") {
    const params = this.props.match && this.props.match.params;
    let endDateToSet = params.endDate;
    let startDateToSet = isFilingFrequencyUpdated ? this.newStartDateCalculater(filingFrequency) : params.startDate;
    const mtdLog = new Logger(MTD_SUBMIT_FILING_LOG_SCOPE, LOG_LEVELS.DEBUG);
    [ALL_MESSAGES.MTD_SUBMISSION_WARNING, ALL_MESSAGES.MTD_SUBMISSION_WARNING_WITH_ERROR]
      .forEach((messageId) => mtdLog.clearDictionaryError(messageId));
    this.props.doRemoveForm();
    this.props.onPageLoad({
      filingTypeId: params.filingTypeId,
      countryCode: params.countryCode,
      companyId: params.companyId,
      dueDate: params.dueDate,
      startDate: startDateToSet,
      endDate: endDateToSet,
      periodicity: filingFrequency && filingFrequency.id,
      returnDisplayType: returnDisplayType,
      selectedCorrectionPeriod: this.selectedCorrectionPeriod,
      simplifiedIntrastat: isSimplifiedIntrastat,
      flow: reportFlow,
      grouped: grouped
    }, this.props.featureFlag);
  }

  simplifiedIntrastatChanged(event){
    let isSimplified = event.target.checked ? "1" : "0";
    this.addSearchParameter({ simplifiedIntrastat: isSimplified });

    const queryParams = QueryString.parse(this.props.location.search) || {};
    let freq = this.props.reportTypeFrequencies[queryParams.frequency];

    this.reloadPage(freq, queryParams.flow, isSimplified, queryParams.returnDisplayType);
  }

  onGroupTypeChangeHandler(event){
        this.addSearchParameter({ grouped: event.target.value });
        const queryParams = QueryString.parse(this.props.location.search) || {};
        let freq = this.props.reportTypeFrequencies[queryParams.frequency];

        this.reloadPage(freq, queryParams.flow, queryParams.simplifiedIntrastat, queryParams.returnDisplayType, false, event.target.value);
  }

  onReportChangeHandler(payload) {
    if(!payload) {
      return;
    }
    let flowType = payload.selectedReportType || ECListingFlowPerTransactionTypesEnum.SALES+'';
    const queryParams = QueryString.parse(this.props.location.search) || {};
    let freq = this.props.reportTypeFrequencies[queryParams.frequency];
    this.addSearchParameter({flow: flowType});
    this.reloadPage(freq, flowType, queryParams.simplifiedIntrastat, queryParams.returnDisplayType, true);
  }

  onListingLineDelete(row, original, index, isSales, ecType, filingTypeId) {
    let tableData = [];
    let data = [];
     if (isSales === false && ecType == ECTypeEnums.SALES) {
        ecType = ECTypeEnums.PURCHASES;
     }
      switch (filingTypeId) {
          case FilingTypeEnum.ECLISTING :
            switch(ecType) {
              case ECTypeEnums.SALES :
              tableData = this.state.ecTypeSalesData;
              data = [...tableData];
              data.splice(index, 1);
              this.setState({ecTypeSalesData: data});
              break;

              case ECTypeEnums.CALLOFSTOCKS :
              tableData = this.state.ecTypeCallOfStocksData;
              data = [...tableData];
              data.splice(index, 1);
              this.setState({ecTypeCallOfStocksData: data});
              break;
     
              case ECTypeEnums.PURCHASES :
              tableData = this.state.ecTypePurchaseData;
              data = [...tableData];
              data.splice(index, 1);
              this.setState({ecTypePurchaseData: data});
              break;

              default : 
              break;
              
            }
          break;
          case FilingTypeEnum.LOCALLISTING :
              tableData = this.state.localListingData;
              let localListingdata = [...tableData];
              localListingdata.splice(index, 1);
              this.setState({localListingData: localListingdata});
          break;
          case FilingTypeEnum.REVERSECHARGELISTING :
              tableData = this.state.reverseChargeListingData;
              let reverseChargeListingData = [...tableData];
              reverseChargeListingData.splice(index, 1);
              this.setState({reverseChargeListingData: reverseChargeListingData});
          break;
          default:
            break;
      }
  }

  onListingLineModify(modifiedRow, index, ecType) {
    switch(ecType) {
      case ECTypeEnums.SALES:
        const salesData = [...this.state.ecTypeSalesData];
        salesData[index] = modifiedRow;  // Replacing with modified row
        this.setState({ecTypeSalesData: salesData});
        break;

      case ECTypeEnums.CALLOFSTOCKS:
        const cosData = [...this.state.ecTypeCallOfStocksData];
        cosData[index] = modifiedRow;    // Replacing with modified row
        this.setState({ecTypeCallOfStocksData: cosData});
        break;

      case ECTypeEnums.PURCHASES:
        const purchaseData = [...this.state.ecTypePurchaseData];
        purchaseData[index] = modifiedRow;  // Replacing with modified row
        this.setState({ecTypePurchaseData: purchaseData});
        break;

      default: 
        break;
    }

  }

  onVATImport(importedLines) {
    log.debug('onVATImport: Received lines', importedLines.length);
    this.setState({ ecTypeSalesData: importedLines });
  }

  onVATImportDataReplace(importedData) {
    log.debug('onVATImportDataReplace(): importedData: ', importedData);
    this.setState({ localListingData: importedData });
  }

  onListingLineDeleteCorrections(row, original, index, isSales) {
    let tableData = [];
    tableData = isSales ? this.state.correctionsSalesData : this.state.correctionsPurchaseData;
    let data = [...tableData];
    data.splice(index, 1);
    if (isSales) {
      this.setState({ correctionsSalesData: data });
    } else {
      this.setState({ correctionsPurchaseData: data });
    }
  }

  onAddLine(newLine, isSales,filingTypeId) {
    log.debug('onAddLine',newLine,filingTypeId)
    if (!newLine) {
      return;
    }
    switch (filingTypeId) {
        case FilingTypeEnum.ECLISTING :
            const newListingLine = {
                "VATNumberSupplier": newLine.vatNumber || '',
                "Value": newLine.totalAmount,
                "ECType": newLine.ectype,
                "ECTypes": newLine.ecTypes || [],
                "ListingType": newLine.listingType,
                "CorrectionType": false,
                "New": true
            };
            if (isSales) {
                this.setState({ecTypeSalesData: [...this.state.ecTypeSalesData, newListingLine]});
            } else {
                this.setState({ecTypePurchaseData: [...this.state.ecTypePurchaseData, newListingLine]});
            }
            break;
        case FilingTypeEnum.LOCALLISTING :
            const newLocalListingLine = {
                "vatNumber": newLine.vatNumber || '',
                "totalAmount": newLine.totalAmount,
                "amountVAT": newLine.amountVAT,
                "amountExclVAT": newLine.amountExclVAT,
                "listingLineType": newLine.listingLineType,
                "New": true
            };
            log.debug('onAddLine newLocalListingLine',newLocalListingLine)
            this.setState({localListingData: [...this.state.localListingData, newLocalListingLine]});
            break;
          default: break;
    }
  }

  onAddLineCorrections(newLine, isSales) {
    if (!newLine) {
      return;
    }
    const newListingLine = {
      "VATNumberSupplier": newLine.vatNumber || '',
      "Value": newLine.totalAmount,
      "ECType": newLine.ectype,
      "ECTypes": newLine.ecTypes || [],
      "ListingType": newLine.listingType,
      "CorrectionType": true,
      "New": true
    };

    if (isSales) {
      this.setState({ correctionsSalesData: [...this.state.correctionsSalesData, newListingLine] });
    } else {
      this.setState({ correctionsPurchaseData: [...this.state.correctionsPurchaseData, newListingLine] });
    }
  }

  onEcTypeChangeHandler(type) {
    return (newValue, row, original, index, isSales) => {
      let tableData = [];
      let statePropertyName = null;
      if (type === 'ectype') {
        tableData = isSales ? this.state.ecTypeSalesData : this.state.ecTypePurchaseData;
        statePropertyName = isSales ? 'ecTypeSalesData' : 'ecTypePurchaseData';
      } else if (type === 'corrections') {
        tableData = isSales ? this.state.correctionsSalesData : this.state.correctionsPurchaseData;
        statePropertyName = isSales ? 'correctionsSalesData' : 'correctionsPurchaseData';
      }
      if (tableData && statePropertyName) {
        const data = [...tableData];
        data[index]['ECType'] = newValue;
        this.setState({ statePropertyName: data });
      }
    };
  }

  getLisitngLinesData(filingTypeId){
    switch (filingTypeId)
    {
        case FilingTypeEnum.LOCALLISTING :
          return this.state.localListingData;
        case FilingTypeEnum.REVERSECHARGELISTING :
          return this.state.reverseChargeListingData;
        default:
          return ;
    }
  }

  generateFinalReportData(filingTypeId) {
      log.debug('generateFinalReportData():filingTypeId',filingTypeId);
      let finalReportingData = [];
    switch (filingTypeId)
    {
        case FilingTypeEnum.ECLISTING :
            log.debug('generateFinalReportData(): ectypes: ', this.state.ectypes);
            const ecSales = this.state.ecTypeSalesData || [];
            const ecPurchase = this.state.ecTypePurchaseData || [];
            let ectypes = ecSales.concat(ecPurchase);
            if (this.props.enableCoSGrid) {
              const ecCallOfStocks = this.state.ecTypeCallOfStocksData || [];
              ectypes = ectypes.concat(ecCallOfStocks);
            }
            let userUpdatedListingData = new Map();

            ectypes.forEach((entry) => {
                if (!entry.New) {
                    userUpdatedListingData.set(entry.Index, entry);
                } else {
                    finalReportingData.push({
                        vatNumber: ((callOfStocksType.includes(entry.ECType))  ? entry.coSvatNumber : entry.VATNumberSupplier) || '',
                        listingLineType: entry.ECType || 0,
                        amount: entry.Value || 0,
                        //its a boolean, so 0 or 1 has to do with corrections,
                        // but since we dont have that for now in saas, it would always be 0
                        isCorrectionBeforeChangeLineType: 0,
                        coSOriginalBuyerVRN: entry.coSOriginalBuyerVRN || ''
                    });
                }
            });
            const correctionSales = this.state.correctionsSalesData || [];
            const correctionPurchase = this.state.correctionsPurchaseData || [];
            const corrections = correctionSales.concat(correctionPurchase);
            log.debug('generateFinalReportData(): corrections: ', this.state.corrections);
            corrections.forEach((entry) => {
                if (!entry.New) {
                    userUpdatedListingData.set(entry.Index, entry);
                } else {
                    finalReportingData.push({
                        vatNumber: entry.VATNumberSupplier || '',
                        listingLineType: entry.ECType || 0,
                        amount: entry.Value || 0,
                        //its a boolean, so 0 or 1 has to do with corrections,
                        // but since we dont have that for now in saas, it would always be 0
                        isCorrectionBeforeChangeLineType: "0"
                    });
                }
            });

            const originalListingData = (this.props.filingValues && this.props.filingValues.lines) || [];
            originalListingData.forEach((entry, index) => {
                let userUpdatedLine = userUpdatedListingData.get(index);
                if (userUpdatedLine) {
                    let listingLineTypeAsString = Array.isArray(entry.lineTypes) ?
                        (entry.lineTypes[userUpdatedLine.ECType] && entry.lineTypes[userUpdatedLine.ECType].typeAsString) : '';
                    finalReportingData.push(Object.assign({}, entry, {
                        vatNumber:((callOfStocksType.includes(userUpdatedLine.ECType))  ? userUpdatedLine.coSvatNumber : userUpdatedLine.VATNumberSupplier) || '',
                        listingLineType: userUpdatedLine.ECType || 0,
                        listingLineTypeAsString: listingLineTypeAsString,
                        amount: userUpdatedLine.Value || 0,
                        amount2: Number.parseFloat(userUpdatedLine.Value),
                        coSOriginalBuyerVRN: userUpdatedLine.coSOriginalBuyerVRN || ''
                    }));
                }
            });

            break;
        case FilingTypeEnum.LOCALLISTING :
          //localListingData
            const localListing =  this.state.localListingData || [];
            let userUpdatedLocalListingData = new Map();

            localListing.forEach((entry) => {
                if (!entry.New) {
                    userUpdatedLocalListingData.set(entry.Index, entry);
                } else {
                    finalReportingData.push({
                        vatNumber: entry.vatNumber || '',
                        listingLineType: entry.ECType || 0,
                        totalAmount: entry.totalAmount || 0,
                        amountVAT: entry.amountVAT || 0,
                        amountExclVAT: entry.amountExclVAT || 0
                    });
                }
            });

            const originalLocalListingData = (this.props.filingValues && this.props.filingValues.lines) || [];
            originalLocalListingData.forEach((entry, index) => {
                let userUpdatedLocalLine = userUpdatedLocalListingData.get(index);
                if (userUpdatedLocalLine) {
                    finalReportingData.push(Object.assign({}, entry, {
                        vatNumber: userUpdatedLocalLine.vatNumber || '',
                        listingLineType: userUpdatedLocalLine.listingLineType || 0,
                        totalAmount: userUpdatedLocalLine.totalAmount || 0,
                        amountVAT: userUpdatedLocalLine.amountVAT || 0,
                        amountExclVAT: userUpdatedLocalLine.amountExclVAT || 0,
                    }));
                }
            });
            break;
        case FilingTypeEnum.REVERSECHARGELISTING :
          const reverseChargeListing =  this.state.reverseChargeListingData || [];
          let userUpdatedReverseChargeListingData = new Map();

          reverseChargeListing.forEach((entry) => {
                  userUpdatedReverseChargeListingData.set(entry.Index, entry);
              });

          const originalReverseChargeListingData = (this.props.filingValues && this.props.filingValues.lines) || [];
          originalReverseChargeListingData.forEach((entry, index) => {
          let userUpdatedReverseChargeLine = userUpdatedReverseChargeListingData.get(index);
            if (userUpdatedReverseChargeLine) {
                finalReportingData.push(Object.assign({}, entry, {
                  vatNumber: userUpdatedReverseChargeLine.vatNumber || '',
                  name: userUpdatedReverseChargeLine.name,
                  taxableBasis: userUpdatedReverseChargeLine.taxableBasis || 0,
                  vatReversed: userUpdatedReverseChargeLine.vatReversed || 0,
                  lineTypeAsString: userUpdatedReverseChargeLine.lineTypeAsString,
                  country:userUpdatedReverseChargeLine.country,
                  flowType:userUpdatedReverseChargeLine.flowType,
                  flowTypeDescription:userUpdatedReverseChargeLine.flowTypeDescription,
                  lineType:userUpdatedReverseChargeLine.lineType,
                  nameId:userUpdatedReverseChargeLine.nameId,
                  transactionDateMonth:userUpdatedReverseChargeLine.transactionDateMonth,
                  transactionDateYear:userUpdatedReverseChargeLine.transactionDateYear
                }));
            }
          });
          break;
          default: break;
    }

    log.debug('generateFinalReportData(): finalReportingData: ', finalReportingData);
    return finalReportingData;
  }

  closeAndSubmitVatBook() {
    const matchParams = this.props.match?.params;
    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    const freq = Number.parseInt(parsedQueryParams.frequency, 10);
    const returnDisplayType = Number.parseInt(parsedQueryParams.returnDisplayType, 10);
    const periodicity = Number.isNaN(freq) ? 1 : freq;
    const filingOption = this.props.selectedFilingOption;
    const filename = this.getVATBookReportFilename() + '.' + filingOption?.outputType.toLowerCase();

    const requestBody = {
      companyId: matchParams?.companyId,
      formName: filingOption?.formXmlId,
      approvalDate: (new Date()).toISOString(),
      savedWithFileName: filename,
      countryCode: matchParams?.countryCode,
      periodicity,
      startDate: matchParams?.startDate,
      endDate: matchParams?.endDate,
      outputType: filingOption?.outputTypeId,
      returnDisplayType: Number.isNaN(returnDisplayType) ? ReturnDisplayType.SHOW_ALL.value : returnDisplayType,
      structured: false,
      reportType: 2, // Value for 'Combined' in Rest service, enums don't match up hence not using enum value
      vatBookPeriodicity: periodicity
    };

    const closeCall = this.props.useV6CloseEndpointForVatBook
      ? this.props.onCloseReturn(this.buildCloseReturnVatBookPayload())
      : this.props.onCloseVatBook(requestBody);

    return new Promise((resolve, reject) => {
      closeCall
        .then(() => resolve(this.downloadVatBook()))
        .catch(error => {
          let message;

          if(error.status === 409) {
            // Already closed
            log.setDictionaryMessage(ALL_MESSAGES.VAT_BOOK_ALREADY_CLOSED);
            message = 'VAT Book already closed';
          } else {
            // generic error
            log.setDictionaryMessage(ALL_MESSAGES.FAILED_CLOSE_VAT_BOOK);
            message = 'Unable to close VAT Book';
          }

          return reject({ message });
        });
    });
  }

  buildCloseReturnVatBookPayload() {
    const matchParams = this.props.match?.params;
    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    const freq = Number.parseInt(parsedQueryParams.frequency, 10);
    const returnDisplayType = Number.parseInt(parsedQueryParams.returnDisplayType, 10);
    const periodicity = Number.isNaN(freq) ? 1 : freq;
    const filingOption = this.props.selectedFilingOption;
    const filename = this.getVATBookReportFilename() + '.' + filingOption?.outputType.toLowerCase();

    return {
      returnType: CloseReturnTypeEnum.VAT_BOOK,
      companyId: matchParams?.companyId,
      formName: filingOption?.formXmlId,
      countryCode: matchParams?.countryCode,
      startDate: matchParams?.startDate,
      endDate: matchParams?.endDate,
      language: this.state.selectedLanguage || '',
      periodicity,
      approvalDate: (new Date()).toISOString(),
      savedWithFileName: filename,
      vatBook: {
        outputType: filingOption?.outputTypeId,
        returnDisplayType: Number.isNaN(returnDisplayType) ? ReturnDisplayType.SHOW_ALL.value : returnDisplayType,
        structured: false,
        reportType: 2,
        vatBookPeriodicity: periodicity
      }
    };
  }

  buildCloseReturnVatReturnPayload(approvalData) {
    const matchParams = this.props.match?.params;
    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    const freq = Number.parseInt(parsedQueryParams.frequency, 10);
    const returnDisplayType = Number.parseInt(parsedQueryParams.returnDisplayType, 10);
    const periodicity = Number.isNaN(freq) ? 1 : freq;
    const filingOption = this.props.selectedFilingOption;
    const filingValues = this.props.filingValues || {};
    const sourceBoxes = (this.state.editableFilingValues && this.state.editableFilingValues.boxes)
      || filingValues.boxes
      || [];
    const boxes = sourceBoxes.map(box => ({
      boxName: box.boxName,
      boxValue: box.boxValue,
      boxType: box.boxType,
      isRealWhenZero: box.isRealWhenZero
    }));

    return {
      returnType: CloseReturnTypeEnum.VAT_RETURN,
      companyId: matchParams?.companyId,
      formName: filingOption?.formXmlId,
      countryCode: matchParams?.countryCode,
      startDate: matchParams?.startDate,
      endDate: matchParams?.endDate,
      language: this.state.selectedLanguage || '',
      periodicity,
      approvalDate: approvalData?.approvalDate || (new Date()).toISOString(),
      savedWithFileName: approvalData?.savedWithFileName,
      vatReturn: {
        correctionStartDate: filingValues.correctionStartDate && filingValues.correctionStartDate.substring(0, 10),
        correctionEndDate: filingValues.correctionEndDate && filingValues.correctionEndDate.substring(0, 10),
        isCorrection: filingValues.isCorrection,
        correctionYear: filingValues.correctionYear,
        correctionPeriod: filingValues.correctionPeriod,
        displayType: Number.isNaN(returnDisplayType) ? ReturnDisplayType.SHOW_ALL.value : returnDisplayType,
        boxes
      }
    };
  }

  buildCloseReturnIntrastatPayload(approvalData) {
    const matchParams = this.props.match?.params;
    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    const freq = Number.parseInt(parsedQueryParams.frequency, 10);
    const periodicity = Number.isNaN(freq) ? 1 : freq;
    const filingOption = this.props.selectedFilingOption || {};
    const intrastatData = this.props.filing.data?.intrastat || {};
    const isSimplifiedReport = filingOption.formXmlId?.toLowerCase().includes('simplified') ? 1 : 0;

    return {
      returnType: CloseReturnTypeEnum.INTRASTAT,
      companyId: matchParams?.companyId,
      formName: filingOption.formXmlId,
      countryCode: matchParams?.countryCode,
      startDate: matchParams?.startDate,
      endDate: matchParams?.endDate,
      language: this.state.selectedLanguage || '',
      periodicity,
      approvalDate: approvalData?.approvalDate || (new Date()).toISOString(),
      savedWithFileName: approvalData?.savedWithFileName,
      intrastat: {
        reportType: IntrastatFlowEnum.props[parsedQueryParams.flow]?.value,
        isSimplifiedReport,
        goodsLines: intrastatData.goodsLines || [],
        serviceLines: intrastatData.serviceLines || []
      }
    };
  }

  vatBooksSubmitClickHandler(isDownloadButton) {
    log.clearAllDictionaryErrors();

    const FF_ENABLE_CLOSE_VAT_BOOK = this.props.featureFlag?.EnableCloseVATBook;
    if(FF_ENABLE_CLOSE_VAT_BOOK && !isDownloadButton) {
      this.closeAndSubmitVatBook().catch(() => {});
    }

    return this.downloadVatBook();
  }

  vatBooksPdfPreviewSubmitClickHandler() {
    log.clearAllDictionaryErrors();

    return this.downloadVatBook(true);
  }

  downloadVatBook(isPdfPreview = false) {
    return new Promise((resolve, reject) => {
      let fileExtension = isPdfPreview ? this.state.extensionPdfPreview.slice(1).toLowerCase() : this.state.extension.slice(1).toLowerCase();
      const documentUrl = isPdfPreview ? this.state.returnsDocumentPdfPreviewURL : this.state.returnsDocumentURL;
      let mimeType = isPdfPreview ? this.state.mimeTypePdfPreview : this.state.mimeType;
      if (this.props.enableSiVatbookZipDownload && this.props.match?.params?.countryCode === siCountryCode) {
        fileExtension = 'zip';
        mimeType = 'application/zip';
      }
      this.props.downloadReturns(fileExtension, documentUrl, (error, data)=>{
        if(error) {
          reject(error);
          return;
        }
        const downloadData = {
              content: data || '',
              ext: fileExtension,
              mimeType: mimeType,
              charset:"utf-8",
              isBlob:true
        };
          resolve(downloadData);
      });
    });
  }

  vatBooksGenerateClickHandler(fieldValues={}) {
    log.debug("vatBooksGenerateClickHandler()");
    this.setState({
      returnGenerationPending: true
    });
    log.setDictionaryMessage(ALL_MESSAGES.VAT_BOOKS_RETURNS_GENERATION_PENDING);
    this.vatBookFetchContent(fieldValues);
  }

  vatBooksReGenerateClickHandler() {
    log.clearAllDictionaryErrors();
    log.debug("vatBooksReGenerateClickHandler()");
    this.setState({
      showVatBooksRegenerateConfirmationModal: true
    });
  }

  vatBooksRegenerateConfirmationModalYesHandler() {
    log.setDictionaryMessage(ALL_MESSAGES.VAT_BOOKS_RETURNS_GENERATION_PENDING);
    this.setState({
      vatBooksShowGenerate: true,
      vatBooksShowRegenerate: false,
      vatBooksShowDownload: false,
      showVatBooksRegenerateConfirmationModal: false,
      returnGenerationPending: false,
      showReturnGenerationControls: false
    });
    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    let frequency = parsedQueryParams && parsedQueryParams.frequency;
    let flowType = parsedQueryParams && parsedQueryParams.flow;
    //this.resetFormDataOnFilingOptionChange = true;
    const params = (this.props.match && this.props.match.params) || {};
    const filingTypeId = params.filingTypeId || -1;

    this.props.doLoadUserQuestions({
      type: filingTypeId,
      companyId: params.companyId,
      startDate: params.startDate,
      endDate: params.endDate,
      formXMLFileName: this.props.selectedFilingOption && this.props.selectedFilingOption.formXmlId,
      frequency: frequency,
      flowType: flowType,
      returnDisplayType: parsedQueryParams.returnDisplayType,
      correctionPeriod: this.selectedCorrectionPeriod
    });
  }

  vatBooksRegenerateConfirmationModalCancelHandler() {
    this.setState({
      showVatBooksRegenerateConfirmationModal: false
    });
  }

  // Intrastat generation handlers (enableNewIntrastatOpenReturnPage feature)
  intrastatGenerateClickHandler(fieldValues={}) {
    log.debug("intrastatGenerateClickHandler()");
    if (this.state.reportAlreadySubmitted) {
      log.setDictionaryMessage(ALL_MESSAGES.REPORT_ALREADY_APPROVED);
      return;
    }
    this.setState({
      intrastatReturnGenerationPending: true
    });
    this.intrastatFetchContent(fieldValues);
  }

  intrastatReGenerateClickHandler() {
    log.clearAllDictionaryErrors();
    log.debug("intrastatReGenerateClickHandler()");
    this.setState({
      showIntrastatRegenerateConfirmationModal: true
    });
  }

  intrastatRegenerateConfirmationModalYesHandler() {
    this.setState({
      intrastatShowGenerate: true,
      intrastatShowRegenerate: false,
      intrastatShowDownload: false,
      showIntrastatRegenerateConfirmationModal: false,
      intrastatReturnGenerationPending: false,
      showIntrastatReturnGenerationControls: false
    });
    // Reload user questions and start new generation (same pattern as VAT Books)
    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    let frequency = parsedQueryParams && parsedQueryParams.frequency;
    let flowType = parsedQueryParams && parsedQueryParams.flow;
    const params = (this.props.match && this.props.match.params) || {};
    const filingTypeId = params.filingTypeId || -1;

    this.props.doLoadUserQuestions({
      type: filingTypeId,
      companyId: params.companyId,
      startDate: params.startDate,
      endDate: params.endDate,
      formXMLFileName: this.props.selectedFilingOption && this.props.selectedFilingOption.formXmlId,
      frequency: frequency,
      flowType: flowType,
      returnDisplayType: parsedQueryParams.returnDisplayType,
      correctionPeriod: this.selectedCorrectionPeriod
    });
  }

  intrastatRegenerateConfirmationModalCancelHandler() {
    log.debug("intrastatRegenerateConfirmationModalCancelHandler()");
    this.setState({
      showIntrastatRegenerateConfirmationModal: false
    });
  }

  intrastatSubmitClickHandler(isDownloadButton) {
    log.debug("intrastatSubmitClickHandler()");
    if (isDownloadButton) {
      return this.downloadIntrastat();
    }
    // Show confirmation modal for "Mark As Submitted"
    this.setState({
      showIntrastatSubmitConfirmationModal: true
    });
  }

  intrastatSubmitConfirmationModalYesHandler() {
    // Mark as submitted: Use the same flow as legacy PrepareFile component
    const approvalData = {
      approvalDate: (new Date()).toISOString(),
      savedWithFileName: this.getIntrastatReportFilename() + this.state.intrastatExtension
    };
     
    // For new Intrastat flow, we need to ensure user questions are loaded before submission
    // This mimics the behavior of the legacy flow where View Filing tab loads user questions first
    
    // Load user questions first to populate database fields
    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    const params = (this.props.match && this.props.match.params) || {};
    const filingTypeId = params.filingTypeId || -1;
    let frequency = parsedQueryParams && parsedQueryParams.frequency;
    let flowType = parsedQueryParams && parsedQueryParams.flow;
    
    this.props.doLoadUserQuestions({
      type: filingTypeId,
      companyId: params.companyId,
      startDate: params.startDate,
      formXMLFileName: this.props.selectedFilingOption && this.props.selectedFilingOption.formXmlId,
      frequency: frequency,
      flowType: flowType,
      endDate: params.endDate,
      returnDisplayType: parsedQueryParams.returnDisplayType,
      correctionPeriod: this.selectedCorrectionPeriod
    }).then(async () => {
      if (this.props.enableNewIntrastatOpenReturnPage && this.props.useV6CloseEndpointForIntrastat) {
        try {
          await this.props.onCloseReturn(this.buildCloseReturnIntrastatPayload(approvalData));
        } catch (error) {
          log.debug('Intrastat CloseReturn failed:', error);
          log.setDictionaryMessage(ALL_MESSAGES.FAILED_CLOSE_INTRASTAT);
          // Keep the generation controls visible so the user can retry; only close the modal.
          this.setState({ showIntrastatSubmitConfirmationModal: false });
          return;
        }
        // ESF-664: async close succeeded — surface the same "already submitted"
        // footer message that the synchronous flow shows via the 409 response.
        this.setState({ reportAlreadySubmitted: true });
        log.setDictionaryMessage(ALL_MESSAGES.REPORT_ALREADY_APPROVED);
        // Close succeeded: trigger a file save for the already-generated Intrastat document.
        try {
          const downloadData = await this.downloadIntrastat();
          const blob = new Blob([downloadData.content], { type: downloadData.mimeType });
          saveBlobAs(blob, `${this.getIntrastatReportFilename()}.${downloadData.ext}`);
        } catch (downloadError) {
          log.debug('Intrastat download after close failed:', downloadError);
        }
      } else {
        this.onPrepareFileSubmit("intrastat", approvalData);
      }
      this.setState({
        showIntrastatReturnGenerationControls: false,
        intrastatShowGenerate: false,
        intrastatShowRegenerate: false,
        intrastatShowDownload: false,
        intrastatReturnsDocumentURL: "",
        intrastatReturnsDocumentPdfPreviewURL: "",
        showIntrastatSubmitConfirmationModal: false
      })
    }).catch((error) => { log.debug('Failed to load user questions:', error); });
  };

  intrastatSubmitConfirmationModalCancelHandler() {
    this.setState({
      showIntrastatSubmitConfirmationModal: false
    });
  }


  downloadIntrastat() {
    return new Promise((resolve, reject) => {
      let fileExtension = this.state.intrastatExtension.slice(1);
      const documentUrl = this.state.intrastatReturnsDocumentURL;
      let mimeType = this.state.intrastatMimeType;
      
      this.props.downloadReturns(fileExtension, documentUrl, (error, data)=>{
        if(error) {
          reject(error);
          return;
        }
        const downloadData = {
              content: data || '',
              ext: fileExtension,
              mimeType: mimeType,
              isBlob:true
        };
          resolve(downloadData);
      });
    });
  }

  buildIntrastatReturnDetails(fieldsData, params, parsedQueryParams, selectedFilingType, periodicity) {
    const { userFields, databaseFields } = fieldsData;
    const intrastatData = this.props.filing.data?.intrastat || {};
    const isSimplifiedIntrastat = selectedFilingType.formXmlId?.toLowerCase().includes('simplified') ? 1 : 0;
    
    return {
      returnType: 3,
      companyId: Number.parseInt(params.companyId, 10),
      countryCode: params.countryCode,
      returnDefinition: selectedFilingType.formXmlId,
      frequency: periodicity,
      periodStartDate: `${params.startDate}T00:00:00Z`,
      periodEndDate: `${params.endDate}T00:00:00Z`,
      language: this.state.selectedLanguage || "",
      reportData: {
        intrastat: {
          id: selectedFilingType.formXmlId,
          userFields,
          databaseFields,
          reportApproval: {},
          selectedLanguage: this.state.reportLanguage || "",
          drawTranslated: this.state.drawTranslated || 0,
          outputType: selectedFilingType.outputType,
          country: params.countryCode,
          reportType: IntrastatFlowEnum.props[parsedQueryParams.flow].value,
          isSimplifiedReport: isSimplifiedIntrastat,
          startDate: `${params.startDate}T00:00:00Z`,
          endDate: `${params.endDate}T00:00:00Z`,
          goodsLines: intrastatData.goodsLines || [],
          serviceLines: intrastatData.serviceLines || []
        }
      }
    };
  }

  handleIntrastatApiResponse(error) {
    if (error?.status === 409) {
      log.setDictionaryMessage(ALL_MESSAGES.INTRASTAT_RETURNS_GENERATION_PENDING);
    } else if (error) {
      log.setDictionaryMessage(ALL_MESSAGES.INTRASTAT_RETURNS_GENERATION_ERROR);
    } else {
      log.setDictionaryMessage(ALL_MESSAGES.INTRASTAT_RETURNS_GENERATION_PENDING);
    }
  }

  intrastatFetchContent(fieldValues={}) {
    log.debug('intrastatFetchContent()');
    
    const fieldsData = this.prepareUserAndDatabaseFields(fieldValues) || {};
    fieldsData.databaseFields = this.covertCreationDateToISOFormat(fieldsData.expandedDatabaseFields);
    
    const params = (this.props.match && this.props.match.params) || {};
    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    const freq = Number.parseInt(parsedQueryParams.frequency, 10);
    const periodicity = Number.isNaN(freq) ? 1 : freq;
    const selectedFilingType = this.props.selectedFilingOption || {};
    
    const returnDetails = this.buildIntrastatReturnDetails(fieldsData, params, parsedQueryParams, selectedFilingType, periodicity);
    
    log.debug('intrastatFetchContent - calling prepareReturnsForIntrastat with payload:', returnDetails);
    this.props.prepareReturnsForIntrastat(returnDetails, (error, response) => {
      this.handleIntrastatApiResponse(error);
    });
  }

  isMVRUser() {
    return Boolean(localStorage.mvrCustomerId);
  }

  isAsyncVatReturnEnabled() {
    if (!this.props.enableAsyncVatReturnOpenReturnPage) {
      return false;
    }
    if (this.isMVRUser() && !this.props.enableAsyncVatReturnsForMvrUsers) {
      return false;
    }
    const countryCode = this.props.match?.params?.countryCode;
    return !SYNCHRONOUS_ONLY_VAT_RETURN_COUNTRIES.includes(countryCode);
  }

  // VAT Return generation handlers (enableAsyncVatReturnOpenReturnPage feature)
  vatReturnGenerateClickHandler(fieldValues={}) {
    log.debug("vatReturnGenerateClickHandler()");
    if (this.state.reportAlreadySubmitted) {
      log.setDictionaryMessage(ALL_MESSAGES.REPORT_ALREADY_APPROVED);
      return;
    }
    this.setState({
      vatReturnGenerationPending: true
    });
    log.setDictionaryMessage(ALL_MESSAGES.VAT_RETURN_GENERATION_PENDING);
    this.vatReturnFetchContent(fieldValues);
    this.startVatReturnGenerationPolling();
  }

  vatReturnReGenerateClickHandler() {
    log.clearAllDictionaryErrors();
    log.debug("vatReturnReGenerateClickHandler()");
    this.setState({
      showVatReturnRegenerateConfirmationModal: true
    });
  }

  vatReturnRegenerateConfirmationModalYesHandler() {
    this.setState({
      vatReturnShowGenerate: true,
      vatReturnShowRegenerate: false,
      vatReturnShowDownload: false,
      showVatReturnRegenerateConfirmationModal: false,
      vatReturnGenerationPending: false,
      showVatReturnGenerationControls: false
    });
    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    let frequency = parsedQueryParams && parsedQueryParams.frequency;
    let flowType = parsedQueryParams && parsedQueryParams.flow;
    const params = (this.props.match && this.props.match.params) || {};
    const filingTypeId = params.filingTypeId || -1;

    this.props.doLoadUserQuestions({
      type: filingTypeId,
      companyId: params.companyId,
      startDate: params.startDate,
      endDate: params.endDate,
      formXMLFileName: this.props.selectedFilingOption && this.props.selectedFilingOption.formXmlId,
      frequency: frequency,
      flowType: flowType,
      returnDisplayType: parsedQueryParams.returnDisplayType,
      correctionPeriod: this.selectedCorrectionPeriod
    });
  }

  vatReturnRegenerateConfirmationModalCancelHandler() {
    log.debug("vatReturnRegenerateConfirmationModalCancelHandler()");
    this.setState({
      showVatReturnRegenerateConfirmationModal: false
    });
  }

  vatReturnSubmitClickHandler(isDownloadButton) {
    log.debug("vatReturnSubmitClickHandler()");
    if (isDownloadButton) {
      return this.downloadVatReturn();
    }
    this.setState({
      showVatReturnSubmitConfirmationModal: true
    });
  }

  vatReturnSubmitConfirmationModalYesHandler() {
    const approvalData = {
      approvalDate: (new Date()).toISOString(),
      savedWithFileName: this.getVatReturnReportFilename() + this.state.vatReturnExtension
    };
     
    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    const params = (this.props.match && this.props.match.params) || {};
    const filingTypeId = params.filingTypeId || -1;
    let frequency = parsedQueryParams && parsedQueryParams.frequency;
    let flowType = parsedQueryParams && parsedQueryParams.flow;
    
    this.props.doLoadUserQuestions({
      type: filingTypeId,
      companyId: params.companyId,
      startDate: params.startDate,
      formXMLFileName: this.props.selectedFilingOption && this.props.selectedFilingOption.formXmlId,
      frequency: frequency,
      flowType: flowType,
      endDate: params.endDate,
      returnDisplayType: parsedQueryParams.returnDisplayType,
      correctionPeriod: this.selectedCorrectionPeriod
    }).then(async () => {
      if (this.isAsyncVatReturnEnabled() && this.props.useV6CloseEndpointForVatReturn) {
        try {
          await this.props.onCloseReturn(this.buildCloseReturnVatReturnPayload(approvalData));
        } catch (error) {
          log.debug('VAT Return CloseReturn failed:', error);
          log.setDictionaryMessage(ALL_MESSAGES.FAILED_CLOSE_VAT_RETURN);
          // Keep the generation controls visible so the user can retry; only close the modal.
          this.setState({ showVatReturnSubmitConfirmationModal: false });
          return;
        }
        // ESF-664: async close succeeded — surface the same "already submitted"
        // footer message that the synchronous flow shows via the 409 response.
        this.setState({ reportAlreadySubmitted: true });
        log.setDictionaryMessage(ALL_MESSAGES.REPORT_ALREADY_APPROVED);
        // Close succeeded: trigger a file save for the already-generated VAT Return document.
        try {
          const downloadData = await this.downloadVatReturn();
          const blob = new Blob([downloadData.content], { type: downloadData.mimeType });
          const primaryFileName = `${this.getVatReturnReportFilename()}.${downloadData.ext}`;
          saveBlobAs(blob, primaryFileName);

          // Required only for specifc countries
          this.downloadRawFormXmlFileIfApplicable(primaryFileName);
        } catch (downloadError) {
          log.debug('VAT Return download after close failed:', downloadError);
        }
      } else {
        this.onPrepareFileSubmit("vatReturns", approvalData);
      }
      this.setState({
        showVatReturnGenerationControls: false,
        vatReturnShowGenerate: false,
        vatReturnShowRegenerate: false,
        vatReturnShowDownload: false,
        vatReturnReturnsDocumentURL: "",
        vatReturnReturnsDocumentPdfPreviewURL: "",
        showVatReturnSubmitConfirmationModal: false
      })
    }).catch((error) => { log.debug('Failed to load user questions:', error); });
  };

  vatReturnSubmitConfirmationModalCancelHandler() {
    this.setState({
      showVatReturnSubmitConfirmationModal: false
    });
  }

  downloadVatReturn() {
    return new Promise((resolve, reject) => {
      let fileExtension = this.state.vatReturnExtension.slice(1);
      const documentUrl = this.state.vatReturnReturnsDocumentURL;
      let mimeType = this.state.vatReturnMimeType;
      
      this.props.downloadReturns(fileExtension, documentUrl, (error, data)=>{
        if(error) {
          reject(error);
          return;
        }
        const downloadData = {
              content: data || '',
              ext: fileExtension,
              mimeType: mimeType,
              isBlob:true
        };
          resolve(downloadData);
      });
    });
  }

  async downloadRawFormXmlFileIfApplicable(primaryFileName) {
    const matchParams = (this.props.match && this.props.match.params) || {};
    const filingTypeId = matchParams.filingTypeId;
    const countryCode = this.props.selectedFilingOption && this.props.selectedFilingOption.countryCode;
    if (!FilingHelper.isRawformXmlSupported(filingTypeId, countryCode)) {
      return;
    }
    const returnGuid = this.extractReturnGuidFromDocumentURL(this.state.vatReturnReturnsDocumentURL);
    if (!returnGuid) {
      log.debug('downloadRawFormXmlFileIfApplicable: unable to derive guid from documentURL:', this.state.vatReturnReturnsDocumentURL);
      return;
    }
    try {
      const rawformBlob = await this.fetchRawFormXmlBlob(returnGuid);
      const updatedRawformBlob = await FilingHelper.updateRawformXmlOutputFileValue(rawformBlob, primaryFileName);
      saveBlobAs(updatedRawformBlob, `${primaryFileName}.rawformxml`);
    } catch (error) {
      log.debug('downloadRawFormXmlFileIfApplicable: rawformxml fetch/save failed:', error);
    }
  }

  extractReturnGuidFromDocumentURL(documentURL = '') {
    const match = /\/returns\/([^/?#]+)/i.exec(documentURL);
    return match ? match[1] : '';
  }

  fetchRawFormXmlBlob(guid) {
    return new Promise((resolve, reject) => {
      this.props.downloadRawFormXml(guid, (error, blob) => {
        if (error) {
          reject(error);
          return;
        }
        resolve(blob);
      });
    });
  }

  getVatReturnReportFilename() {
    // Multi-file packages (.zip) cannot use the standard VAT Return name; use the
    // period-scoped pattern shared with VAT Books so the download is meaningfully labelled.
    const isZip = (this.state.vatReturnExtension || '').replace(/^\./, '').toLowerCase() === 'zip';
    if (isZip) {
      return this.buildPeriodScopedFilename('VatReturn');
    }
    const vatReturnData = this.props.filing.data?.vatReturn || {};
    const vatReturnFilingNameGenerator = FilingHelper.fileNameFactory(FilingTypeEnum.VATRETURN);
    const vatForceSystemFileName = this.state.vatReturnFileName && this.props.featureFlag?.[FeatureFlagEnum.USE_SYSTEM_FILENAME_FOR_DOWNLOAD_WHEN_PRESENT];
    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};

    return vatForceSystemFileName ? this.state.vatReturnFileName : vatReturnFilingNameGenerator({
      countryCode: this.props.selectedFilingOption && this.props.selectedFilingOption.countryCode,
      startDate: vatReturnData.startDate,
      endDate: vatReturnData.endDate,
      systemFileName: this.state.vatReturnFileName,
      vatReturnDataCountry: vatReturnData.country,
      returnDisplayType: parsedQueryParams.returnDisplayType
    }) || '';
  }

  getVatReturnCountrySpecificButton(filename, documentUri, outputType, companyCode, formName, companyName, periodName) {
    const showMtdSubmitBtn =
      outputType === GB_FORM_NAME && GB_FILE_NAMES.some((x) => filename.includes(x));

    if (showMtdSubmitBtn) {
      const matchParams = this.props.match && this.props.match.params;
      return (
        <MTDSubmitFiling
          filename={filename}
          uri={documentUri}
          vatnumber={this.vatnumber}
          companyCode={companyCode}
          companyId={matchParams && matchParams.companyId}
          onApprove={this.vatReturnSubmitConfirmationModalYesHandler}
        />
      );
    }

    // NL VAT Return async flow: render the same Digiport submit dialog as the
    // sync flow (NLSubmitFiling) instead of the generic "Mark as submitted" button.
    const showNLSubmitBtn =
      outputType === XML_FORM_NAME && NL_VAT_FILE_NAMES.some((x) => filename.includes(x));

    if (showNLSubmitBtn) {
      const vatReturnData = this.props.filing.data?.vatReturn || {};
      const documentExtension = (this.state.vatReturnExtension || '').replace(/^\./, '')
        || (this.props.filingDocumentFileExtension || '');

      // Enabling the new Digiport Window in Async flow
      const enableNewNLDigiportWindow = this.props.featureFlag?.[FeatureFlagEnum.ENABLE_NEW_NL_DIGIPORT_WINDOW];

      return enableNewNLDigiportWindow ? (
        <NLSubmissionFilingV2
          filename={filename}
          uri={documentUri}
          vatnumber={this.vatnumber}
          fromDate={vatReturnData.startDate}
          toDate={vatReturnData.endDate}
          documentExtension={documentExtension}
          isVATFiling={true}
          onApprove={this.vatReturnSubmitConfirmationModalYesHandler}
          companyName={companyName}
          periodName={periodName}
        />
      ) : (
        <NLSubmitFiling
          filename={filename}
          uri={documentUri}
          vatnumber={this.vatnumber}
          fromDate={vatReturnData.startDate}
          toDate={vatReturnData.endDate}
          documentExtension={documentExtension}
          isVATFiling={true}
          onApprove={this.vatReturnSubmitConfirmationModalYesHandler}
        />
      );
    }

    // DE VAT Return async flow: only ERIC electronic submission gets the
    // DESubmitFiling dialog. FLSTER online-portal (XML output, user submits
    // manually through the portal) falls through to "Mark as submitted".
    const showDESubmitBtn =
      formName === DE_VAT_FORM_NAME && DE_VAT_FILE_NAMES.some((x) => filename.includes(x));

    if (showDESubmitBtn) {
      return (
        <DESubmitFiling
          filename={filename}
          uri={documentUri}
          isVATFiling={true}
          onApprove={this.vatReturnSubmitConfirmationModalYesHandler}
        />
      );
    }

    return null;
  }

  // Correction metadata for the selected return, sourced from the loaded filing values.
  // Shared by the synchronous generate payload, the async VAT Return payload and the VAT
  // Book payload so the flows cannot drift apart again.
  buildCorrectionProps() {
    const filingValues = this.props.filingValues || {};
    return {
      isCorrection: filingValues.isCorrection,
      correctionStartDate: filingValues.correctionStartDate && filingValues.correctionStartDate.substring(0, 10),
      correctionEndDate: filingValues.correctionEndDate && filingValues.correctionEndDate.substring(0, 10),
      correctionYear: filingValues.correctionYear,
      correctionPeriod: filingValues.correctionPeriod
    };
  }

  buildVatReturnDetails(fieldsData, params, parsedQueryParams, selectedFilingType, periodicity) {
    const { userFields, databaseFields } = fieldsData;
    const boxes = (this.state.editableFilingValues && this.state.editableFilingValues.boxes) || [];
    const parsedReturnDisplayType = Number.parseInt(parsedQueryParams.returnDisplayType, 10);
    const returnDisplayType = (enableCorrections && !Number.isNaN(parsedReturnDisplayType))
      ? parsedReturnDisplayType
      : ReturnDisplayType.SHOW_ALL.value;

    return {
      returnType: 0,
      companyId: Number.parseInt(params.companyId, 10),
      countryCode: params.countryCode,
      returnDefinition: selectedFilingType.formXmlId,
      frequency: periodicity,
      periodStartDate: `${params.startDate}T00:00:00Z`,
      periodEndDate: `${params.endDate}T00:00:00Z`,
      language: this.state.selectedLanguage || "",
      reportData: {
        vatReturn: {
          id: selectedFilingType.formXmlId,
          userFields,
          databaseFields,
          boxes,
          reportApproval: {},
          selectedLanguage: this.state.reportLanguage || "",
          drawTranslated: this.state.drawTranslated || 0,
          outputType: selectedFilingType.outputType,
          returnDisplayType,
          ...this.buildCorrectionProps()
        }
      }
    };
  }

  handleVatReturnApiResponse(error) {
    if (error?.status === 409) {
      log.setDictionaryMessage(ALL_MESSAGES.VAT_RETURN_GENERATION_PENDING);
    } else if (error) {
      log.setDictionaryMessage(ALL_MESSAGES.VAT_RETURN_GENERATION_ERROR);
    } else {
      log.setDictionaryMessage(ALL_MESSAGES.VAT_RETURN_GENERATION_PENDING);
    }
  }

  vatReturnFetchContent(fieldValues={}) {
    log.debug('vatReturnFetchContent()');
    
    const fieldsData = this.prepareUserAndDatabaseFields(fieldValues) || {};
    fieldsData.databaseFields = this.covertCreationDateToISOFormat(fieldsData.expandedDatabaseFields);
    
    const params = (this.props.match && this.props.match.params) || {};
    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    const freq = Number.parseInt(parsedQueryParams.frequency, 10);
    const periodicity = Number.isNaN(freq) ? 1 : freq;
    const selectedFilingType = this.props.selectedFilingOption || {};
    
    const returnDetails = this.buildVatReturnDetails(fieldsData, params, parsedQueryParams, selectedFilingType, periodicity);
    
    log.debug('vatReturnFetchContent - calling prepareReturnsForVatReturn with payload:', returnDetails);
    this.props.prepareReturnsForVatReturn(returnDetails, (error, response) => {
      this.handleVatReturnApiResponse(error);
    });
  }

  applyVatReturnClosedPeriodState(selection = this.props.selectedFilingOption) {
    const params = (this.props.match && this.props.match.params) || {};
    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    const filingTypeId = params.filingTypeId || -1;
    const frequency = parsedQueryParams && parsedQueryParams.frequency;
    const flowType = parsedQueryParams && parsedQueryParams.flow;
    const startDate = (this.props.filingValues && this.props.filingValues.startDate) || params.dueDate;
    const endDate = this.props.filingValues && this.props.filingValues.endDate;

    this.props.doLoadUserQuestions({
      type: filingTypeId,
      companyId: params.companyId,
      startDate: startDate,
      formXMLFileName: selection && selection.formXmlId,
      frequency: frequency,
      flowType: flowType,
      endDate: endDate,
      returnDisplayType: parsedQueryParams.returnDisplayType,
      correctionPeriod: this.selectedCorrectionPeriod
    });
    this.stopVatReturnGenerationPolling();
    this.setState({
      showVatReturnGenerationControls: false,
      vatReturnGenerationPending: false,
      vatReturnShowGenerate: false,
      vatReturnShowRegenerate: false,
      vatReturnShowDownload: false,
      vatReturnReturnsDocumentURL: '',
      vatReturnReturnsDocumentPdfPreviewURL: '',
      vatReturnExtension: '',
      vatReturnMimeType: '',
      vatReturnFileName: ''
    });
    log.clearDictionaryError(ALL_MESSAGES.VAT_RETURN_GENERATION_PENDING);
    log.setDictionaryMessage(ALL_MESSAGES.REPORT_ALREADY_APPROVED);
  }

  // Renders the generated VAT Return preview + controls once a return is ready.
  applyVatReturnReadyState(response, selection) {
    if (this.state.reportAlreadySubmitted) {
      this.applyVatReturnClosedPeriodState(selection);
      return;
    }
    const { location, extension, mimeType, preview, fileName } = response || {};
    this.setState({
      vatReturnShowGenerate: false,
      vatReturnShowRegenerate: true,
      vatReturnShowDownload: true,
      showVatReturnGenerationControls: true,
      vatReturnGenerationPending: false,
      vatReturnAutoFetchFailed: false,
      vatReturnReturnsDocumentURL: location,
      vatReturnReturnsDocumentPdfPreviewURL: preview ? `${vrRestApiHost}/${preview.location}` : '',
      vatReturnExtension: extension,
      vatReturnMimeType: mimeType,
      vatReturnFileName: fileName
    });
    // onOpenModal short-circuits when warningMessage is empty.
    this.onOpenModal(response && response.warningMessage, response && response.manualCorrectionBoxes, response && response.isBoxValueAutoCorrected);
    log.clearDictionaryError(ALL_MESSAGES.VAT_RETURN_GENERATION_PENDING);
    this.fetchReturnApprovalStatus();
  }

  applyIntrastatAlreadySubmittedQuestionsState(selection) {
    const params = (this.props.match && this.props.match.params) || {};
    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    const filingTypeId = params.filingTypeId || -1;
    const frequency = parsedQueryParams && parsedQueryParams.frequency;
    const flowType = parsedQueryParams && parsedQueryParams.flow;
    const startDate = (this.props.filingValues && this.props.filingValues.startDate) || params.dueDate;
    const endDate = this.props.filingValues && this.props.filingValues.endDate;

    this.props.doLoadUserQuestions({
      type: filingTypeId,
      companyId: params.companyId,
      startDate: startDate,
      formXMLFileName: selection && selection.formXmlId,
      frequency: frequency,
      flowType: flowType,
      endDate: endDate,
      returnDisplayType: parsedQueryParams.returnDisplayType,
      correctionPeriod: this.selectedCorrectionPeriod
    });
    this.setState({
      showIntrastatReturnGenerationControls: false,
      intrastatReturnGenerationPending: false,
      intrastatShowGenerate: false,
      intrastatShowRegenerate: false,
      intrastatShowDownload: false,
      intrastatReturnsDocumentURL: '',
      intrastatReturnsDocumentPdfPreviewURL: '',
      intrastatExtension: '',
      intrastatMimeType: '',
      intrastatFileName: ''
    });
    log.clearDictionaryError(ALL_MESSAGES.INTRASTAT_RETURNS_GENERATION_PENDING);
    log.setDictionaryMessage(ALL_MESSAGES.REPORT_ALREADY_APPROVED);
  }

  startVatReturnGenerationPolling() {
    if (this.vatReturnPollIntervalId > 0) {
      return;
    }
    log.debug('startVatReturnGenerationPolling()');
    log.clearDictionaryError(ALL_MESSAGES.VAT_RETURN_AUTO_FETCH_FAILED);
    this.setState({ vatReturnAutoFetchFailed: false });
    this.vatReturnPollStartedAt = Date.now();
    this.vatReturnPollErrorCount = 0;
    this.vatReturnPollIntervalId = window.setInterval(
      this.pollVatReturnGenerationOnce,
      VatReturnAsyncGeneration.POLL_INTERVAL
    );
  }

  stopVatReturnGenerationPolling() {
    if (this.vatReturnPollIntervalId > 0) {
      window.clearInterval(this.vatReturnPollIntervalId);
      this.vatReturnPollIntervalId = 0;
    }
    this.vatReturnPollStartedAt = 0;
    this.vatReturnPollErrorCount = 0;
  }

  failVatReturnGenerationPolling() {
    this.stopVatReturnGenerationPolling();
    this.setState({ vatReturnGenerationPending: false, vatReturnAutoFetchFailed: true });
    log.clearDictionaryError(ALL_MESSAGES.VAT_RETURN_GENERATION_PENDING);
    log.setDictionaryMessage(ALL_MESSAGES.VAT_RETURN_AUTO_FETCH_FAILED);
  }

  pollVatReturnGenerationOnce() {
    if (
      this.vatReturnPollStartedAt > 0 &&
      Date.now() - this.vatReturnPollStartedAt > VatReturnAsyncGeneration.MAX_POLL_DURATION
    ) {
      log.debug('pollVatReturnGenerationOnce(): max poll duration exceeded, stopping');
      this.failVatReturnGenerationPolling();
      return;
    }
    const params = this.buildReturnsParams();
    this.props.getReturns(params, (error, response) => {
      if (error) {
        if (error.notFound) {
          this.stopVatReturnGenerationPolling();
          return;
        }
        this.vatReturnPollErrorCount += 1;
        if (this.vatReturnPollErrorCount >= VatReturnAsyncGeneration.MAX_CONSECUTIVE_ERRORS) {
          log.debug('pollVatReturnGenerationOnce(): max consecutive errors reached, stopping');
          this.failVatReturnGenerationPolling();
        }
        return;
      }
      this.vatReturnPollErrorCount = 0;
      if (response && response.locationType === 'returns') {
        this.stopVatReturnGenerationPolling();
        this.applyVatReturnReadyState(response);
      }
    });
  }

  setupEditableLinesData(filingValuesLineData=[],filingTypeId) {
      log.debug('setupEditableLinesData filingTypeId',filingTypeId); 
    switch (filingTypeId)
    {
        case FilingTypeEnum.ECLISTING:
        let ectypes = [];
        let corrections = [];
        filingValuesLineData.forEach((lineEntry, index) => {
          const listingLineType = lineEntry.listingLineType;
          if (lineEntry.correctionType === 0) {
            ectypes.push({
              "VATNumberSupplier": lineEntry.vatNumber || '',
              "Value": Number(lineEntry.amount).toFixed(2),
              "ECType": listingLineType + '',
              "ECTypes": this.props.ectypeOptions,
              "CorrectionType": false,
              "ListingType": lineEntry.listingType,
              "New": false,
              "Index": index,
              "coSvatNumber": lineEntry.vatNumber || '',
              "coSname": lineEntry.name || '',
              "coSlistingTypeAsString": lineEntry.listingLineTypeAsString || '',
              "coSamount": Number(lineEntry.amount).toFixed(2),
              "coSDate": getDefaultValue(lineEntry.coSDate),
              "coSOriginalBuyerVRN": getDefaultValue(lineEntry.coSOriginalBuyerVRN),
              "coSOriginalBuyerName": getDefaultValue(lineEntry.coSOriginalBuyerName)
            });
          }
          else {
            corrections.push({
              "VATNumberSupplier": lineEntry.vatNumber || '',
              "Value": Number(lineEntry.amount).toFixed(2),
              "ECType": listingLineType + '',
              "ECTypes": this.props.ectypeOptions,
              "ListingType": lineEntry.listingType,
              "CorrectionType": true,
              "New": false,
              "Index": index
            });
          }
        });
        
        const localData = ectypes.filter(entry => salesTypes.includes(entry.ListingType));
        let ecTypeCallOfStocksData = [];
        let ecTypeSalesData = [];

        // under feature flag
        if (this.props.enableCoSGrid) {
          ecTypeCallOfStocksData =  localData.filter(entry => callOfStocksType.includes(entry.ECType));
          ecTypeSalesData =  localData.filter(entry => !callOfStocksType.includes(entry.ECType));
        } else {
          ecTypeSalesData = localData;
        }
        
        const ecTypePurchaseData = ectypes.filter(entry => purchaseTypes.includes(entry.ListingType));      
        
        const correctionsSalesData = corrections.filter(entry => salesTypes.includes(entry.ListingType));
        const correctionsPurchaseData = corrections.filter(entry => purchaseTypes.includes(entry.ListingType));

        this.setState({
          ecTypeSalesData: ecTypeSalesData,
          ecTypePurchaseData: ecTypePurchaseData,
          ecTypeCallOfStocksData: ecTypeCallOfStocksData,
          correctionsSalesData: correctionsSalesData,
          correctionsPurchaseData: correctionsPurchaseData,
          ectypeOptions: [{ label: 'Select EC type', value: '' }].concat(this.props.ectypeOptions)
        });
         break;
        case FilingTypeEnum.LOCALLISTING:
          let localListing = [];
            log.debug('setupEditableLinesData LOCALLISTING');
            filingValuesLineData.forEach((lineEntry, index) => {
                localListing.push({
                    "vatNumber": lineEntry.vatNumber || '',
                    "totalAmount": lineEntry.totalAmount,
                    "amountVAT": lineEntry.amountVAT,
                    "amountExclVAT": lineEntry.amountExclVAT,
                    "listingLineType": lineEntry.listingLineType,
                    "New": false,
                    "Index": index
                });
            });
            this.setState({
                localListingData: localListing
            });
            break;
          case FilingTypeEnum.REVERSECHARGELISTING:
            let reverseChargeListing = [];
              log.debug('setupEditableLinesData REVERSECHARGELISTING');
              filingValuesLineData.forEach((lineEntry, index) => {
                reverseChargeListing.push({
                      "vatNumber": lineEntry.vatNumber || '',
                      "name": lineEntry.name,
                      "taxableBasis": lineEntry.taxableBasis,
                      "vatReversed": lineEntry.vatReversed,
                      "lineTypeAsString": lineEntry.lineTypeAsString,
                      "New": false,
                      "country":lineEntry.country,
                      "flowType":lineEntry.flowType,
                      "flowTypeDescription":lineEntry.flowTypeDescription,
                      "lineType":lineEntry.lineType,
                      "nameId":lineEntry.nameId,
                      "transactionDateMonth":lineEntry.transactionDateMonth,
                      "transactionDateYear":lineEntry.transactionDateYear,
                      "Index": index
                  });
              });
              this.setState({
                reverseChargeListingData: reverseChargeListing
              });
              break;
              default: break;
    }
  }

  onSaveToWorkflow = (submissionType, returnTypeFlow, isFileVatBookPreviewPdf = false) => {
    function getDocIdOrName(uri) {
      if(_.isEmpty(uri)){
        return '';
      }

      var fixedUri = uri;
      if(fixedUri.endsWith("/preview")) {
        fixedUri = fixedUri.substring(0, fixedUri.length - "/preview".length);
      }

      var lastSlashInDocUri = fixedUri.lastIndexOf('/');
      const uriAfterSlash = fixedUri.slice(lastSlashInDocUri + 1, fixedUri.length);
      return uriAfterSlash;
    }

    let matchParams = this.props.match && this.props.match.params;
    let docUri;
    let vatBookId = '';
    let savedFileName = '';
    let workflowSaveFileName = null;
    let isAsyncReturn = false;

    if(matchParams.filingTypeId === 'VATBook'){
      if(isFileVatBookPreviewPdf) {
        docUri = this.state.returnsDocumentPdfPreviewURL;
        workflowSaveFileName = this.getVATBookReportFilename() + '.pdf';
      } else {
        docUri = this.state.returnsDocumentURL;
        workflowSaveFileName = this.getVATBookReportFilename() + '.xml';
      }      
      vatBookId = getDocIdOrName(docUri);
    }else{
      // Handle Intrastat new open return page flow
      if (matchParams.filingTypeId === FilingTypeEnum.INTRASTAT && this.props.enableNewIntrastatOpenReturnPage) {
        docUri = this.state.intrastatReturnsDocumentURL;
         // For Intrastat new flow, put the Operation Id into vatBookId
        vatBookId = getDocIdOrName(docUri);
        // Use the filename generation method
        const intrastatFilename = this.getIntrastatReportFilename();
        const ext = (this.state.intrastatExtension || '').replace(/^\./, '') || (this.props.filingDocumentFileExtension || '');
        workflowSaveFileName = ext ? `${intrastatFilename}.${ext}` : intrastatFilename; 
      } 
      // Handle VAT Return new async open return page flow
      else if (matchParams.filingTypeId === FilingTypeEnum.VATRETURN && this.isAsyncVatReturnEnabled() && this.state.vatReturnReturnsDocumentURL) {
        docUri = this.state.vatReturnReturnsDocumentURL;
        vatBookId = getDocIdOrName(docUri);
        const vatReturnFilename = this.getVatReturnReportFilename();
        const ext = (this.state.vatReturnExtension || '').replace(/^\./, '') || (this.props.filingDocumentFileExtension || '');
        workflowSaveFileName = ext ? `${vatReturnFilename}.${ext}` : vatReturnFilename;
        isAsyncReturn = true;
      } else {
        docUri = this.props.filingDocumentUri;
        savedFileName = getDocIdOrName(docUri);
        workflowSaveFileName = this.props.filingDocumentFileName == null ?
          savedFileName :
          `${this.props.filingDocumentFileName}.${this.props.filingDocumentFileExtension}`;
      }
    }

    if(_.isEmpty(docUri)){
      log.debug('Failed to save to workflow. No doc Uri for ', matchParams.filingTypeId);
      log.setDictionaryMessage(ALL_MESSAGES.FAILED_TO_SAVE_TO_WORKFLOW);
      return;
    }

    const filingPeriodName = this.selectedFilingFrequency && this.selectedFilingFrequency.id ? ENUMS.getPeriodicityFromId(this.selectedFilingFrequency.id) : '';

    const workflowParams = {
      companyId: matchParams.companyId,
      countryCode: matchParams.countryCode,
      startDate: matchParams.startDate,
      endDate: matchParams.endDate,
      frequency: filingPeriodName,
      returnType: matchParams.filingTypeId,
      returnTypeFlow: returnTypeFlow ?? matchParams.filingTypeFlow,
      isCorrective: submissionType !== 'regular',
      fileName: savedFileName,
      workflowSaveFileName: workflowSaveFileName,
      vatBookId: vatBookId,
      isAsyncReturn: isAsyncReturn
    };

    log.clearDictionaryError(ALL_MESSAGES.FAILED_TO_SAVE_TO_WORKFLOW);
    log.clearSuccessMessage(ALL_MESSAGES.SAVED_TO_WORKFLOW);

    const workflowCallback = (error, response) => {
      if (error) {
        log.debug('Failed to save to workflow with the following parameters and error:', workflowParams, error);
        log.clearAllDictionaryErrors();
        log.clearDictionaryError(ALL_MESSAGES.CONNECTION_ERROR);
        log.setDictionaryMessage(ALL_MESSAGES.FAILED_TO_SAVE_TO_WORKFLOW);
      } else {
        log.debug('Success saving to workflow)', response);
        log.setDictionaryMessage(ALL_MESSAGES.SAVED_TO_WORKFLOW);
      }
    };

    this.props.doSaveToWorkflow(workflowParams, workflowCallback);
  };

  buildAutoSubmissionParams = () => {
    const matchParams = this.props.match && this.props.match.params;
    const parsedQueryParams = QueryString.parse(this.props.location?.search) || {};
    const filingPeriodName = this.selectedFilingFrequency && this.selectedFilingFrequency.id ? ENUMS.getPeriodicityFromId(this.selectedFilingFrequency.id) : '';

    const company = this.props.companyList.find((c) => c.id == matchParams.companyId) || {};
    const companyName = company.name || '';

    let docUri = '';
    let filename = '';
    let extension = '';

    if (matchParams.filingTypeId === FilingTypeEnum.VATRETURN && this.isAsyncVatReturnEnabled()) {
      docUri = this.state.vatReturnReturnsDocumentURL;
      filename = this.getVatReturnReportFilename();
      extension = (this.state.vatReturnExtension || '').replace(/^\./, '') || (this.props.filingDocumentFileExtension || '');
    }

    let systemFileName = '';
    try {
      systemFileName = new URL(docUri).pathname.split("/").at(-1) || "";
    } catch (e) {
      systemFileName = '';
    }

    const workflowFileName = this.props.filingDocumentFileName
      ? `${this.props.filingDocumentFileName}.${extension}`
      : `${filename}.${extension}`;

    const correctionPeriod = this.selectedCorrectionPeriod
      ? (() => {
          const year = this.selectedCorrectionPeriod.year || this.selectedCorrectionPeriod.correctionYear;
          const period = this.selectedCorrectionPeriod.period || this.selectedCorrectionPeriod.correctionPeriod;
          return (year && period) ? `${year}-${period}` : null;
        })()
      : null;

    return {
      companyId: matchParams.companyId,
      companyName: companyName,
      companyCode: company.code || '',
      countryCode: matchParams.countryCode,
      startDate: matchParams.startDate,
      endDate: matchParams.endDate,
      frequency: filingPeriodName,
      returnType: ENUMS.getFilingNameForUrlFromFilingTypeId(matchParams.filingTypeId),
      returnTypeFlow: matchParams.filingTypeFlow || 'Standard',
      userName: this.props.userName || 'Unknown',
      transactionFilter: parsedQueryParams.returnDisplayType || '0',
      correctionPeriod: correctionPeriod,
      formXmlId: this.props.selectedFilingOption && this.props.selectedFilingOption.formXmlId,
      fileName: systemFileName,
      workflowFileName: workflowFileName
    };
  };

  onInitiateAutoSubmission = () => {
    log.debug('onInitiateAutoSubmission() called');
    const autoSubmissionParams = this.buildAutoSubmissionParams();
    log.debug('onInitiateAutoSubmission() - Initiating job with params:', autoSubmissionParams);

    // Disable the button immediately so a user can't fire it twice while the
    // request is in flight; workflowInProgress takes over once it succeeds.
    this.setState({ isInitiatingAutoSubmission: true });
    this.props.doInitiateAutoSubmission(autoSubmissionParams, (error) => {
      if (error) {
        this.setState({ isInitiatingAutoSubmission: false });
      }
    });
  };

  getCanInitiateAutoSubmission = (urlParams) => {
    const hasPermission = canInitiateDirectSubmissionGated(
      this.props.featureFlag?.[FeatureFlagEnum.ENABLE_USER_MANAGEMENT_TILES],
      this.props.directSubmission, urlParams.companyId, urlParams.countryCode
    );
    return hasPermission && !this.props.workflowInProgress && !this.state.isInitiatingAutoSubmission;
  };

  getInitiateAutoSubmissionDisabledTooltip = (urlParams) => {
    const hasPermission = canInitiateDirectSubmissionGated(
      this.props.featureFlag?.[FeatureFlagEnum.ENABLE_USER_MANAGEMENT_TILES],
      this.props.directSubmission, urlParams.companyId, urlParams.countryCode
    );
    if (!hasPermission) {
      return LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_InitiateDirectSubmissionNoPermission');
    }
    return LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_InitiateDirectSubmissionInProgress');
  };

  // Regenerate and Mark as Submitted stay usable whenever direct submission isn't
  // applicable to this return type/country. When it is, they disable the same
  // way Send for Approval does: immediately while the initiate request is in
  // flight, then for as long as a workflow is already in progress.
  isDirectSubmissionInProgress = () =>
    this.props.workflowInProgress || this.state.isInitiatingAutoSubmission;

  getCanRegenerate = (urlParams) => {
    if (!isAutoSubmissionEnabled(urlParams.filingTypeId, urlParams.countryCode, this.props.entitlements, this.props.featureFlag)) {
      return true;
    }
    return !this.isDirectSubmissionInProgress();
  };

  getRegenerateDisabledTooltip = () =>
    LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_RegenerateInProgress');

  // ESF-978: shared with FilingPreview's sync flow via FilingHelper.isGbPdfVatReturn
  // so the async and sync Mark as Submitted modals cannot drift apart again.
  // returnApprovals and isReturnApprovalApplicable come from ESF-1052; the status is checked first so the gate is only consulted once a status is in Redux.
  getVatReturnRegenerateMessageKey = (urlParams) =>
    doesRegenerateVoidApproval(this.props.returnApprovals) && this.isReturnApprovalApplicable(urlParams)
      ? VAT_RETURN_REGENERATE_VOIDS_APPROVAL_MESSAGE_KEY
      : VAT_RETURN_REGENERATE_MESSAGE_KEY;

  isGbPdfVatReturn = (urlParams) =>
    FilingHelper.isGbPdfVatReturn(urlParams?.filingTypeId, urlParams?.countryCode, this.props.selectedFilingOption?.outputType);

  // ESF-1052: approval gate for in-scope VAT returns only; null means "behave as today".
  isReturnApprovalApplicable = (urlParams = {}) => isReturnApprovalInScope({
    enableReturnApprovalWorkflow: this.props.enableReturnApprovalWorkflow,
    isAsyncVatReturn: this.isAsyncVatReturnEnabled(),
    useV6CloseEndpointForVatReturn: this.props.useV6CloseEndpointForVatReturn,
    filingTypeId: urlParams.filingTypeId,
    countryCode: urlParams.countryCode
  });

  getReturnApprovalGate = (urlParams) =>
    (this.isReturnApprovalApplicable(urlParams) ? getApprovalGate(this.props.returnApprovals) : null);

  // Same numeric returnType/periodicity mapping as buildCloseReturnVatReturnPayload.
  buildReturnApprovalParams = () => {
    const { companyId, countryCode, startDate, endDate } = this.props.match?.params || {};
    const freq = Number.parseInt((QueryString.parse(this.props.location.search) || {}).frequency, 10);
    return { companyId, countryCode, returnType: CloseReturnTypeEnum.VAT_RETURN, startDate, endDate, periodicity: Number.isNaN(freq) ? 1 : freq };
  };

  // Called when a generation is ready, so a Send from an earlier generation no longer blocks a new request.
  fetchReturnApprovalStatus = () => {
    const urlParams = this.props.match?.params || {};
    if (this.props.doGetReturnApprovalStatus && this.isReturnApprovalApplicable(urlParams)) {
      this.props.doResetReturnApprovals();
      this.props.doGetReturnApprovalStatus(this.buildReturnApprovalParams());
    }
  };

  onSendForApproval = () => this.props.doSendReturnForApproval(this.buildReturnApprovalParams());

  onGoToReturnApprovals = () => {
    window.location.href = `${getClientConfig().complianceCalendarUrl}/return-approvals`;
  };

  getCanMarkAsSubmitted = (urlParams) => {
    const approvalGate = this.getReturnApprovalGate(urlParams);
    if (approvalGate && !approvalGate.canMarkAsSubmitted) {
      return false;
    }
    if (!isAutoSubmissionEnabled(urlParams.filingTypeId, urlParams.countryCode, this.props.entitlements, this.props.featureFlag)) {
      return true;
    }
    return !this.isDirectSubmissionInProgress();
  };

  getMarkAsSubmittedDisabledTooltip = (urlParams) => {
    const approvalGate = this.getReturnApprovalGate(urlParams);
    const key = approvalGate && !approvalGate.canMarkAsSubmitted
      ? approvalGate.markAsSubmittedTooltipKey
      : 'filingPage_MarkAsSubmittedInProgress';
    return LANGUAGES_CONTROLLER.format(this.props.languages, key);
  };

  checkAutoSubmissionWorkflowInProgress = (urlParams) => {
    if (!this.props.doCheckWorkflowInProgress) return;

    const isEnabled = isAutoSubmissionEnabled(
      urlParams?.filingTypeId,
      urlParams?.countryCode,
      this.props.entitlements,
      this.props.featureFlag
    );
    if (!isEnabled) return;

    // Only the filter fields matter for this check, unlike buildAutoSubmissionParams()
    // which also derives file-name details from the generated document for the initiate call.
    const filingPeriodName = this.selectedFilingFrequency && this.selectedFilingFrequency.id
      ? ENUMS.getPeriodicityFromId(this.selectedFilingFrequency.id)
      : '';
    const params = {
      companyId: urlParams?.companyId,
      countryCode: urlParams?.countryCode,
      startDate: urlParams?.startDate,
      endDate: urlParams?.endDate,
      frequency: filingPeriodName,
      returnType: ENUMS.getFilingNameForUrlFromFilingTypeId(urlParams?.filingTypeId)
    };
    log.debug('checkAutoSubmissionWorkflowInProgress() - Checking with params:', params);
    this.props.doCheckWorkflowInProgress(params);
  };

  onGoToTaskList = () => {
    log.debug('onGoToTaskList() called');
    const complianceCalendarUrl = getClientConfig().complianceCalendarUrl;

    const url = `${complianceCalendarUrl}/direct-submission`;
    log.debug('onGoToTaskList() - Navigating to:', url);

    window.location.href = url;
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
        // setUpParamsBeforePageLoad() below is what sets this.selectedFilingFrequency and then runs
        // the same check itself, so when frequencies change in this pass we leave the call to it.
        const reportTypeFrequenciesChanged =
            this.props.reportTypeFrequencies && this.props.reportTypeFrequencies !== prevProps.reportTypeFrequencies;

        if (!prevProps.entitlements?.loaded && this.props.entitlements?.loaded
            && this.props.reportTypeFrequencies && !reportTypeFrequenciesChanged) {
            this.checkAutoSubmissionWorkflowInProgress((this.props.match && this.props.match.params) || {});
        }

        if (this.resetFormDataOnFilingOptionChange){
          this.resetFormData();
          this.resetFormDataOnFilingOptionChange =false;
        }

        // When the user switches filing option, clear the materialised-document state
        const prevOption = prevProps.selectedFilingOption || {};
        const currOption = this.props.selectedFilingOption || {};
        const filingOptionChanged =
            prevOption.outputType !== currOption.outputType ||
            prevOption.formXmlId !== currOption.formXmlId;
        if (filingOptionChanged) {
            this.stopVatReturnGenerationPolling();
            log.clearDictionaryError(ALL_MESSAGES.VAT_RETURN_AUTO_FETCH_FAILED);
            this.setState({
                // VAT Books
                showReturnGenerationControls: false,
                returnGenerationPending: false,
                vatBooksShowGenerate: true,
                vatBooksShowRegenerate: false,
                vatBooksShowDownload: false,
                returnsDocumentURL: "",
                returnsDocumentPdfPreviewURL: "",
                extension: "",
                extensionPdfPreview: "",
                mimeType: "",
                mimeTypePdfPreview: "",
                // Intrastat
                showIntrastatReturnGenerationControls: false,
                intrastatReturnGenerationPending: false,
                intrastatShowGenerate: !this.state.reportAlreadySubmitted,
                intrastatShowRegenerate: false,
                intrastatShowDownload: false,
                intrastatReturnsDocumentURL: "",
                intrastatReturnsDocumentPdfPreviewURL: "",
                intrastatExtension: "",
                intrastatMimeType: "",
                intrastatFileName: "",
                // VAT Return (async)
                showVatReturnGenerationControls: false,
                vatReturnGenerationPending: false,
                vatReturnAutoFetchFailed: false,
                vatReturnShowGenerate: !this.state.reportAlreadySubmitted,
                vatReturnShowRegenerate: false,
                vatReturnShowDownload: false,
                vatReturnReturnsDocumentURL: "",
                vatReturnReturnsDocumentPdfPreviewURL: "",
                vatReturnExtension: "",
                vatReturnMimeType: "",
                vatReturnFileName: ""
            });
        }

        if (this.props.filingValues !== prevProps.filingValues) {
            this.resetFormData();
            let editableFilingValues =_.cloneDeep(this.props.filingValues);
            this.setState({
                editableFilingValues: editableFilingValues
            });
            let filingValuesLineData = editableFilingValues && editableFilingValues.lines;
            log.debug('In componentDidUpdate filingValuesLineData',filingValuesLineData);
            log.debug('In componentDidUpdate filingValuesLineData',this.props.selectedFilingOption);

            if(!Array.isArray(filingValuesLineData) || filingValuesLineData.length === 0) {
                this.setState( {
                    ecTypeSalesData: [],
                    ecTypePurchaseData: [],
                    correctionsSalesData: [],
                    correctionsPurchaseData: [],
                    ectypeOptions: [{ label: 'Select EC type', value: '' }].concat(this.props.ectypeOptions),
                    localListingData : [],
                    reverseChargeListingData :[]
                });
                return;
            }
            let filingTypeId =this.props.selectedFilingOption && this.props.selectedFilingOption.filingTypeId;
            this.setupEditableLinesData(filingValuesLineData,filingTypeId);
        }
        //deeplinking changes to reload page once we have reportTypeFrequency #SVR-10376
        if (reportTypeFrequenciesChanged) {
         this.setUpParamsBeforePageLoad();
        }
  }

  handleAfterTabSelected(selectedIndex, selectedPanel, selectedTabMenu, selectedFilingOption, prevTabIndex, selectedTabId) {
    this.resetFormDataOnFilingOptionChange = false;
    const filingTypeId = selectedFilingOption && selectedFilingOption.filingTypeId;
    this.setState({currentTab: selectedTabId});
    switch(filingTypeId) {
      case FilingTypeEnum.VATRETURN:
        if( selectedIndex === 2) {
          this.onPrepareFileSubmit("vatReturns", {});
        }
        break;
      case FilingTypeEnum.ECLISTING:
        //If user clicked on View Filing for EC Listing
        if( selectedIndex === 3) {
          this.onPrepareFileSubmit("ecListing", {});
        }
        break;
      case FilingTypeEnum.INTRASTAT:
          log.debug('In handleAfterTabSelected Intrastat',selectedIndex);
          if( selectedIndex === 2) {
            this.onPrepareFileSubmit("intrastat", {});
          }
          break;
      case FilingTypeEnum.OSSIMPORT:
      case FilingTypeEnum.OSSUNION:
      case FilingTypeEnum.OSSNONUNION:
            log.debug('In handleAfterTabSelected OSS',selectedIndex);
          if( selectedIndex === 2) {
              this.onPrepareFileSubmit("oss", {});
          }
          break;
      case FilingTypeEnum.LOCALLISTING:
        log.debug('In handleAfterTabSelected LOCALLISTING',selectedIndex);
          //If user clicked on View Filing for Local Listing
          if( selectedIndex === 3) {
          this.onPrepareFileSubmit("localListing", {});
          }
          break;
      case FilingTypeEnum.EXTRASTAT:
          log.debug('In handleAfterTabSelected Extrastat',selectedIndex);
          if( selectedIndex === 2) {
            this.onPrepareFileSubmit("extrastat", {});
          }
          break;
      case FilingTypeEnum.REVERSECHARGELISTING:
            log.debug('In handleAfterTabSelected Reverse charge listing',selectedIndex);
            if( selectedIndex === 3) {
              this.onPrepareFileSubmit("reverseChargeListing", {});
            }
            break;
      default:
    }
  }

  //on tab change for VAT Return Details screen either 'Finalise&File' or 'ViewReturnByTransaction'
  onVATReturnTabHandler(selectedIndex, selectedPanel, selectedTabMenu) {
    log.debug('onVATReturnTabHandler: ' + selectedIndex);
    this.setState({currentVATReturnTabIndex:selectedTabMenu});
    const queryParams = QueryString.parse(this.props.location.search) || {};
    const returnDisplayType = queryParams.returnDisplayType;
    if (selectedTabMenu === VATReturnDetailsTabs.VIEW_RETURN_BY_TRANSACTION.value && FILING_CORRECTIONS_CONTROLLER.isGroupedDisplayType(returnDisplayType)) {
      this.onTransactionFilterChange(ReturnDisplayType.SHOW_ALL.value);
    }
  }

  vatBookFetchContent(fieldValues={}) {
    const FF_ENABLE_VATBOOK_CORRECTION_FILTERS = this.props.featureFlag?.EnableCorrectionFiltersVATBook;
      log.debug('vatBookFetchContent()');
      let fieldsData = this.prepareUserAndDatabaseFields(fieldValues) || {};
      let userFields = fieldsData.userFields;
      let databaseFields = this.covertCreationDateToISOFormat(fieldsData.expandedDatabaseFields);
      const params = (this.props.match && this.props.match.params) || {};
      const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
      const freq = Number.parseInt(parsedQueryParams.frequency, 10);
      const periodicity = Number.isNaN(freq) ? 1: (freq);
      const returnDisplayType = Number.parseInt(parsedQueryParams.returnDisplayType, 10) || 0;
      const correctionProps = {};
      if (FF_ENABLE_VATBOOK_CORRECTION_FILTERS) {
        Object.assign(correctionProps, this.buildCorrectionProps());
      }

      let selectedFilingType = this.props.selectedFilingOption || {};
      // Top-level `language` is the GET /api/returns identity (same as async VAT Return
      // and Intrastat). `reportData.vatBook.selectedLanguage` remains the render language.
      let returnDetails = {
          returnType : FilingTypeEnum.VATBOOKS,
        countryCode: params.countryCode,
        companyId: Number.parseInt(params.companyId, 10),
        periodStartDate: params.startDate,
        periodEndDate: params.endDate,
        frequency: ENUMS.getPeriodicityFromId(periodicity),
        returnDefinition: selectedFilingType.formXmlId,
        language: this.state.selectedLanguage || "",
        reportData: {
          vatBook: {
            id: selectedFilingType.filingTypeId,
            userFields: userFields,
            databaseFields: databaseFields,
            reportApproval: {
              //approvalDate: "2021-03-11T12:12:41.439Z",
              //savedWithFileName: "string"
            },
            selectedLanguage: this.state.reportLanguage,
            drawTranslated: this.state.drawTranslated,
            outputType: selectedFilingType.outputTypeId,
            declarationFileName: selectedFilingType.formXmlId,
            periodicity: periodicity,
            vatBookPeriodicity: periodicity, //TODO: To be confirmed
            returnDisplayType: returnDisplayType,
            //"structured": true, //TODO: This may not ne need check
            reportType:VATBookFlowEnum.props[parsedQueryParams.flow].value,
            ...correctionProps
          }
        }
      };
      this.props.prepareReturns(returnDetails);
  }

  onPrepareFileSubmit(formName, approvalData) {
    let fieldsData = this.prepareUserAndDatabaseFields() || {};
    this.formData[formName] =   {
        fieldValues: {},
        userFields: fieldsData.userFields,
        databaseFields: fieldsData.databaseFields,
        expandedDBFields: fieldsData.expandedDatabaseFields
    };
    this.doUserQuestionsAnswered(fieldsData.userFields, fieldsData.expandedDatabaseFields, approvalData);
  }

  componentWillUnmount() {
    log.clearAllDictionaryErrors();
    this.props.doRemoveForm();
    this.props.doResetReturnApprovals?.();
    this.stopVatReturnGenerationPolling();
  }

  //set up filingFrequency, flow before page load
  setUpParamsBeforePageLoad(){
    log.debug('setUpParamsBeforePageLoad()');
    //Reset the selected report type to the default
    const queryParams = QueryString.parse(this.props.location.search) || {};
    var filingFrequency =this.props.reportTypeFrequencies[queryParams.frequency];
    log.debug('setUpParamsBeforePageLoad: filingFrequency ', filingFrequency);
    this.addSearchParameter({ frequency: filingFrequency && filingFrequency.id });
    this.selectedFilingFrequency = filingFrequency;
    this.vatnumber = queryParams.vatnumber;
    log.debug('queryParams ',queryParams);
    const urlParams = (this.props.match && this.props.match.params) || {};
    //set flow to initial value if not provided
    let flow = queryParams.flow;
    
    // Define default flow mappings to reduce duplication
    const defaultFlowMappings = {
      [FilingTypeEnum.ECLISTING]: ECListingFlowPerTransactionTypesEnum.SALES,
      [FilingTypeEnum.ECLISTINGCORRECTION]: ECListingFlowPerTransactionTypesEnum.SALES,
      [FilingTypeEnum.EXTRASTAT]: ExtrastatFlowEnum.SALES,
      [FilingTypeEnum.VATBOOKS]: VATBookFlowEnum.SALES,
      [FilingTypeEnum.LOCALLISTING]: LocalListingFlowEnum.SALES,
      [FilingTypeEnum.REVERSECHARGELISTING]: LocalListingFlowEnum.SALES
    };

    if (!flow && urlParams?.filingTypeId && defaultFlowMappings[urlParams.filingTypeId]) {
      flow = defaultFlowMappings[urlParams.filingTypeId];
      this.addSearchParameter({flow: flow});
    }

    // Handle French Intrastat specific returnDisplayType
    if (urlParams?.filingTypeId === FilingTypeEnum.INTRASTAT && urlParams?.countryCode === "FR") {
      const returnDisplayTypeValue = ReturnDisplayType.ONLY_NON_CORRECTIONS.value;
      this.addSearchParameter({ returnDisplayType: returnDisplayTypeValue });
      queryParams.returnDisplayType = returnDisplayTypeValue;
    }

    this.props.getCanUserSaveToWorkflow();
    this.checkAutoSubmissionWorkflowInProgress(urlParams);
    this.applyReloadPage(filingFrequency, flow, urlParams, queryParams);
  }
    applyReloadPage(filingFrequency, flow, urlParams, queryParams) {
        if(getOssReturnTypes().includes(urlParams.filingTypeId)) {
          this.reloadPage(filingFrequency, flow, queryParams.simplifiedIntrastat, queryParams.returnDisplayType, false, queryParams.grouped);
      } else {
          this.reloadPage(filingFrequency, flow, queryParams.simplifiedIntrastat, queryParams.returnDisplayType, false);
      }
    }

    componentDidMount() {
      //If reportTypeFrequencies are not available then skip reload--changes for deeplinking of URL #SVR-10376
      if(this.props.reportTypeFrequencies){
        this.setUpParamsBeforePageLoad();
      }
      // ESF-664: On page load / refresh, replicate the synchronous
      // "already submitted" footer message for the async close flows by
      // querying the GET history endpoint for the current period.
      this.maybeShowReportAlreadySubmitted();
  }

  maybeShowReportAlreadySubmitted() {
    const params = (this.props.match && this.props.match.params) || {};
    const filingTypeId = params.filingTypeId;
    const isAsyncVatReturn =
      filingTypeId === FilingTypeEnum.VATRETURN
      && this.isAsyncVatReturnEnabled()
      && this.props.useV6CloseEndpointForVatReturn;
    const isAsyncIntrastat =
      filingTypeId === FilingTypeEnum.INTRASTAT
      && this.props.enableNewIntrastatOpenReturnPage
      && this.props.useV6CloseEndpointForIntrastat;
    if (!isAsyncVatReturn && !isAsyncIntrastat) {
      return;
    }
    if (!params.companyId || !params.startDate || !params.endDate || !params.countryCode) {
      return;
    }
    this.props.checkReportAlreadySubmitted({
      filingType: filingTypeId,
      companyId: params.companyId,
      countryCode: params.countryCode,
      startDate: params.startDate,
      endDate: params.endDate
    }).then((alreadySubmitted) => {
      if (alreadySubmitted) {
        this.setState({ reportAlreadySubmitted: true });
        log.setDictionaryMessage(ALL_MESSAGES.REPORT_ALREADY_APPROVED);
        // Cover View Filing, Generate-on-404, and pending — not only show*GenerationControls.
        if (
          this.state.showVatReturnGenerationControls
          || this.state.vatReturnShowGenerate
          || this.state.vatReturnGenerationPending
        ) {
          this.applyVatReturnClosedPeriodState(this.props.selectedFilingOption);
        }
        if (
          this.state.showIntrastatReturnGenerationControls
          || this.state.intrastatShowGenerate
          || this.state.intrastatReturnGenerationPending
        ) {
          this.applyIntrastatAlreadySubmittedQuestionsState(this.props.selectedFilingOption);
        }
      }
    });
  }

  render() {
    log.debug('render(): ', this.props);

    const urlParams = (this.props.match && this.props.match.params) || {};
    log.debug('render(): URL params: ', urlParams,this.vatnumber);

    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    log.debug('render() parsedQueryParams: ', parsedQueryParams);

    const filingValues = this.props.filingValues;
    const filingValueDetail = this.props.filingValueDetail;
    const userQuestions = this.props.userQuestions;
    const answers = this.props.answers;
    const company = this.props.companyList.find((company) => {
      return company.id == urlParams.companyId;
    }) || {};

    const companyName = company.name || 'Unknown companyId: ' + urlParams.companyId;
    const companyCode = company.code || undefined;

    let reportName = ENUMS.getFilingNameFromFilingType(urlParams.filingTypeId);
    if (urlParams.filingTypeId === FilingTypeEnum.INTRASTAT)
    {
      reportName = reportName + ' ' + ENUMS.getIntrastatFlowNameFromFlowType(parsedQueryParams.flow);
    }

    // We now get the filing options which have not been filtered by frequency
    const filingOptionsForAllPeriods = (this.props.filingOptions && this.props.filingOptions.data) || [];
    let fileName='';
    if (urlParams.filingTypeId === FilingTypeEnum.OSSIMPORT || urlParams.filingTypeId === FilingTypeEnum.OSSUNION ||
        urlParams.filingTypeId === FilingTypeEnum.OSSNONUNION) {
        const dataTemp = this.props.filing && this.props.filing.data && this.props.filing.data.ossData;
        if(dataTemp)
            fileName = `${ENUMS.getFilingNameFromFilingType(urlParams.filingTypeId)} ${ dataTemp.country} (${moment( dataTemp.startDate).format("YYYY-MM-DD")}_${moment( dataTemp.endDate).format("YYYY-MM-DD")})`;
    }

    let availablePeriods = [];
    let periodicityOptions = this.props.content.reportsPeriodicityOptions;
    if ((urlParams.filingTypeId === FilingTypeEnum.VATRETURN) && periodicityOptions && periodicityOptions.vatReturn)
    {
        availablePeriods = this.props.content.reportsPeriodicityOptions.vatReturn[urlParams.countryCode] || [];
    }

    // And then we filter by frequency after we have determined the availablePeriods
    const formXmlFrequency = ENUMS.ReportPeriodicityToFormXmlPeriodicity(Number.parseInt(parsedQueryParams.frequency || '0', 10));

    // Logic to select the "Reporter Type" for holding companies in VAT groups.
    // This is currently specific to Spanish companies, hence references to
    // `reporter.vatGroupTypeEs`/`reporter.vatGroupTypeEsGc`
    const selectHoldingReporterType = (reporter) => {
      let result = 0;

      const NONE = 0;
      const DOMINANT = 1;
      const DEPENDENT = 2;
      const HOLDING = 3;

      // Check if the company's country is within the holding company countries (currently ES + ESGC)
      const isHoldingCountry = holdingCompanyCountries.includes(
        reporter.country
      );

      const isVatReturn = urlParams.filingTypeId === FilingTypeEnum.VATRETURN;

      // Check if the company is of any VAT Group (not NONE)
      const isVatGroupType =
        reporter.vatGroupTypeEs !== NONE || reporter.vatGroupTypeEsGc !== NONE;

      // Check if the company's VAT Group type is "holding" and that it operates in a VAT Group
      const isHoldingAndOperatesInVatGroup = (reporter.vatGroupTypeEs === HOLDING || reporter.vatGroupTypeEsGc === HOLDING) && reporter.operatesInVatGroup;

      // Check if the company's VAT Group type is "dominant" or "dependent"
      const isDominantOrDependent = [DOMINANT, DEPENDENT].includes(reporter.vatGroupTypeEs) || [DOMINANT, DEPENDENT].includes(reporter.vatGroupTypeEsGc);

      if (isHoldingCountry && isVatGroupType) {

        if(isVatReturn){
          result = -1;
        }

        if (isHoldingAndOperatesInVatGroup) {
          result = 1;
        } else if (isVatReturn && isDominantOrDependent) {
          result = 2;
        }
      }

      return result;
    };

    let filingOptions = this.props.filteredFilingOptions || [];

    //Sort options if EE and VAT Return
    let sortFilingOptions = filingOptions && filingOptions.length > 0 && FilingHelper.isFilingOptionSortingRequired(urlParams.filingTypeId, urlParams.countryCode);

    const selectedFilingOption = this.props.selectedFilingOption;

    const isZipVatReturn = (this.state.vatReturnExtension || '').replace(/^\./, '').toLowerCase() === 'zip';

    const filingPeriod = {
      fromDate:filingValues.startDate || urlParams.startDate,
      toDate: filingValues.endDate || urlParams.endDate
    };


    //SVR-9252 For PL VAT XML return, show message, as vat book and vat return are combined in PL.
    const filingPreparationVATXMLPL = (urlParams && urlParams.filingTypeId === FilingTypeEnum.VATRETURN && urlParams.countryCode === PLCountryCode &&
      selectedFilingOption && selectedFilingOption.outputType == ReturnTypeXML);

    const getPLVatXMLsUserQuestionsComponent = () => {
      return (
        <span className="mt10">
          <ApplicationMessages
            messageIds={[ALL_MESSAGES.VAT_PL_FILING_PREVIEW]}
            messageType="applicationWarning"
          />
        </span>
      );
    };

    log.debug('render(): fileName: ', fileName);
    log.debug('render(): %s filing: ', reportName, filingValues, urlParams.filingTypeId);
    log.debug('render(): userQuestions: ', userQuestions);
    log.debug('render(): answers: ', answers);
    log.debug('render(): filingOptionsForAllPeriods: ', filingOptionsForAllPeriods);
    log.debug('render(): filingOptions: ', filingOptions);
    log.debug('render(): selectedFilingOption: ', selectedFilingOption);
    log.debug('render(): availablePeriods: ', availablePeriods);
    log.debug('render(): filingValues(): ', this.props.filingValues);


    const startDate = (this.props.filingValues.startDate && this.props.filingValues.startDate.substring(0, 10)) || urlParams.startDate;
    const endDate = (this.props.filingValues.endDate && this.props.filingValues.endDate.substring(0, 10)) || urlParams.endDate;
    const showDirectSubmission = isAutoSubmissionEnabled(urlParams.filingTypeId, urlParams.countryCode, this.props.entitlements, this.props.featureFlag);
    const returnApprovalGate = this.getReturnApprovalGate(urlParams);
    const ectypeOptions = [{ label: 'Select EC type', value: '' }, ...this.props.ectypeOptions];
    let filingTypeId = (selectedFilingOption && selectedFilingOption.filingTypeId);
    const listingLinesComponent = (
      <div>
        <ReportingOptionListingLines
          salesData={this.state.ecTypeSalesData}
          purchaseData={this.state.ecTypePurchaseData}
          callOfStocksData = {this.state.ecTypeCallOfStocksData}
          onECTypeChange={this.onEcTypeChangeHandler('ectype')}
          onDelete={this.onListingLineDelete}
          onModify ={this.onListingLineModify}  /*here provide modify handler */
          onAdd={this.onAddLine.bind(this)}
          ectypeOptions={ectypeOptions}
          filingTypeId={filingTypeId}
          listingLinesData={this.getLisitngLinesData(filingTypeId)}
          countryCode={this.props.match?.params?.countryCode}
          onVATImport={this.onVATImport}
        />
      </div>
    );
        // listingLinesData={this.getLisitngLinesData(filingTypeId)}
    let workflowParams = this.props.match && this.props.match.params;
    workflowParams.filingTypeFlow = parsedQueryParams.flow;
    const filingPeriodName = this.selectedFilingFrequency && this.selectedFilingFrequency.id ? ENUMS.getPeriodicityFromId(this.selectedFilingFrequency.id) : '';

    let tabOptionList = [];
      switch(filingTypeId) {
      case FilingTypeEnum.VATRETURN:
        const vatReturnData = this.props.filing.data?.vatReturn || {};
        const vatReturnFilingNameGenerator = FilingHelper.fileNameFactory(FilingTypeEnum.VATRETURN);
        const vatForceSystemFileName = this.props.filingDocumentFileName && this.props.featureFlag?.[FeatureFlagEnum.USE_SYSTEM_FILENAME_FOR_DOWNLOAD_WHEN_PRESENT];
        let vatReturnFilename = vatForceSystemFileName ? this.props.filingDocumentFileName : vatReturnFilingNameGenerator({
          countryCode: this.props.selectedFilingOption && this.props.selectedFilingOption.countryCode,
          startDate: vatReturnData.startDate,
          endDate: vatReturnData.endDate,
          systemFileName: this.props.filingDocumentFileName,
          vatReturnDataCountry: vatReturnData.country,
          returnDisplayType: parsedQueryParams.returnDisplayType
        }) || '';

        // enableAsyncVatReturnOpenReturnPage feature: VAT Books-like async behavior
        if (this.isAsyncVatReturnEnabled()) {
            const vatUserQuestionsComponentAsync = this.state.vatReturnGenerationPending ? (<></>) : (
                <div>
                    <UserQuestionsForm
                        name="vatReturns"
                        filingTypeId={filingTypeId}
                        answers={answers}
                        userQuestions={userQuestions}
                        onSubmit={this.onFilingQuestionsSubmit}
                        triggerSubmitOnUnmount={true}
                        initData={this.formData["vatReturns"] ? this.formData["vatReturns"]["fieldValues"] : undefined}
                        showDownload={false}
                        showGenerate={this.state.vatReturnShowGenerate}
                        onGenerateClick={this.vatReturnGenerateClickHandler}
                    />
                </div>
            );

            // Once Generate is clicked the questions tab is replaced by the View Filing tab.
            const vatReturnGenerationPreviewExpected = this.state.vatReturnGenerationPending || this.state.showVatReturnGenerationControls;
            if (filingPreparationVATXMLPL) {
                tabOptionList = [{ id: 'userFields', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_UserFields'), component: getPLVatXMLsUserQuestionsComponent() }];
            } else if (vatReturnGenerationPreviewExpected) {
                tabOptionList = [{ id: 'approveFilings', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_PreviewApprove'), component: <></>  }];
            } else {
                tabOptionList = [{ id: 'userFields', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_UserFields'), component: vatUserQuestionsComponentAsync }];
            }
        }
        else {
            const vatUserQuestionsComponent = (
                <div>
                    <UserQuestionsForm
                        name="vatReturns"
                        filingTypeId={filingTypeId}
                        answers={answers}
                        userQuestions={userQuestions}
                        onSubmit={this.onFilingQuestionsSubmit}
                        triggerSubmitOnUnmount={true}
                        initData={this.formData["vatReturns"] ? this.formData["vatReturns"]["fieldValues"] : undefined}
                    />
                </div>
            );

            const vatReturnPrepareFile = (
                <div>
                    <PrepareFile
                        name="vatReturns"
                        onSubmit={this.onPrepareFileSubmit}
                        selectedFilingOption={selectedFilingOption}
                        documentUri={this.props.filingDocumentUri}
                        filename={vatReturnFilename}
                        filingDocumentFileName={this.props.filingDocumentFileName}
                        vatnumber={this.vatnumber}
                        companyCode={companyCode}
                        companyName={companyName}
                        filingTypeId={urlParams.filingTypeId}
                        countryCode={urlParams.countryCode}
                        documentExtension={this.props.filingDocumentFileExtension}
                        periodName={filingPeriodName}
                        multipleFilesToDownload={this.props.filingDocumentMultipleFilesToDownload}
                        fromDate = {vatReturnData.startDate}
                        toDate = {vatReturnData.endDate}
                        filingTypeFlow = {workflowParams.filingTypeFlow}
                        onSaveToWorkflow = {this.onSaveToWorkflow}
                        companyId={urlParams.companyId}
                        userName={this.props.userName}
                        returnDisplayType={parsedQueryParams.returnDisplayType}
                        selectedCorrectionPeriod={this.selectedCorrectionPeriod}
                    />
                </div>
            );

            tabOptionList = filingPreparationVATXMLPL ?
                [{ id: 'userFields', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_UserFields'), component: getPLVatXMLsUserQuestionsComponent() }] :
                [
                    { id: 'userFields', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_UserFields'), component: vatUserQuestionsComponent },
                    { id: 'approveFilings', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_PreviewApprove'), component: vatReturnPrepareFile },
                ];
        }
        break;
      case FilingTypeEnum.ECLISTING:
        const ecListingUserQuestionsComponent = (
          <div>
            <UserQuestionsForm
              name="ecListing"
              answers={answers}
              filingTypeId={filingTypeId}
              userQuestions={userQuestions}
              onSubmit={this.onFilingQuestionsSubmit}
              triggerSubmitOnUnmount={true}
              initData={this.formData["ecListing"] ? this.formData["ecListing"]["fieldValues"] : undefined}
            />
          </div>
        );

        const ecListingData = this.props.filing.data?.ecListing || {};
        const eclFilingNameGenerator = FilingHelper.fileNameFactory(FilingTypeEnum.ECLISTING);
        const eclForceSystemFileName = this.props.filingDocumentFileName && this.props.featureFlag?.[FeatureFlagEnum.USE_SYSTEM_FILENAME_FOR_DOWNLOAD_WHEN_PRESENT];
        const ecListingFilename = eclForceSystemFileName ? this.props.filingDocumentFileName : eclFilingNameGenerator({
          countryCode: this.props.selectedFilingOption && this.props.selectedFilingOption.countryCode,
          startDate: ecListingData.startDate,
          endDate: ecListingData.endDate,
          systemFileName: this.props.filingDocumentFileName,
          eclDataCountry: ecListingData.country,
          returnDisplayType: parsedQueryParams.returnDisplayType
        }) || '';

        const ecListingPrepareFile = (
          <div>
            <PrepareFile
              name="ecListing"
              onSubmit={this.onPrepareFileSubmit}
              selectedFilingOption={selectedFilingOption}
              documentUri={this.props.filingDocumentUri}
              documentExtension={this.props.filingDocumentFileExtension}
              filename={ecListingFilename}
              multipleFilesToDownload={this.props.filingDocumentMultipleFilesToDownload}
              vatnumber={this.vatnumber}
              fromDate = {ecListingData.startDate}
              toDate = {ecListingData.endDate}
              filingTypeFlow = {workflowParams.filingTypeFlow}
              onSaveToWorkflow = {this.onSaveToWorkflow}
              periodName = {filingPeriodName}
            />
          </div>
        );
        tabOptionList = [
         { id: 'listingLines', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_ListingLineEC'), component: listingLinesComponent },
         // { id: 'correctionsListingLines', title: (<LanguageStringResolver string='filingPage_ListingLineCorrections' />), component: listingLinesCorrectionComponent },
          { id: 'userFields', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_UserFields'), component: ecListingUserQuestionsComponent },
          { id: 'approveFilings', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_PreviewApprove'), component: ecListingPrepareFile },
        ];
        break;
      case FilingTypeEnum.VATBOOKS:
          const vatBookFileName = (
            this.props.selectedFilingOption &&
            this.props.selectedFilingOption.countryCode === ITCountryCode &&
            this.props.filingDocumentFileName) ? this.props.filingDocumentFileName : this.getVATBookReportFilename();
          const vatBooksUserQuestionsComponent = this.state.returnGenerationPending ? (<></>) :(
          <div>
            <UserQuestionsForm
              answers={answers}
              userQuestions={userQuestions}
              filingTypeId={filingTypeId}
              showDownload={false}
              showGenerate={this.state.vatBooksShowGenerate}
              onGenerateClick={this.vatBooksGenerateClickHandler}
            />
          </div>
        );

        //TODO: Kept both conditions as some part of API and application may be using 'VATBooks'. Need to remove the use of 'VATBooks' in future
        const filingPreparationVATBooksEE = ((urlParams.filingTypeId === 'VATBooks' || urlParams.filingTypeId === FilingTypeEnum.VATBOOKS) && urlParams.countryCode === 'EE');
        tabOptionList = [
          { id: 'userFields', title: filingPreparationVATBooksEE ?
            LANGUAGES_CONTROLLER.format(this.props.languages, 'filingFilingPreparation'):
            LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_UserFields'),
            component:  this.state.showReturnGenerationControls ? (<></>): vatBooksUserQuestionsComponent  }
        ];
        break;
        case FilingTypeEnum.INTRASTAT:

            const intrastatData=this.props.filing.data?.intrastat || {};
            const filingDocumentNameGenerator = FilingHelper.fileNameFactory(FilingTypeEnum.INTRASTAT);
            const intrastatForceSystemFileName = this.props.filingDocumentFileName && this.props.featureFlag?.[FeatureFlagEnum.USE_SYSTEM_FILENAME_FOR_DOWNLOAD_WHEN_PRESENT];

            let intrastatFilename = intrastatForceSystemFileName ? this.props.filingDocumentFileName : filingDocumentNameGenerator({
             countryCode: this.props.selectedFilingOption && this.props.selectedFilingOption.countryCode,
             startDate: intrastatData.startDate,
             endDate: intrastatData.endDate,
             documentExtension: this.props.filingDocumentFileExtension,
             systemFileName: this.props.filingDocumentFileName,
             outputType: this.props.selectedFilingOption && this.props.selectedFilingOption.outputType,
             filingPeriodName: filingPeriodName
           }) || '';

            // enableNewIntrastatOpenReturnPage feature: VAT Books-like behavior
            if (this.props.enableNewIntrastatOpenReturnPage) {
                const intrastatUserQuestionsComponent = this.state.intrastatReturnGenerationPending ? (<></>) : (
                    <div>
                        <UserQuestionsForm
                            name="intrastat"
                            answers={answers}
                            userQuestions={userQuestions}
                            filingTypeId={filingTypeId}
                            onSubmit={this.onFilingQuestionsSubmit}
                            triggerSubmitOnUnmount={true}
                            initData={this.formData["intrastat"] ? this.formData["intrastat"]["fieldValues"] : undefined}
                            showDownload={false}
                            showGenerate={this.state.intrastatShowGenerate}
                            onGenerateClick={this.intrastatGenerateClickHandler}
                        />
                    </div>
                );

                tabOptionList = [
                    { id: 'userFields', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_UserFields'), 
                      component: this.state.showIntrastatReturnGenerationControls ? (<></>) : intrastatUserQuestionsComponent }
                ];
            }
            // Existing behavior: Return Questions + View Filing tabs
            else {
                const intrastatUserQuestionsComponent = (
                    <div>
                        <UserQuestionsForm
                            name="intrastat"
                            answers={answers}
                            userQuestions={userQuestions}
                            filingTypeId={filingTypeId}
                            onSubmit={this.onFilingQuestionsSubmit}
                            triggerSubmitOnUnmount={true}
                            initData={this.formData["intrastat"] ? this.formData["intrastat"]["fieldValues"] : undefined}
                        />
                    </div>
                );

                const intrastatPrepareFile = (
                    <div>
                        <PrepareFile
                            name="intrastat"
                            onSubmit={this.onPrepareFileSubmit}
                            selectedFilingOption={selectedFilingOption}
                            documentUri={this.props.filingDocumentUri}
                            documentExtension={this.props.filingDocumentFileExtension}
                            filename={intrastatFilename}
                            multipleFilesToDownload={this.props.filingDocumentMultipleFilesToDownload}
                            filingTypeFlow = {workflowParams.filingTypeFlow}
                            onSaveToWorkflow = {this.onSaveToWorkflow}
                            fromDate={intrastatData.startDate}
                            toDate={intrastatData.endDate}
                            periodName={filingPeriodName}
                        />
                    </div>
                );

                tabOptionList = [
                    { id: 'userFields', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_UserFields'), component: intrastatUserQuestionsComponent },
                    { id: 'approveFilings', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_PreviewApprove'), component: intrastatPrepareFile },
                ];
            }
            break;
        case FilingTypeEnum.LOCALLISTING:
            log.debug('in LOCALLISTING(): ', this.formData);
            const localListingUserQuestionsComponent = (
                <div>
                    <UserQuestionsForm
                        name="localListing"
                        answers={answers}
                        userQuestions={userQuestions}
                        filingTypeId={filingTypeId}
                        onSubmit={this.onFilingQuestionsSubmit}
                        triggerSubmitOnUnmount={true}
                        initData={this.formData["localListing"] ? this.formData["localListing"]["fieldValues"] : []}
                    />
                </div>
            );

            const localListingData=this.props.filing.data?.localListing || {};
            const localListingForceSystemFileName = this.props.filingDocumentFileName && this.props.featureFlag?.[FeatureFlagEnum.USE_SYSTEM_FILENAME_FOR_DOWNLOAD_WHEN_PRESENT];
            const localListingFilename = localListingForceSystemFileName ? this.props.filingDocumentFileName : 'Local Listing ' + localListingData.country + ' (' +
localListingData.startDate + '_' + localListingData.endDate +')';

            const localListingPrepareFile = (
                <div>
                    <PrepareFile
                        name="localListing"
                        onSubmit={this.onPrepareFileSubmit}
                        selectedFilingOption={selectedFilingOption}
                        documentUri={this.props.filingDocumentUri}
                        documentExtension={this.props.filingDocumentFileExtension}
                        filename={localListingFilename}
                        filingTypeFlow = {workflowParams.filingTypeFlow}
                        filingTypeId = {filingTypeId}
                        onSaveToWorkflow = {this.onSaveToWorkflow}
                        fromDate = {localListingData.startDate}
                        toDate = {localListingData.endDate}
                        periodName = {filingPeriodName}
                    />
                </div>
            );

            // Local Listing Lines component with VAT Import Section
            const localListingLinesComponent = (
                <div>
                    <ReportingOptionListingLines
                        salesData={this.state.ecTypeSalesData}
                        purchaseData={this.state.ecTypePurchaseData}
                        callOfStocksData={this.state.ecTypeCallOfStocksData}
                        onECTypeChange={this.onEcTypeChangeHandler('ectype')}
                        onDelete={this.onListingLineDelete}
                        onModify={this.onListingLineModify}
                        onAdd={this.onAddLine.bind(this)}
                        ectypeOptions={ectypeOptions}
                        filingTypeId={filingTypeId}
                        listingLinesData={this.getLisitngLinesData(filingTypeId)}
                        countryCode={urlParams.countryCode}
                        onLocalListingVATImport={this.onVATImportDataReplace}
                    />
                </div>
            );

            tabOptionList = [
               { id: 'listingLines', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'localListingLines_Title'), component: localListingLinesComponent },
                { id: 'userFields', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_UserFields'), component: localListingUserQuestionsComponent },
                { id: 'approveFilings', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_PreviewApprove'), component: localListingPrepareFile },
            ];
            break;
        case FilingTypeEnum.EXTRASTAT:
              log.debug('in EXTRASTAT(): ', this.formData);
              const extrastatUserQuestionsComponent = (
                  <div>
                      <UserQuestionsForm
                         name="extrastat"
                         answers={answers}
                         userQuestions={userQuestions}
                         filingTypeId={filingTypeId}
                         onSubmit={this.onFilingQuestionsSubmit}
                         triggerSubmitOnUnmount={true}
                         initData={this.formData["extrastat"] ? this.formData["extrastat"]["fieldValues"] : undefined}
                      />
                  </div>
              );
              const extrastatData = this.props.filing.data?.extrastat || {};
              const extrastatForceSystemFileName = this.props.filingDocumentFileName && this.props.featureFlag?.[FeatureFlagEnum.USE_SYSTEM_FILENAME_FOR_DOWNLOAD_WHEN_PRESENT];
              const extrastatFilename = extrastatForceSystemFileName ? this.props.filingDocumentFileName : `${FilingTypeEnum.EXTRASTAT} ${extrastatData.country} (${moment(extrastatData.startDate).format("YYYY-MM-DD")}_${moment(extrastatData.endDate).format("YYYY-MM-DD")})`;
              const extrastatPrepareFile = (
                  <div>
                      <PrepareFile
                          name="extrastat"
                          onSubmit={this.onPrepareFileSubmit}
                          selectedFilingOption={selectedFilingOption}
                          documentUri={this.props.filingDocumentUri}
                          documentExtension={this.props.filingDocumentFileExtension}
                          filename={extrastatFilename}
                          filingTypeFlow = {workflowParams.filingTypeFlow}
                          onSaveToWorkflow = {this.onSaveToWorkflow}
                          fromDate = {extrastatData.startDate}
                          toDate = {extrastatData.endDate}
                          periodName = {filingPeriodName}
                      />
                  </div>
              );
              tabOptionList = [
                { id: 'userFields', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_UserFields'), component: extrastatUserQuestionsComponent },
                { id: 'approveFilings', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_PreviewApprove'), component: extrastatPrepareFile }
              ];
            break;
        case FilingTypeEnum.REVERSECHARGELISTING:
              log.debug('in REVERSECHARGELISTING(): ', this.formData);
              const reverseChargeListingUserQuestionsComponent = (
                  <div>
                      <UserQuestionsForm
                          name="reverseChargeListing"
                          answers={answers}
                          userQuestions={userQuestions}
                          filingTypeId={filingTypeId}
                          onSubmit={this.onFilingQuestionsSubmit}
                          triggerSubmitOnUnmount={true}
                          initData={this.formData["reverseChargeListing"] ? this.formData["reverseChargeListing"]["fieldValues"] : []}
                      />
                  </div>
              );
              const reverseChargeListingData=this.props.filing.data?.reverseChargeListing || {};
              const reverseChargeListingForceSystemFileName = this.props.filingDocumentFileName && this.props.featureFlag?.[FeatureFlagEnum.USE_SYSTEM_FILENAME_FOR_DOWNLOAD_WHEN_PRESENT];
              const reverseChargeListingFilename = reverseChargeListingForceSystemFileName ? this.props.filingDocumentFileName : 'Reverse Charge Listing ' + reverseChargeListingData.country + ' (' +
              moment(reverseChargeListingData.startDate).format("YYYY-MM-DD") + '_' + moment(reverseChargeListingData.endDate).format("YYYY-MM-DD") +')';

              const reverseChargeListingPrepareFile = (
                  <div>
                      <PrepareFile
                          name="reverseChargeListing"
                          onSubmit={this.onPrepareFileSubmit}
                          selectedFilingOption={selectedFilingOption}
                          documentUri={this.props.filingDocumentUri}
                          documentExtension={this.props.filingDocumentFileExtension}
                          filename={reverseChargeListingFilename}
                          filingTypeFlow = {workflowParams.filingTypeFlow}
                          onSaveToWorkflow = {this.onSaveToWorkflow}
                          fromDate = {reverseChargeListingData.startDate}
                          toDate = {reverseChargeListingData.endDate}
                          periodName = {filingPeriodName}
                      />
                  </div>
              );
              tabOptionList = [
                  { id: 'listingLines', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'localListingLines_Title'), component: listingLinesComponent },
                  { id: 'userFields', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_UserFields'), component: reverseChargeListingUserQuestionsComponent },
                  { id: 'approveFilings', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_PreviewApprove'), component: reverseChargeListingPrepareFile },
              ];
             break;
          case FilingTypeEnum.OSSUNION:
          case FilingTypeEnum.OSSIMPORT:
          case FilingTypeEnum.OSSNONUNION:
              log.debug('in OSS(): formdata', this.formData);
              log.debug('in OSS(): filing', this.props.filing);
              const ossUserQuestionsComponent = (
                  <div>
                      <UserQuestionsForm
                          name="oss"
                          answers={answers}
                          userQuestions={userQuestions}
                          filingTypeId={filingTypeId}
                          onSubmit={this.onFilingQuestionsSubmit}
                          triggerSubmitOnUnmount={true}
                          initData={this.formData["oss"] ? this.formData["oss"]["fieldValues"] : undefined}
                      />
                  </div>
              );

              const ossData= this.props.filing.data?.ossData || {};
              const ossForceSystemFileName = this.props.filingDocumentFileName && this.props.featureFlag?.[FeatureFlagEnum.USE_SYSTEM_FILENAME_FOR_DOWNLOAD_WHEN_PRESENT];
              const ossFilename = ossForceSystemFileName ? this.props.filingDocumentFileName : `${ENUMS.getFilingNameFromFilingType(filingTypeId)} ${ossData && ossData.country} (${moment(ossData && ossData.startDate).format("YYYY-MM-DD")}_${moment(ossData && ossData.endDate).format("YYYY-MM-DD")})`;
              const ossPrepareFile = (
                  <div>
                      <PrepareFile
                          name="oss"
                          onSubmit={this.onPrepareFileSubmit}
                          selectedFilingOption={selectedFilingOption}
                          documentUri={this.props.filingDocumentUri}
                          documentExtension={this.props.filingDocumentFileExtension}
                          filename={ossFilename}
                          filingTypeFlow = {workflowParams.filingTypeFlow}
                          onSaveToWorkflow = {this.onSaveToWorkflow}
                          fromDate = {ossData.startDate}
                          toDate = {ossData.endDate}
                          periodName = {filingPeriodName}
                      />
                  </div>
              );
              tabOptionList = [
                  { id: 'userFields', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_UserFields'), component: ossUserQuestionsComponent },
                  { id: 'approveFilings', title: LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_PreviewApprove'), component: ossPrepareFile },
              ];
              break;
      default:
        break;
    }
    const createManualDocumentFilename = (this.props.createManualDocumentData && this.props.createManualDocumentData.fileName) || '';
    let tomorrow  = moment(new Date()).add(1,'days').format('YYYY-MM-DD');
    const enableUploadedDocumentsPage = this.props.featureFlag?.EnableUploadedDocumentsPage;
    const manualDocumentLinkTo = enableUploadedDocumentsPage
      ? `/uploadedDocuments?endDate=${tomorrow}&filename=${createManualDocumentFilename}`
      : `/ProcessedDocuments?endDate=${tomorrow}&filename=${createManualDocumentFilename}`;
    const spanStyle = (urlParams.dueDate !== defaultDueDate)?{}:{"display": "none"};

          const tabOne = (
        <TabsPanel label={LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_ViewByTransactions')}>
         {(this.state.currentVATReturnTabIndex === VATReturnDetailsTabs.VIEW_RETURN_BY_TRANSACTION.value) ? (
           //In VATReturnDetails screen, if current tab is ViewReturnByTransaction then only load ReturnByTransactions view
                         <ReturnByTransactions
                         countryCode={urlParams.countryCode}
                         companyId={urlParams.companyId}
                         companyCode={companyCode}
                         companyName={companyName}
                         endDate={endDate}
                         startDate={startDate}
                         frequency={parsedQueryParams.frequency}
                         returnDisplayType={parsedQueryParams.returnDisplayType}
                         transactionType={0}
                         frequencyOptions={availablePeriods}
                       />
                    ):(
                        <div></div>
                    )}
      </TabsPanel>
    )
      log.debug('render(): fileName: ', fileName);
    // Show the component-specific loader while the filing values are being fetched.
    const isFilingValuesLoading = Boolean(this.props.filingValuesLoading);
    const filingValuesComponent = FilingTypeEnum.VATBOOKS !== urlParams.filingTypeId ? (
        <>
          <h2><LanguageStringResolver string='filingPage_FilingValues'/></h2>
          {isFilingValuesLoading ? (
            <div className="mb30" style={{ display: 'flex', justifyContent: 'center' }} data-testid="filing-values-loading">
              <SLoader loading className="small" />
            </div>
          ) : (
          <FilingValues
            filingTypeId={urlParams.filingTypeId}
            filingValues={filingValues}
            filingValueDetail={filingValueDetail}
            filingLoading={this.props.filing?.loading}
            countryCode={urlParams.countryCode}
            companyId={urlParams.companyId}
            filingPeriod={filingPeriod}
            filingDueDate={urlParams.dueDate}
            frequency={parsedQueryParams.frequency}
            onReportChangeHandler={this.onReportChangeHandler.bind(this)}
            selectedReportType={parsedQueryParams.flow}
            vatNumber={this.vatnumber}
            onGroupTypeChangeHandler={this.onGroupTypeChangeHandler.bind(this)}
            selectedGroupType={parsedQueryParams.grouped || "1"}
            filename={fileName}
            returnDisplayType={parsedQueryParams.returnDisplayType}
            selectedCorrectionPeriod={this.selectedCorrectionPeriod}
          />
          )}
        </>
      ): (
        <></>
    );
          const tabTwoLabel = FilingTypeEnum.VATBOOKS !== urlParams.filingTypeId ? (
        LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_FinaliseFile')
      ) : (<></>);
    const NoPreviewDisclaimer = FilingTypeEnum.VATBOOKS === urlParams.filingTypeId ? (
      (this.state.outputTypeSelection === "" ?
        <s-alert status="info">
          <s-icon ref="status-icon" class="medium absolute" aria-hidden="true" name="info-circle-filled"></s-icon>
          <div>
            <LanguageStringResolver string='filingPage_NoPreviewDisclaimer' />
          </div>
        </s-alert>
        : <></>)
      ) : (<></>);

    const selectorLabelString = FilingHelper.isRawformXmlSupported(urlParams.filingTypeId, urlParams.countryCode) ? 'filingFilingSelectFilingTypeInclRawformXml' : 'filingFilingSelectFilingType';

    const tabTwo = (
      <TabsPanel label={tabTwoLabel} selected="true">
          { filingValuesComponent }
          <hr className="mt30 mb25" />
          {NoPreviewDisclaimer}
          <FilingPreparation
            filingOptions={typeof parsedQueryParams.frequency === 'undefined' ? [] : filingOptions}
            disableFilingOptionSelector={isFilingValuesLoading}
            doSelectFilingOption={this.doSelectFilingOption.bind(this)}
            modifiedAvailableFilingLanguages = {this.state.modifiedAvailableFilingLanguages}
            selectedLanguage={this.state.selectedLanguage}
            doSelectReportLanguage={this.doSelectReportLanguage.bind(this)}
            selectedFilingOption={selectedFilingOption}
            selectorLabelString={selectorLabelString}
            userQuestions={userQuestions}
            answers={answers}
            title={(<LanguageStringResolver string='filingPage_ECSalesListing' />)}
            tabOptionList={tabOptionList}
            onAfterTabSelected={this.handleAfterTabSelected}
            tabShow={1}
            sortFilingOptions={sortFilingOptions}
            returnGenerationPending={this.state.returnGenerationPending}
            intrastatReturnGenerationPending={this.props.enableNewIntrastatOpenReturnPage && this.props.match.params.filingTypeId === FilingTypeEnum.INTRASTAT ? this.state.intrastatReturnGenerationPending : false}
            vatReturnGenerationPending={this.isAsyncVatReturnEnabled() && this.props.match.params.filingTypeId === FilingTypeEnum.VATRETURN ? this.state.vatReturnGenerationPending : false}
            vatReturnAutoFetchFailed={this.isAsyncVatReturnEnabled() && this.props.match.params.filingTypeId === FilingTypeEnum.VATRETURN ? this.state.vatReturnAutoFetchFailed : false}
          />
          <div className="clear"></div>
      </TabsPanel>
    )

    return (
      <ReadOnlyWrapper>
        <s-container>
          <div className="content-area openReturns">
          <ApplicationMessages
            messageIds={[
              ALL_MESSAGES.CREATE_MANUAL_DOCUMENT_NO_FILE_DATA,
              ALL_MESSAGES.ECL_VATNUMBER_CHECK_ERROR,
              ALL_MESSAGES.INTRASTAT_RETURNS_GENERATION_ERROR
            ]}
            messageType="applicationError"
          />
          <ApplicationMessages
            messageIds={[ALL_MESSAGES.CREATE_MANUAL_DOCUMENT_SUCCESS]}
            linkTo={manualDocumentLinkTo}
            messageType="applicationSuccess"
          />
          <h1><span>{reportName}</span></h1>

          {/* Start of summary section */}
          <div className="summary-panel">
            <span className="uppercase"><LanguageStringResolver string='filingPage_Country'/>: </span><span className="bold">{urlParams.countryCode}</span>
            <span className="divider-left margin-left-sm margin-right-sm"></span>
            <span className="uppercase"><LanguageStringResolver string='filingPage_Company'/>: </span><span className="bold">{companyName}</span>
            <span className="divider-left margin-left-sm margin-right-sm"></span>
            <span className="uppercase"><LanguageStringResolver string='filingPage_Period'/>: </span><span className="font-weight-400">{startDate} - {endDate}</span>
            <span className="divider-left margin-left-sm margin-right-sm"></span>
            <span style={spanStyle}>
              <span className="uppercase"><LanguageStringResolver string='filingPage_DueDate'/>: </span><span className="font-weight-400">{urlParams.dueDate}</span>
              <span className="divider-left margin-left-sm margin-right-sm"></span>
            </span>
            <span class="filter-select">
              <FilingFrequencySelector
                selectionHandler={this.filingFrequencySelectionHandler.bind(this)}
                value={parsedQueryParams.frequency}
                validPeriodIds={availablePeriods}
                filingTypeId={urlParams.filingTypeId}
                inline={true}
                labelText={<LanguageStringResolver string='filingPage_Frequency'/>}
                showDefaultValue={true}
              />
                {
                  //If monthly intrastat then we need to know if it is the simplified monthly return they want
                  (()=> {
                    if (showSimpifiedIntrastat === true && (urlParams.filingTypeId === FilingTypeEnum.INTRASTAT) && (parsedQueryParams.frequency === '1'))
                    {
                      return  <span>
                                <span className="divider-left margin-left-sm margin-right-sm"></span>
                                <span>
                                  <fieldset className="inline uppercase">
                                    <input
                                      type="checkBox"
                                      name="monthlySimplifiedIntrastat"
                                      className="checkbox"
                                      checked={(parsedQueryParams.simplifiedIntrastat || "0") === "1"}
                                      onChange={this.simplifiedIntrastatChanged.bind(this)}
                                    />
                                    <label className="checkbox"><LanguageStringResolver string='filingPage_SimplifiedMonthlyIntrastat'/></label>
                                  </fieldset>
                                </span>
                              </span>
                    }
                    else
                    {
                      return;
                    }
                  })()
                }
            </span>
            {
              (() => {
                if (enableCorrections) {
                  return (
                    <span class="filter-select">
                      <span className="divider-left margin-left-sm margin-right-sm"></span>
                      <span className="filter-font-weight">
                        <TransactionFilter
                          labelTextId={"filingPage_TransactionFilterLabel"}
                          languages={this.props.languages}
                          value={parsedQueryParams.returnDisplayType}
                          showGroupingOptions={this.state.currentVATReturnTabIndex !== VATReturnDetailsTabs.VIEW_RETURN_BY_TRANSACTION.value}
                          onSelect={this.onTransactionFilterChange.bind(this)}
                          returnType={urlParams?.filingTypeId}
                          featureFlag={this.props.featureFlag}
                        />
                      </span>
                      <CorrectionPeriodSelector value={this.selectedCorrectionPeriodIndex} onSelect={this.onCorrectionPeriodChange.bind(this)} />
                      <OSSGroupFilters
                        labelTextId={"filingPage_GroupingTypeFilterLabel"}
                        languages={this.props.languages}
                        value={parsedQueryParams.grouped}
                        returnType={urlParams?.filingTypeId}
                        onSelect={this.onOSSGroupingFilterChange.bind(this)}
                        featureFlag={this.props.featureFlag}
                      />
                    </span>
                  );
                } else {
                  return null;
                }
              })()
            }
          </div>
          {/* End of summary section */}

          <div>
            {this.props.match.params.filingTypeId === FilingTypeEnum.VATBOOKS ? <></>: <hr className="mt30 mb25" />}
            <div className="clear"></div>
            <div className="mb50">
              { this.props.match.params.filingTypeId === 'VATReturn' ?
                (
                  <TabsContainer className="mb50" onTabChange={this.onVATReturnTabHandler}>
                    {tabOne}
                    {tabTwo}
                  </TabsContainer>
                ):(
                  <TabsContainer className="mb50">
                    {tabTwo}
                  </TabsContainer>
                  )
              }
              {
                this.state.showReturnGenerationControls ? (
                  <div className="mt20">
                    <StaticApplicationMessage
                      messageType="applicationInfo"
                      string="filingPreview_vatBookNotAvailable"
                      languages={this.props.languages}
                      nodismiss
                    />
                    <div className="mt20">
                      <ReturnGenerationControls
                        showSubmit={this.state.vatBooksShowDownload}
                        showGenerate={this.state.vatBooksShowGenerate}
                        showRegenerate={this.state.vatBooksShowRegenerate}
                        showDownload={this.state.vatBooksShowDownload}
                        showPdfPreviewDownload={this.state.vatBooksShowDownload && !!this.state.returnsDocumentPdfPreviewURL}
                        showPdfPreviewWorkflow={this.props.canUserSaveToWorkflow && !!this.state.returnsDocumentPdfPreviewURL}
                        onSubmitClick={this.vatBooksSubmitClickHandler}
                        onDownloadPdfPreviewClick={this.vatBooksPdfPreviewSubmitClickHandler}
                        onRegenerateClick={this.vatBooksReGenerateClickHandler}
                        filename={this.vatBookFileName || this.getVATBookReportFilename()}
                        showWorkflow={this.props.canUserSaveToWorkflow}
                        onSaveToWorkflow={this.onSaveToWorkflow}
                        fileExtension={this.state.extension}
                        submitOptions={this.props.enableSiVatbookZipDownload && this.props.match?.params?.countryCode === siCountryCode && this.state.vatBooksShowDownload ? {
                          isBlob: true
                        } : {}}
                      />
                    </div>
                  </div>
                ): (<></>)
              }
              {
                // Intrastat ReturnGenerationControls (enableNewIntrastatOpenReturnPage feature)
                this.props.enableNewIntrastatOpenReturnPage && this.props.match.params.filingTypeId === FilingTypeEnum.INTRASTAT && this.state.showIntrastatReturnGenerationControls ? (
                  <div className="mt20">
                    <ReturnPreview
                      documentUri={this.state.intrastatReturnsDocumentURL}
                      documentType={selectedFilingOption && selectedFilingOption.outputType}
                      mimeType={this.state.intrastatMimeType}
                      documentExtension={(this.state.intrastatExtension || '').replace(/^\./, '')}
                      filename={this.getIntrastatReportFilename()}
                      infoMessageString="filingPreview_returnRegenerationReminder"
                      languages={this.props.languages}
                    />
                    <div className="mt20">
                      <ReturnGenerationControls
                        showSubmit={false}
                        showGenerate={this.state.intrastatShowGenerate}
                        showRegenerate={this.state.intrastatShowRegenerate}
                        showDownload={this.state.intrastatShowDownload}
                        onSubmitClick={this.intrastatSubmitClickHandler}
                        onDownloadClick={this.intrastatSubmitClickHandler}
                        onRegenerateClick={this.intrastatReGenerateClickHandler}
                        filename={this.getIntrastatReportFilename()}
                        showWorkflow={this.props.canUserSaveToWorkflow}
                        onSaveToWorkflow={this.onSaveToWorkflow}
                        fileExtension={this.state.intrastatExtension}
                        submitOptions={{ isBlob: true }}
                        MarkAsSubmittedButton={
                            <button className="primary ml10" onClick={() => this.setState({ showIntrastatSubmitConfirmationModal: true })}>
                              <LanguageStringResolver string='filingPage_ApproveAndDownloadBtn' />
                            </button>
                        }
                        disableRegenerate={!this.getCanRegenerate(urlParams)}
                        regenerateDisabledTooltip={this.getRegenerateDisabledTooltip()}
                        disableMarkAsSubmitted={!this.getCanMarkAsSubmitted(urlParams)}
                        markAsSubmittedDisabledTooltip={this.getMarkAsSubmittedDisabledTooltip()}
                      />
                    </div>
                  </div>
                ): (<></>)
              }
              {
                // VAT Return ReturnGenerationControls (enableAsyncVatReturnOpenReturnPage feature)
                this.isAsyncVatReturnEnabled() && this.props.match.params.filingTypeId === FilingTypeEnum.VATRETURN && this.state.showVatReturnGenerationControls ? (
                  filingPreparationVATXMLPL ? (getPLVatXMLsUserQuestionsComponent()) : (
                  <div className="mt20">
                    {isZipVatReturn ? (
                      <StaticApplicationMessage
                        messageType="applicationInfo"
                        string="filingPreview_vatReturnZipNotAvailable"
                        languages={this.props.languages}
                        nodismiss
                      />
                    ) : (
                      <ReturnPreview
                        documentUri={this.state.vatReturnReturnsDocumentURL}
                        documentType={selectedFilingOption && selectedFilingOption.outputType}
                        mimeType={this.state.vatReturnMimeType}
                        documentExtension={(this.state.vatReturnExtension || '').replace(/^\./, '')}
                        filename={this.getVatReturnReportFilename()}
                        infoMessageString="filingPreview_returnRegenerationReminder"
                        languages={this.props.languages}
                      />
                    )}
                    <div className="mt20">
                      <ReturnGenerationControls
                        showSubmit={false}
                        showGenerate={this.state.vatReturnShowGenerate}
                        showRegenerate={this.state.vatReturnShowRegenerate}
                        showDownload={this.state.vatReturnShowDownload}
                        onSubmitClick={this.vatReturnSubmitClickHandler}
                        onDownloadClick={this.vatReturnSubmitClickHandler}
                        onRegenerateClick={this.vatReturnReGenerateClickHandler}
                        filename={this.getVatReturnReportFilename()}
                        showWorkflow={this.props.canUserSaveToWorkflow}
                        onSaveToWorkflow={this.onSaveToWorkflow}
                        fileExtension={this.state.vatReturnExtension}
                        submitOptions={{ isBlob: true }}
                        MarkAsSubmittedButton={
                            <button className="primary ml10" onClick={() => this.setState({ showVatReturnSubmitConfirmationModal: true })}>
                              <LanguageStringResolver string='filingPage_ApproveAndDownloadBtn' />
                            </button>
                        }
                        CountrySpecificSubmitButton={this.getVatReturnCountrySpecificButton(
                          this.getVatReturnReportFilename(),
                          this.state.vatReturnReturnsDocumentURL,
                          selectedFilingOption && selectedFilingOption.outputType,
                          companyCode,
                          selectedFilingOption && selectedFilingOption.name,
                          companyName,
                          filingPeriodName
                        )}
                        onInitiateAutoSubmission={this.onInitiateAutoSubmission}
                        onGoToTaskList={this.onGoToTaskList}
                        showInitiateAutoSubmission={showDirectSubmission}
                        canInitiateAutoSubmission={this.getCanInitiateAutoSubmission(urlParams)}
                        initiateDisabledTooltip={this.getInitiateAutoSubmissionDisabledTooltip(urlParams)}
                        showDirectSubmissionStatus={showDirectSubmission}
                        showApprovalWarning={FilingHelper.isRawformXmlSupported(urlParams.filingTypeId, urlParams.countryCode)}
                        disableRegenerate={!this.getCanRegenerate(urlParams)}
                        regenerateDisabledTooltip={this.getRegenerateDisabledTooltip()}
                        disableMarkAsSubmitted={!this.getCanMarkAsSubmitted(urlParams)}
                        markAsSubmittedDisabledTooltip={this.getMarkAsSubmittedDisabledTooltip(urlParams)}
                        ApprovalControls={returnApprovalGate && (
                          <ReturnApprovalControls
                            gate={returnApprovalGate}
                            isSending={this.props.returnApprovals?.sending}
                            sendDisabledTooltip={LANGUAGES_CONTROLLER.format(this.props.languages, 'filingPage_ReturnApproval_SendDisabled')}
                            onSendForApproval={this.onSendForApproval}
                            onGoToReturnApprovals={this.onGoToReturnApprovals}
                          />
                        )}
                      />
                    </div>
                  </div>)
                ): (<></>)
              }
            </div>
          </div>
            <BoxValueValidationModal
              isModalPopupOpen={this.state.isBoxValidationPopupOpen}
              modalMessage={this.state.boxValidationWarningMessage}
              onCloseClickHandler={() => this.onCloseModal()}
              onYesClickHandler={() => this.handleAutoCorrection()}
              isManualCorrection={this.state.boxValidationManualCorrection?.length > 0}
              isBoxValueAutoCorrected={this.state.boxValidationIsAutoCorrected}
            />
             <ConfirmationModal
              isModalPopupOpen={this.state.showVatBooksRegenerateConfirmationModal}
              modelTitle = "filingPage_ConfirmationModalTitle"
              modelMessage = "filingPage_ConfirmationModalDisclaimer"
              onYesClickHandler = {this.vatBooksRegenerateConfirmationModalYesHandler}
              onCancelClickHandler = {this.vatBooksRegenerateConfirmationModalCancelHandler}
            />
             <ConfirmationModal
              isModalPopupOpen={this.state.showIntrastatRegenerateConfirmationModal}
              modelTitle = "filingPage_ConfirmationModalTitle"
              modelMessage = "filingPage_ConfirmationModalDisclaimerIntrastat"
              onYesClickHandler = {this.intrastatRegenerateConfirmationModalYesHandler}
              onCancelClickHandler = {this.intrastatRegenerateConfirmationModalCancelHandler}
            />
            <ConfirmationModal
              isModalPopupOpen={this.state.showIntrastatSubmitConfirmationModal}
              modelTitle="confirmationModal_TitleApproval"
              modelMessage="approval_confirmation"
              onYesClickHandler={this.intrastatSubmitConfirmationModalYesHandler}
              onCancelClickHandler={this.intrastatSubmitConfirmationModalCancelHandler}
            />
            <ConfirmationModal
              isModalPopupOpen={this.state.showVatReturnRegenerateConfirmationModal}
              modelTitle="filingPage_ConfirmationModalTitle"
              modelMessage={this.getVatReturnRegenerateMessageKey(urlParams)}
              onYesClickHandler={this.vatReturnRegenerateConfirmationModalYesHandler}
              onCancelClickHandler={this.vatReturnRegenerateConfirmationModalCancelHandler}
            />
            <ConfirmationModal
              isModalPopupOpen={this.state.showVatReturnSubmitConfirmationModal}
              modelTitle={this.isGbPdfVatReturn(urlParams) ? "filingPage_GbPdfMarkAsSubmittedTitle" : "confirmationModal_TitleApproval"}
              modelMessage={this.isGbPdfVatReturn(urlParams) ? "filingPage_GbPdfMarkAsSubmittedMessage" : "approval_confirmation"}
              onYesClickHandler={this.vatReturnSubmitConfirmationModalYesHandler}
              onCancelClickHandler={this.vatReturnSubmitConfirmationModalCancelHandler}
            />
        </div>
      </s-container>
      </ReadOnlyWrapper>
    );
  }

    onOpenModal(warningMessage, manualCorrectionBoxes, isBoxValueAutoCorrected = false) {
        log.debug('onOpenModal: warningMessage', warningMessage);
        if(!_.isEmpty(warningMessage))
            this.setState({
                isBoxValidationPopupOpen: true,
                boxValidationWarningMessage: warningMessage,
                boxValidationManualCorrection: manualCorrectionBoxes,
                boxValidationIsAutoCorrected: !!isBoxValueAutoCorrected,
            });
    }

    onCloseModal() {
        this.setState({isBoxValidationPopupOpen: false });
    }

    getCompanyCodeById(companyId) {
      return this.props.companyList.find(item => item.id === Number(companyId));
    }

    handleAutoCorrection() {
      const urlParams = (this.props.match && this.props.match.params) || {};
      const currencyData = ReactComponentHelper.getCurrencyByCountryCode(urlParams?.countryCode) || {};
      let payload = {
        filingType: 1,
        companyCode: this.getCompanyCodeById(urlParams?.companyId)?.code,
        country: urlParams?.countryCode,
        transactionDate: urlParams?.startDate,
        invoiceDate: urlParams?.startDate,
        reporterName: this.props.userName,
        referenceCode: '',
        currency: currencyData.currencyCode,
        documentType: 0,
        reportingType: 1,
        countryMainTransaction: urlParams?.countryCode,
        vatBoxes: this.state.boxValidationManualCorrection,
        totalTaxableBasis: 0,
        totalVAT: 0,
      }
      this.props.doCreateAutoAdjustment(payload, () => {
        // After creating the manual auto-adjustment document, also flip the
        // IsBoxValueAutoCorrected flag on the return so the backend kicks off
        // its async box-value auto-correction job. Modal is closed regardless
        // of success/failure - failures are logged silently per product spec.
        this.triggerBoxValueAutoCorrectFlagUpdate(() => this.onCloseModal());
      });
    }

    // Builds the parameter object that uniquely identifies the currently
    // selected return. Single source of truth shared between the GET
    // /returns call (doSelectFilingOption) and the auto-correction PATCH
    // (triggerBoxValueAutoCorrectFlagUpdate). `selection` defaults to the
    // current redux-tracked filing option but can be overridden by the GET
    // callsite, which has the freshest selection in a local variable before
    // redux has had a chance to round-trip the prop update.
    //
    // Note: the legacy `getReturns` REST helper still uses the misspelled
    // `countyCode` parameter name; this method preserves that shape and the
    // PATCH callsite renames inline.
    //
    // `language` is optional. When omitted the call falls back to the
    // redux-tracked `reportLanguage` so existing callers (including the PATCH
    // wrapper) continue to address the active return. The async VAT Return
    // language-change flow passes the freshly-selected language explicitly
    // because the next-tick `setState({reportLanguage})` has not landed yet
    // when the GET fires.
    buildReturnsParams(selection = this.props.selectedFilingOption, language = this.state.reportLanguage || '') {
      const params = (this.props.match && this.props.match.params) || {};
      const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
      const filingTypeId = params.filingTypeId || -1;
      const isVatBooks = filingTypeId === FilingTypeEnum.VATBOOKS;
      // Preserves the exact null-safety semantics of the previous inline
      // literal so non-VAT-Return paths (VAT Books, Intrastat) behave
      // identically when filingValues is null vs undefined vs {}.
      const periodStartDate = isVatBooks
        ? params.startDate
        : ((this.props.filingValues && this.props.filingValues.startDate) || params.dueDate);
      const periodEndDate = isVatBooks
        ? params.endDate
        : (this.props.filingValues && this.props.filingValues.endDate);
      const rawFrequency = parsedQueryParams && parsedQueryParams.frequency;
      const frequency = isVatBooks
        ? ENUMS.getPeriodicityFromId(rawFrequency)
        : rawFrequency;
      return {
        countyCode: params.countryCode,
        companyId: params.companyId,
        periodStartDate,
        periodEndDate,
        frequency,
        returnDefinition: selection && selection.formXmlId,
        language,
      };
    }

    triggerBoxValueAutoCorrectFlagUpdate(done = () => {}) {
      const returnsParams = this.buildReturnsParams(
        this.props.selectedFilingOption,
        this.state.selectedLanguage || ''
      );
      // Skip silently when we don't yet have enough context to address a
      // specific return (e.g. modal opened from a flow that hasn't yet
      // selected a filing option). Mirrors the previous "no cached params"
      // guard.
      if (!returnsParams.returnDefinition || !returnsParams.companyId) {
        log.debug('triggerBoxValueAutoCorrectFlagUpdate: insufficient returns context, skipping PATCH');
        done();
        return;
      }
      // The GET /returns helper still uses the legacy `countyCode` typo; the
      // PATCH endpoint expects the correctly-spelled `countryCode`. Renaming
      // is contained to this single callsite.
      const { countyCode, ...rest } = returnsParams;
      const patchParams = {
        ...rest,
        countryCode: countyCode,
        // Yes click on the box validation modal opts the return in to
        // backend-driven box-value auto-correction.
        isBoxValueAutoCorrected: true,
      };
      this.props.doUpdateBoxValueAutoCorrectFlag(patchParams, () => {
        done();
      });
    }

    //Below covertCreationDateToISOFormat function is regarding ticket SVR-5324,
    //Here attaching current local system time to CreationDate .
    //In UI CreationDate is html date calendar it supports date only, not dateTime.
    //Hence html control is not returning datetime
    //VR API required creationDate in ISO datetime format.
    //CreationDate in ISO datetime format is required for ECL and VAT for LU country filing.
    //It generates FileReference field based on CreationDate Time.
    //Same logic is implemented in Desktop
    covertCreationDateToISOFormat(databaseFields){
      let dateformatLength = 10;
      let localCurrentDateTime = (new Date()).toISOString();
      return _.map(databaseFields,function(item){
        if(item.dbName === "CreationDate" && item.value){
          item.value = localCurrentDateTime.replace(localCurrentDateTime.substring(0,dateformatLength),item.value.substring(0,dateformatLength));
        }
        return item;
      })
    }

  getAdditionalECListingOptions(filingOptions) {
    if (this.props.featureFlag?.EnableNewMetaData) {
      filingOptions = Object.assign({}, filingOptions, {
        isCorrection: this.selectedCorrectionPeriod ? true : false,
        correctionYear: this.selectedCorrectionPeriod?.correctionYear,
        correctionPeriod: this.selectedCorrectionPeriod?.correctionPeriod,
      });
    }
    return filingOptions;
  }

  doUserQuestionsAnswered(userFields, databaseFields, approval, downloadInBrowser=true, callback=()=>{}) {
    databaseFields = this.covertCreationDateToISOFormat(databaseFields);
    log.debug('doUserQuestionsAnswered: ', userFields, databaseFields, this.props.filingValues);
    const params = (this.props.match && this.props.match.params) || {};
    const filingValues = this.props.filingValues;
    const filingPeriod = {
      fromDate: filingValues.startDate && filingValues.startDate.substring(0, 10),
      toDate: filingValues.endDate  && filingValues.endDate.substring(0, 10)
    };
    const correctionProps = this.buildCorrectionProps();
    if (this.props.selectedFilingOption) {
      this.setState({
        showFilingPreview: true
      });
      log.debug('doUserQuestionsAnswered: selectedFilingOption', this.props.selectedFilingOption, this.props.filingTypes);
      let generateFilingOptions = {};
      const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
      const filingTypeId = (this.props.selectedFilingOption && this.props.selectedFilingOption.filingTypeId) || -1;
      const freq = Number.parseInt(parsedQueryParams.frequency, 10);
      const periodicity = Number.isNaN(freq) ? 1: (freq);
      const returnDisplayType = enableCorrections ? parsedQueryParams.returnDisplayType : ReturnDisplayType.SHOW_ALL.value;

      switch (filingTypeId) {
        case FilingTypeEnum.ECLISTING:
          let ecListingReportData = {
            listingType: this.props.filingValues && this.props.filingValues.listingType,
            lines: this.generateFinalReportData(filingTypeId) || []
          };
          generateFilingOptions = {
            companyId: params.companyId,
            reportData: ecListingReportData,
            userFields: userFields,
            databaseFields: databaseFields,
            countryCode: params.countryCode,
            filingPeriod: filingPeriod,
            periodicity: periodicity,
            reportApproval: approval,
            selectedLanguage: this.state.reportLanguage,
            drawTranslated: this.state.drawTranslated,
            outputType: this.props.selectedFilingOption.outputType,
            periodName: this.props.selectedFilingOption.periodName,
            filingName: this.props.selectedFilingOption.filingName
          };
          generateFilingOptions = this.getAdditionalECListingOptions(generateFilingOptions);
          break;
        case FilingTypeEnum.LOCALLISTING:
            let localListingReportData = {
                listingType : LocalListingFlowEnum.props[parsedQueryParams.flow].value,
                lines: this.generateFinalReportData(filingTypeId) || []
            };

          generateFilingOptions = {
            companyId: params.companyId,
            reportData: localListingReportData,
            userFields: userFields,
            databaseFields: databaseFields,
            countryCode: params.countryCode,
            filingPeriod: filingPeriod,
            periodicity: periodicity,
            reportApproval: approval,
            selectedLanguage: this.state.reportLanguage,
            drawTranslated: this.state.drawTranslated,
            outputType: this.props.selectedFilingOption.outputType,
            periodName: this.props.selectedFilingOption.periodName,
            filingName: this.props.selectedFilingOption.filingName
          };
          break;
        case FilingTypeEnum.REVERSECHARGELISTING:
          let reverseChargeListingReportData = {
            listingType: LocalListingFlowEnum.props[parsedQueryParams.flow].value,
            lines: this.generateFinalReportData(filingTypeId) || []
          };
          
          generateFilingOptions = {
            companyId: params.companyId,
            reportData: reverseChargeListingReportData,
            userFields: userFields,
            databaseFields: databaseFields,
            countryCode: params.countryCode,
            filingPeriod: filingPeriod,
            periodicity: periodicity,
            reportApproval: approval,
            selectedLanguage: this.state.reportLanguage,
            drawTranslated: this.state.drawTranslated,
            outputType: this.props.selectedFilingOption.outputType,
            periodName: this.props.selectedFilingOption.periodName,
            filingName: this.props.selectedFilingOption.filingName
          };
          break;
        case FilingTypeEnum.INTRASTAT:
          let reportData = { country: params.countryCode, reportType: parsedQueryParams.flow, startDate: filingValues.startDate, endDate: filingValues.endDate, goodsLines: filingValues.goodsLines,serviceLines: filingValues.serviceLines };
          generateFilingOptions = {
            companyId: params.companyId,
            reportData: reportData,
            userFields: userFields,
            databaseFields: databaseFields,
            countryCode: params.countryCode,
            filingPeriod: filingPeriod,
            periodicity: periodicity,
            reportApproval: approval,
            selectedLanguage: this.state.reportLanguage,
            drawTranslated: this.state.drawTranslated,
            outputType: this.props.selectedFilingOption.outputType,
            periodName: this.props.selectedFilingOption.periodName,
            filingName: this.props.selectedFilingOption.filingName
          };
          break;
        case FilingTypeEnum.EXTRASTAT:
            let reportDataExtrastat = { country: params.countryCode, reportType: parsedQueryParams.flow, startDate: filingValues.startDate, endDate: filingValues.endDate, lines: filingValues.lines };
            generateFilingOptions = {
              companyId: params.companyId,
              reportData: reportDataExtrastat,
              userFields: userFields,
              databaseFields: databaseFields,
              countryCode: params.countryCode,
              filingPeriod: filingPeriod,
              periodicity: periodicity,
              reportApproval: approval,
              selectedLanguage: this.state.reportLanguage,
              drawTranslated: this.state.drawTranslated,
              outputType: this.props.selectedFilingOption.outputType,
              periodName: this.props.selectedFilingOption.periodName,
              filingName: this.props.selectedFilingOption.filingName
            };
            break;
        case FilingTypeEnum.OSSIMPORT:
        case FilingTypeEnum.OSSUNION:
        case FilingTypeEnum.OSSNONUNION:
              let ossReportData = { startDate: filingValues.startDate, endDate: filingValues.endDate, country: params.countryCode, Lines: filingValues.lines};
              generateFilingOptions = {
                  companyId: params.companyId,
                  reportData: ossReportData,
                  userFields: userFields,
                  databaseFields: databaseFields,
                  countryCode: params.countryCode,
                  filingPeriod: filingPeriod,
                  periodicity: periodicity,
                  reportApproval: approval,
                  selectedLanguage: this.state.reportLanguage,
                  drawTranslated: this.state.drawTranslated,
                  outputType: this.props.selectedFilingOption.outputType,
                  periodName: this.props.selectedFilingOption.periodName,
                  filingName: this.props.selectedFilingOption.filingName
              };
              break;
        default:
          const boxes = ((this.state.editableFilingValues && this.state.editableFilingValues.boxes) || []);
          generateFilingOptions = Object.assign({}, {
            companyId: params.companyId,
            reportData: boxes,
            userFields: userFields,
            databaseFields: databaseFields,
            countryCode: params.countryCode,
            filingPeriod: filingPeriod,
            periodicity: periodicity,
            returnDisplayType: returnDisplayType,
            reportApproval: approval,
            selectedLanguage: this.state.reportLanguage,
            drawTranslated: this.state.drawTranslated,
            outputType: this.props.selectedFilingOption.outputType,
            periodName: this.props.selectedFilingOption.periodName,
            filingName: this.props.selectedFilingOption.filingName
          }, correctionProps);
      }

      log.debug('doUserQuestionsAnswered(): generateFilingOptions: ', generateFilingOptions);
        //For DE VAT return on submit, show warning message
        log.debug('doUserQuestionsAnswered: callback');
        if(filingTypeId === FilingTypeEnum.VATRETURN && _.isEmpty(approval))
        {
            callback = (data, filedata, warningMessage, manualCorrectionBoxes, isBoxValueAutoCorrected) => {
                log.debug('doUserQuestionsAnswered: callback', warningMessage);
                this.onOpenModal(warningMessage, manualCorrectionBoxes, isBoxValueAutoCorrected);
            };
        }

        this.props.generateFilingDocument (
          this.props.selectedFilingOption.formXmlId,
          this.props.selectedFilingOption.filingTypeId,
          generateFilingOptions, downloadInBrowser, callback
        );
    }
  }

  doSelectFilingOption(selection, setLanguage) {
    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    const params = (this.props.match && this.props.match.params) || {};
    const filingTypeId = params.filingTypeId || -1;
    let frequency = parsedQueryParams && parsedQueryParams.frequency;
    let flowType = parsedQueryParams && parsedQueryParams.flow;
    this.resetFormDataOnFilingOptionChange = true;

    selection = {
      ...selection,
      filingTypeId: filingTypeId,
      filingName: ENUMS.getFilingNameFromFilingType(filingTypeId),
      periodName: ENUMS.getPeriodicityFromId(frequency)
    };

    log.debug('doSelectFilingOption: ', selection, this.props.match.params, this.props.filingValues);
    this.props.onSelectFilingOption(selection);
    this.props.doClearSuccess();
    log.clearAllDictionaryErrors();
    if (this.state.reportAlreadySubmitted) {
      log.setDictionaryMessage(ALL_MESSAGES.REPORT_ALREADY_APPROVED);
    }
    log.setDictionaryMessage(ALL_MESSAGES.VAT_PL_FILING_PREVIEW);
    if(selection) {
      this.setState({
        outputTypeSelection: selection.outputType
      });
    }
    if(!selection) {
      this.setState({
        returnGenerationPending: false,
        showReturnGenerationControls: false,
        outputTypeSelection: ""
      });
      return;
    }

    // Capture the selected language value from the language dropdown. 
    let dropdownLanguage = this.state.selectedLanguage || '';
    if (selection.outputType !== 'PDF') {
        this.setState({
          reportLanguage: '',
          drawTranslated: 0,
          selectedLanguage: '',
          modifiedAvailableFilingLanguages: []
        });
        dropdownLanguage = '';
    } else if (setLanguage) {
      let modifiedLanguages = this.modifyAvailableFilingLanguages(selection);
      this.setState({ modifiedAvailableFilingLanguages: modifiedLanguages,selectedLanguage: modifiedLanguages[0] });
      this.setReportLanguage(selection, modifiedLanguages[0]);
      dropdownLanguage = modifiedLanguages[0] || '';
    }

    let startDate = filingTypeId === FilingTypeEnum.VATBOOKS ? params.startDate :((this.props.filingValues && this.props.filingValues.startDate) || params.dueDate);
    let endDate = filingTypeId === FilingTypeEnum.VATBOOKS ? params.endDate : (this.props.filingValues && this.props.filingValues.endDate);

    if (
      filingTypeId === FilingTypeEnum.ECLISTING ||
      filingTypeId === FilingTypeEnum.LOCALLISTING ||
      filingTypeId === FilingTypeEnum.REVERSECHARGELISTING
    ) {
      let editableFilingValues = _.cloneDeep(this.props.filingValues);
      this.setState({
          editableFilingValues: editableFilingValues
      });
      this.setupEditableLinesData(editableFilingValues && editableFilingValues.lines, filingTypeId);
    }
    // Async VAT Return delegates to a dedicated helper so the same GET +
    // state-machine is reused by doSelectReportLanguage when the user changes
    // language. The helper resets preview state synchronously so the user does
    // not see a stale preview while the GET is in flight.
    const isAsyncVatReturn = filingTypeId === FilingTypeEnum.VATRETURN && this.isAsyncVatReturnEnabled();
    if (isAsyncVatReturn) {
      this.refreshAsyncVatReturnFromGet(selection, dropdownLanguage);
      return;
    }
    //If filing type is vat books or intrastat (with feature flag)
    if(filingTypeId === FilingTypeEnum.VATBOOKS ||
       (filingTypeId === FilingTypeEnum.INTRASTAT && this.props.enableNewIntrastatOpenReturnPage)) {
      // Pass dropdownLanguage explicitly: setState({selectedLanguage/reportLanguage})
      // from above has not flushed yet, and GET identity must match the POST `language`.
      const returnsInfo = this.buildReturnsParams(selection, dropdownLanguage);
      if (filingTypeId === FilingTypeEnum.INTRASTAT && flowType && IntrastatFlowEnum.props[flowType]) {
        // Intrastat Out (Sales) => 1, Intrastat In (Purchases) => 2
        returnsInfo.reportType = IntrastatFlowEnum.props[flowType].value;
      }
      const getFilingTypeName = () => {
        if (filingTypeId === FilingTypeEnum.VATBOOKS) return 'VAT Books';
        if (filingTypeId === FilingTypeEnum.INTRASTAT) return 'Intrastat';
        return 'Unknown';
      };
      log.debug(`getReturns called for ${getFilingTypeName()}:`, returnsInfo);
      this.props.getReturns(returnsInfo, (error, response) => {
        log.debug(`getReturns response for ${getFilingTypeName()}:`, error ? 'ERROR' : 'SUCCESS', error || response);
        //If error is not found, this is the first time a user is requesting to generate a return
        if(error) {
          if(error.notFound) {
            this.props.doLoadUserQuestions({
              type: filingTypeId,
              companyId: params.companyId,
              startDate: startDate,
              formXMLFileName: selection.formXmlId,
              frequency: frequency,
              flowType: flowType,
              endDate: endDate,
              returnDisplayType: parsedQueryParams.returnDisplayType,
              correctionPeriod: this.selectedCorrectionPeriod
            });
            //Only allow to generate
            if(filingTypeId === FilingTypeEnum.VATBOOKS) {
              this.setState({
                vatBooksShowGenerate: true,
                vatBooksShowRegenerate: false,
                vatBooksShowDownload: false,
                returnGenerationPending: false,
                showReturnGenerationControls: false,
                returnsDocumentURL: '',
                returnsDocumentPdfPreviewURL: '',
                extension: '',
                extensionPdfPreview: undefined,
                mimeType: '',
                mimeTypePdfPreview: undefined
              });
            } else if(filingTypeId === FilingTypeEnum.INTRASTAT && this.props.enableNewIntrastatOpenReturnPage) {
              if (this.state.reportAlreadySubmitted) {
                this.applyIntrastatAlreadySubmittedQuestionsState(selection);
              } else {
                this.setState({
                  intrastatShowGenerate: true,
                  intrastatShowRegenerate: false,
                  intrastatShowDownload: false,
                  intrastatReturnGenerationPending: false,
                  showIntrastatReturnGenerationControls: false
                });
              }
            }
          } else {
            //TODO: Show some error message; something went wrong
          }
        }
        //If there is no error; check if returns generation is in progress or not
        else {
          let {locationType} = response;
          let {location} = response;
          let {extension} = response;
          let {mimeType} = response;
          let {preview} = response;
          let {fileName} = response;  // filename persisted from the getReturns API call
          //Returns generated
          if(locationType === "returns") {
            // //Allow to regenerate and download
            if(filingTypeId === FilingTypeEnum.VATBOOKS) {
              this.setState({
                vatBooksShowGenerate: false,
                vatBooksShowRegenerate: true,
                vatBooksShowDownload: true,
                showReturnGenerationControls: true,
                returnGenerationPending: false,
                returnsDocumentURL: location,
                returnsDocumentPdfPreviewURL: preview ? `${vrRestApiHost}/${preview.location}` : '',
                extension: extension,
                extensionPdfPreview: preview?.extension,
                mimeType: mimeType,
                mimeTypePdfPreview: preview?.mimeType
              });
            } else if(filingTypeId === FilingTypeEnum.INTRASTAT && this.props.enableNewIntrastatOpenReturnPage) {
              if (this.state.reportAlreadySubmitted) {
                this.applyIntrastatAlreadySubmittedQuestionsState(selection);
              } else {
                this.setState({
                  intrastatShowGenerate: false,
                  intrastatShowRegenerate: true,
                  intrastatShowDownload: true,
                  showIntrastatReturnGenerationControls: true,
                  intrastatReturnGenerationPending: false,
                  intrastatReturnsDocumentURL: location,
                  intrastatReturnsDocumentPdfPreviewURL: preview ? `${vrRestApiHost}/${preview.location}` : '',
                  intrastatExtension: extension,
                  intrastatMimeType: mimeType,
                  intrastatFileName: fileName  // fileName updated to state
                });
                log.clearDictionaryError(ALL_MESSAGES.INTRASTAT_RETURNS_GENERATION_PENDING);
              }
            }
          }
          //Returns generation is in progress
          else {
            //Display a message that the returns generation is in progress
            if(filingTypeId === FilingTypeEnum.VATBOOKS) {
              log.setDictionaryMessage(ALL_MESSAGES.VAT_BOOKS_RETURNS_GENERATION_PENDING);
              this.setState({
                vatBooksShowGenerate: false,
                vatBooksShowRegenerate: false,
                vatBooksShowDownload: false,
                returnGenerationPending: true
              });
            } else if(filingTypeId === FilingTypeEnum.INTRASTAT) {
              if (this.state.reportAlreadySubmitted) {
                this.applyIntrastatAlreadySubmittedQuestionsState(selection);
              } else {
                log.setDictionaryMessage(ALL_MESSAGES.INTRASTAT_RETURNS_GENERATION_PENDING);
                this.setState({
                  intrastatShowGenerate: false,
                  intrastatShowRegenerate: false,
                  intrastatShowDownload: false,
                  intrastatReturnGenerationPending: true
                });
              }
            }
          }
        }
      });
    }
    //Case for non vat books type (and non-intrastat/vat return with feature flag)
    else {
      this.props.doLoadUserQuestions({
        type: filingTypeId,
        companyId: params.companyId,
        startDate: startDate,
        formXMLFileName: selection.formXmlId,
        frequency: frequency,
        flowType: flowType,
        endDate: endDate,
        returnDisplayType: parsedQueryParams.returnDisplayType,
        correctionPeriod: this.selectedCorrectionPeriod
      });
    }
  }

  // Async VAT Return state-machine for GET /api/returns. Shared between
  // doSelectFilingOption (filing-type change) and doSelectReportLanguage
  // (language change) so both code paths react identically to the response:
  //   - 404         -> route user to the Return Questions sub-tab
  //   - 200 returns -> render preview + the 4 controls (View Filing sub-tab),
  //                    unless the period is already closed (Return Questions only)
  //   - 200 ops     -> show the "generation pending" banner
  //
  // `language` is optional. When omitted, buildReturnsParams falls back to
  // the redux-tracked reportLanguage. doSelectReportLanguage passes the
  // freshly-computed effective language explicitly because the next-tick
  // setState({reportLanguage}) has not landed yet when this fires.
  refreshAsyncVatReturnFromGet(selection, language) {
    const params = (this.props.match && this.props.match.params) || {};
    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    const filingTypeId = params.filingTypeId || -1;
    const frequency = parsedQueryParams && parsedQueryParams.frequency;
    const flowType = parsedQueryParams && parsedQueryParams.flow;
    const startDate = (this.props.filingValues && this.props.filingValues.startDate) || params.dueDate;
    const endDate = this.props.filingValues && this.props.filingValues.endDate;

    // Synchronously clear the previously-rendered preview + controls so the
    // user never sees a document keyed to the stale (filing-type, language)
    this.setState({
      showVatReturnGenerationControls: false,
      vatReturnGenerationPending: true,
      vatReturnShowGenerate: false,
      vatReturnShowRegenerate: false,
      vatReturnShowDownload: false,
      vatReturnReturnsDocumentURL: '',
      vatReturnReturnsDocumentPdfPreviewURL: '',
      vatReturnExtension: '',
      vatReturnMimeType: '',
      vatReturnFileName: ''
    });

    const returnsInfo = this.buildReturnsParams(selection, language);
    log.debug('getReturns called for VAT Return (async):', returnsInfo);
    this.props.getReturns(returnsInfo, (error, response) => {
      log.debug('getReturns response for VAT Return (async):', error ? 'ERROR' : 'SUCCESS', error || response);
      if (error) {
        if (error.notFound) {
          if (this.state.reportAlreadySubmitted) {
            this.applyVatReturnClosedPeriodState(selection);
          } else {
            this.props.doLoadUserQuestions({
              type: filingTypeId,
              companyId: params.companyId,
              startDate: startDate,
              formXMLFileName: selection && selection.formXmlId,
              frequency: frequency,
              flowType: flowType,
              endDate: endDate,
              returnDisplayType: parsedQueryParams.returnDisplayType,
              correctionPeriod: this.selectedCorrectionPeriod
            });
            this.setState({
              vatReturnShowGenerate: true,
              vatReturnShowRegenerate: false,
              vatReturnShowDownload: false,
              vatReturnGenerationPending: false,
              showVatReturnGenerationControls: false
            });
          }
        } else {
          this.setState({ vatReturnGenerationPending: false });
        }

        return;
      }
      const { locationType } = response;
      if (locationType === 'returns') {
        this.applyVatReturnReadyState(response, selection);
      } else if (this.state.reportAlreadySubmitted) {
        this.applyVatReturnClosedPeriodState(selection);
      } else {
        log.setDictionaryMessage(ALL_MESSAGES.VAT_RETURN_GENERATION_PENDING);
        this.setState({
          vatReturnShowGenerate: false,
          vatReturnShowRegenerate: false,
          vatReturnShowDownload: false,
          vatReturnGenerationPending: true
        });
        this.startVatReturnGenerationPolling();
      }
    });
  }

  refreshIntrastatReturnFromGet(selection, language) {
    const params = (this.props.match && this.props.match.params) || {};
    const parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    const filingTypeId = params.filingTypeId || -1;
    const frequency = parsedQueryParams && parsedQueryParams.frequency;
    const flowType = parsedQueryParams && parsedQueryParams.flow;
    const startDate = (this.props.filingValues && this.props.filingValues.startDate) || params.dueDate;
    const endDate = this.props.filingValues && this.props.filingValues.endDate;

    this.setState({
      showIntrastatReturnGenerationControls: false,
      intrastatReturnGenerationPending: true,
      intrastatShowGenerate: false,
      intrastatShowRegenerate: false,
      intrastatShowDownload: false,
      intrastatReturnsDocumentURL: '',
      intrastatReturnsDocumentPdfPreviewURL: '',
      intrastatExtension: '',
      intrastatMimeType: '',
      intrastatFileName: ''
    });

    const returnsInfo = this.buildReturnsParams(selection, language);
    if (flowType && IntrastatFlowEnum.props[flowType]) {
      returnsInfo.reportType = IntrastatFlowEnum.props[flowType].value;
    }
    log.debug('getReturns called for Intrastat (async):', returnsInfo);
    this.props.getReturns(returnsInfo, (error, response) => {
      log.debug('getReturns response for Intrastat (async):', error ? 'ERROR' : 'SUCCESS', error || response);
      if (error) {
        // 404 => no return yet for this (filing-type, language): route the user
        // to Return Questions. Any other error only clears the pending state and
        // leaves the currently-rendered preview/controls untouched (mirrors the
        // async VAT Return flow in refreshAsyncVatReturnFromGet).
        if (error.notFound) {
          if (this.state.reportAlreadySubmitted) {
            this.applyIntrastatAlreadySubmittedQuestionsState(selection);
          } else {
            this.props.doLoadUserQuestions({
              type: filingTypeId,
              companyId: params.companyId,
              startDate: startDate,
              formXMLFileName: selection && selection.formXmlId,
              frequency: frequency,
              flowType: flowType,
              endDate: endDate,
              returnDisplayType: parsedQueryParams.returnDisplayType,
              correctionPeriod: this.selectedCorrectionPeriod
            });
            this.setState({
              intrastatShowGenerate: true,
              intrastatShowRegenerate: false,
              intrastatShowDownload: false,
              intrastatReturnGenerationPending: false,
              showIntrastatReturnGenerationControls: false
            });
          }
        } else {
          this.setState({ intrastatReturnGenerationPending: false });
        }
        return;
      }
      const { locationType, location, extension, mimeType, preview, fileName } = response;
      if (locationType === 'returns') {
        if (this.state.reportAlreadySubmitted) {
          this.applyIntrastatAlreadySubmittedQuestionsState(selection);
        } else {
          this.setState({
            intrastatShowGenerate: false,
            intrastatShowRegenerate: true,
            intrastatShowDownload: true,
            showIntrastatReturnGenerationControls: true,
            intrastatReturnGenerationPending: false,
            intrastatReturnsDocumentURL: location,
            intrastatReturnsDocumentPdfPreviewURL: preview ? `${vrRestApiHost}/${preview.location}` : '',
            intrastatExtension: extension,
            intrastatMimeType: mimeType,
            intrastatFileName: fileName
          });
          log.clearDictionaryError(ALL_MESSAGES.INTRASTAT_RETURNS_GENERATION_PENDING);
        }
      } else if (this.state.reportAlreadySubmitted) {
        this.applyIntrastatAlreadySubmittedQuestionsState(selection);
      } else {
        log.setDictionaryMessage(ALL_MESSAGES.INTRASTAT_RETURNS_GENERATION_PENDING);
        this.setState({
          intrastatShowGenerate: false,
          intrastatShowRegenerate: false,
          intrastatShowDownload: false,
          intrastatReturnGenerationPending: true
        });
      }
    });
  }

  doSelectReportLanguage(selection, aLanguage) {
    // Set the language the user sees on the select element
    this.setState({ selectedLanguage: aLanguage });

    // Set the language we send to the reporting layer based on whether
    // we need to mark it as a translation or not - SVR-5615
    this.setReportLanguage(selection, aLanguage);

    // The dropdown's literal selection is forwarded verbatim to both refresh
    // methods below - the SVR-5615 English-fallback that setReportLanguage
    // applies to reportLanguage is intentionally NOT applied to the backend identity.
    const filingTypeId = selection && selection.filingTypeId;

    // Async VAT Return (PDF only): re-check GET /api/returns for the newly
    // selected language and route the user to the matching sub-tab.
    const isAsyncVatReturnPdf =
      this.isAsyncVatReturnEnabled() &&
      filingTypeId === FilingTypeEnum.VATRETURN &&
      selection && selection.outputType === 'PDF';

    if (isAsyncVatReturnPdf) {
      this.refreshAsyncVatReturnFromGet(selection, aLanguage);
      if (this.state.currentTab === 'approveFilings') {
        this.setState({ currentTab: undefined });
      }
      return;
    }

    // Async Intrastat (PDF only): same re-check pattern as VAT Return.
    const isAsyncIntrastatPdf =
      this.props.enableNewIntrastatOpenReturnPage &&
      filingTypeId === FilingTypeEnum.INTRASTAT &&
      selection && selection.outputType === 'PDF';

    if (isAsyncIntrastatPdf) {
      this.refreshIntrastatReturnFromGet(selection, aLanguage);
      if (this.state.currentTab === 'approveFilings') {
        this.setState({ currentTab: undefined });
      }
      return;
    }

    // Legacy behaviour for all other flows: stay-on-View-Filing protection.
    if (this.state.currentTab === 'approveFilings') {
      this.doSelectFilingOption(selection, false);
      this.setState({ currentTab: undefined });
    }
  }

  setReportLanguage(selection, aLanguage) {
    let drawTranslated = 0;
    if (selection !== undefined && selection !== null) {
      if (aLanguage === English && !selection.availableLanguages.includes(English)) {
        drawTranslated = 1;
        aLanguage = selection.availableLanguages[0]; // SVR-5615
      }
    }
    this.setState({
      reportLanguage: aLanguage,
      drawTranslated,
    });
  }

  modifyAvailableFilingLanguages(selection){
    //Initially this logic was present in child component FilingLanguageSelector.jsx
    //As part of SVR-4749 ,it has been moved to parent component because parent component needs
    //modifiedAvailableLanguages array while setting default state.
    let availableLanguages = [];
    if ((selection !== undefined) && (selection !== null))
    {
      availableLanguages = [...selection.availableLanguages];
      if ((selection.hasReferenceBoxes === "True") && (!selection.availableLanguages.includes(English)))
      {
        availableLanguages.push(English);
      }
    }
    return availableLanguages;
  }

}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);

  const userQuestionsForm = state.managedUxForms && state.managedUxForms.forms && state.managedUxForms.forms[USER_QUESTIONS_FORM];
  const fieldKeys =  Object.keys( (userQuestionsForm && userQuestionsForm.fieldValues) || {});
  let userFormFields = userQuestionsForm && userQuestionsForm.fieldValues;

  const userQuestions = state.userQuestions && state.userQuestions.data;
  let answers = {};
  if (userQuestions) {
    for (let group in userQuestions) {
      answers = userQuestions[group].reduce((answers, question) => {
        //If Field withing User Questions Form is Modified then we have to use updated answers
        let boxPropertyKey =  `${question.BoxID}`;
        if(userQuestionsForm && fieldKeys && fieldKeys.includes(boxPropertyKey)) {
          answers[question.BoxID] = userQuestionsForm.fieldValues[question.BoxID];
        }
        else {
          answers[question.BoxID] = question.BoxValue;
        }
        return answers;
      }, answers);
    }
  }

  const hiddenUserQuestions = state.userQuestions && state.userQuestions.hiddenUserQuestions || EMPTY_OBJECT;
  const filingTypes = (state.content && state.content.data && state.content.data.filingTypes) || EMPTY_OBJECT;
  const filingTypeShortnames = CONTENT_CONTROLLER.getDict(filingTypes);
  const ecListingLineTypes = (state.content && state.content.data && state.content.data.ecListingLineTypes) || EMPTY_OBJECT;
  const ectypeKeys = Object.keys(ecListingLineTypes);
  const ectypeOptions = ectypeKeys.map((key) => {
    return {
      value: key + '',
      label: (<LanguageStringResolver string={ecListingLineTypes[key].languageString}></LanguageStringResolver>)
    };
  });
  const createManualDocumentData = state.manualDocuments && state.manualDocuments.createData;
  return {
    content: state.content,
    filingOptions: state.filingOptions,
    companyList: (state.companies && state.companies.data) || [],
    filing: state.filing,
    correctionPeriods: state.filingCorrections?.correctionPeriods,
    // the requested filing data is always the first sub-object. Because there only is one sub-object. But its key varies.
    filingValues: (state.filing.data && Object.values(state.filing.data)[0]) || EMPTY_OBJECT,
    filingValuesLoading: state.filing.filingValuesLoading,
    filingTypes: filingTypeShortnames,
    ecListingLineTypes: (state.content && state.content.data && state.content.data.ecListingLineTypes) || EMPTY_OBJECT,
    filingValueDetail: state.filing.filingValueDetails,
    selectedFilingOption: state.filingOptions.selectedFilingOption,
    ectypeOptions: ectypeOptions || [],
    languages: state.languages,
    createManualDocumentData: createManualDocumentData,
    userQuestions,
    userFormFields,
    answers,
    hiddenUserQuestions,
    filingDocumentUri: state.filing && state.filing.filingDocumentDetails && state.filing.filingDocumentDetails.uri,
    filingDocumentFileExtension: state.filing && state.filing.filingDocumentDetails && state.filing.filingDocumentDetails.ext,
    reportTypeFrequencies: (state.content && state.content.contentData && state.content.contentData.filingFrequencies),
    filingDocumentFileName : state.filing && state.filing.filingDocumentDetails && state.filing.filingDocumentDetails.filingDocumentFileName,
    filingDocumentMultipleFilesToDownload : state.filing && state.filing.filingDocumentDetails && state.filing.filingDocumentDetails.multipleFilesToDownload,
    canUserSaveToWorkflow: state.filing.canUserSaveToWorkflow,
    workflowInProgress: state.filing.workflowInProgress,
    filteredFilingOptions: state.filingOptions.filteredFilingOptions,
    featureFlag: state.featureFlag?.data,
    entitlements: state.authentication?.entitlements,
    directSubmission: state.authentication?.data?.iamData?.directSubmission,
    userName: (state.authentication?.data?.userName) || "Unknown",
    enableCoSGrid: state.featureFlag?.data?.EnableCoSGrid,
    enableSiVatbookZipDownload: state.featureFlag?.data?.EnableSIVatbookZipDownload,
    enableNewIntrastatOpenReturnPage: state.featureFlag?.data?.EnableNewIntrastatOpenReturnPage,
    enableAsyncVatReturnOpenReturnPage: state.featureFlag?.data?.EnableAsyncVatReturnOpenReturnPage,
    enableAsyncVatReturnsForMvrUsers: state.featureFlag?.data?.EnableAsyncVatReturnsForMvrUsers,
    useV6CloseEndpointForVatBook: state.featureFlag?.data?.UseV6CloseEndpointForVatBook,
    useV6CloseEndpointForVatReturn: state.featureFlag?.data?.UseV6CloseEndpointForVatReturn,
    enableReturnApprovalWorkflow: state.featureFlag?.data?.[FeatureFlagEnum.ENABLE_RETURN_APPROVAL_WORKFLOW],
    returnApprovals: state.returnApprovals,
    useV6CloseEndpointForIntrastat: state.featureFlag?.data?.UseV6CloseEndpointForIntrastat
  };
}
function mapDispatchersToProps(dispatch) {
  return {
    onPageLoad: (queryParams, featureFlag) => {
      log.debug('onPageLoad: ', queryParams);
      dispatch(USER_QUESTIONS_CONTROLLER.doUnload());
      dispatch(FILING_CONTROLLER.resetFilingValues());
      dispatch(FILING_CONTROLLER.clearFilingDocumentDetails());

      if (queryParams.filingTypeId === FilingTypeEnum.VATRETURN)
      {
        dispatch(CONTENT_CONTROLLER.getReportPeriodicityOptions());
      }

      dispatch(FILING_OPTIONS_CONTROLLER.selectFilingOption());

      if (queryParams.startDate)
      {
        let flowType = queryParams.flow;
        if ((queryParams.filingTypeId === FilingTypeEnum.ECLISTING) || (queryParams.filingTypeId === FilingTypeEnum.ECLISTINGCORRECTION))  //For EC Listing we need to convert to the flow type used by the formXml
        {
          flowType = ENUMS.ConvertToECListingFlowEnum(queryParams.flow);
        }

        const startDateForFilterFilingOptions = (featureFlag?.UseCorrectionStartDateInFilteredOptions)
          ? FilingHelper.getStartDateForFilteredOptions(queryParams)
          : queryParams.startDate;

        dispatch(FILING_OPTIONS_CONTROLLER.getFilteredFilingOptions({
          returnType: FilingTypeEnum.props[queryParams.filingTypeId].filingOptionValue,
          countryId: queryParams.countryCode,
          startDate:startDateForFilterFilingOptions,
          frequency: queryParams.periodicity,
          flowType: ENUMS.DetermineFlowEnumFromFilingType(queryParams.filingTypeId, flowType),
          returnDisplayType: queryParams.returnDisplayType,
          companyId: queryParams.companyId
        }));

      }
      if (queryParams.periodicity)
      {
        switch (queryParams.filingTypeId)
        {
            case FilingTypeEnum.VATRETURN:
            case FilingTypeEnum.VATBOOKS:
                const params = {
                  type: queryParams.filingTypeId,
                  countryCode: queryParams.countryCode,
                  companyId: queryParams.companyId,
                  dueDate: queryParams.dueDate,
                  dueDateBefore: queryParams.startDate,
                  dueDateAfter: queryParams.endDate,
                  periodicity: queryParams.periodicity,
                  returnDisplayType: queryParams.returnDisplayType,
                  selectedCorrectionPeriod: queryParams.selectedCorrectionPeriod
                }
                if (FILING_CORRECTIONS_CONTROLLER.isGroupedDisplayType(params.returnDisplayType)) {
                  if (!params.selectedCorrectionPeriod) {
                    dispatch(FILING_CORRECTIONS_CONTROLLER.doUnloadCorrectionPeriods());
                    dispatch(FILING_CORRECTIONS_CONTROLLER.doLoadCorrectionPeriods(params));
                  } else {
                    dispatch(FILING_CONTROLLER.doLoadGroupedCorrections(params));
                  }
                } else {
                  dispatch(FILING_CORRECTIONS_CONTROLLER.doUnloadCorrectionPeriods());
                  dispatch(FILING_CONTROLLER.doLoadValues(params));
                }

                if (featureFlag?.EnableBoxDescription && queryParams.filingTypeId === FilingTypeEnum.VATRETURN) {
                  dispatch(FILING_CONTROLLER.doLoadBoxDescriptions({
                    reportType: 0,
                    companyId: queryParams.companyId,
                    countryCode: queryParams.countryCode,
                    periodEndDate: queryParams.endDate,
                    frequency: queryParams.periodicity
                  }));
                }
                break;

            case FilingTypeEnum.ECLISTING :
                log.debug('onPageLoad: Fetching eclisting: ', queryParams.filingTypeId);
                const ecParams = {
                  countryCode: queryParams.countryCode,
                  companyId: queryParams.companyId,
                  dueDate: queryParams.dueDate,
                  dueDateBefore: queryParams.startDate,
                  dueDateAfter: queryParams.endDate,
                  flow: queryParams.flow,
                  periodicity: queryParams.periodicity,
                  returnDisplayType: queryParams.returnDisplayType,
                  selectedCorrectionPeriod: queryParams.selectedCorrectionPeriod,
                  type: queryParams.filingTypeId,
                }

                if(!featureFlag?.EnableECTransactionFilterOpenReturns) {
                  dispatch(FILING_CONTROLLER.doLoadEcListingReports(ecParams));
                  break;
                }

                if (!FILING_CORRECTIONS_CONTROLLER.isGroupedDisplayType(ecParams.returnDisplayType)) {
                  dispatch(FILING_CORRECTIONS_CONTROLLER.doUnloadCorrectionPeriods());
                  dispatch(FILING_CONTROLLER.doLoadECGroupedCorrections(ecParams));
                  break;
                }

                if (!ecParams.selectedCorrectionPeriod) {
                  dispatch(FILING_CORRECTIONS_CONTROLLER.doUnloadCorrectionPeriods());
                  dispatch(FILING_CORRECTIONS_CONTROLLER.doLoadECCorrectionPeriods(ecParams));
                } else {
                  dispatch(FILING_CONTROLLER.doLoadECGroupedCorrections(ecParams));
                }
                break;

            case FilingTypeEnum.LOCALLISTING:
              log.debug('onPageLoad: Fetching Local Listing: ', queryParams.filingTypeId);
              dispatch(FILING_CONTROLLER.doLoadLocalListingFilingValues({
                countryCode: queryParams.countryCode,
                companyId: queryParams.companyId,
                dueDate: queryParams.dueDate,
                dueDateBefore: queryParams.startDate,
                dueDateAfter: queryParams.endDate,
                flow: queryParams.flow
              }));
              break;

            case FilingTypeEnum.REVERSECHARGELISTING:
              log.debug('onPageLoad: Fetching reverse charge listing: ', queryParams.filingTypeId);
              dispatch(FILING_CONTROLLER.doLoadReverseChargeListingValues({
                countryCode: queryParams.countryCode,
                companyId: queryParams.companyId,
                dueDate: queryParams.dueDate,
                dueDateBefore: queryParams.startDate,
                dueDateAfter: queryParams.endDate,
                flow: queryParams.flow
              }));
              break;

            case FilingTypeEnum.INTRASTAT:
                log.debug('onPageLoad: Fetching Intra: ', queryParams.filingTypeId);
                dispatch(FILING_CONTROLLER.doLoadIntrastatReports({
                    country: queryParams.countryCode,
                    companyId: queryParams.companyId,
                    dueDateBefore: queryParams.startDate,
                    dueDateAfter: queryParams.endDate,
                    reportType: queryParams.flow,
                    returnDisplayType: queryParams.returnDisplayType,
                    periodicity: queryParams.periodicity,
                    simplifiedIntrastat: queryParams.simplifiedIntrastat
                }));
                break;
            case FilingTypeEnum.EXTRASTAT:
                log.debug('onPageLoad: EXTRASTAT: ', queryParams.filingTypeId);
                dispatch(FILING_CONTROLLER.doLoadExtrastatReports ({
                  country: queryParams.countryCode,
                  companyId: queryParams.companyId,
                  dueDateBefore: queryParams.startDate,
                  dueDateAfter: queryParams.endDate,
                  reportType : queryParams.flow,
                  periodicity: queryParams.periodicity
                }));
                break;
            case FilingTypeEnum.OSSIMPORT:
            case FilingTypeEnum.OSSNONUNION:
            case FilingTypeEnum.OSSUNION:
                log.debug('onPageLoad: Fetching OSS: ', queryParams.filingTypeId,queryParams.grouped);
                if (checkFeatureFlagForReturnType(queryParams.filingTypeId)) {
                  dispatch(FILING_CONTROLLER.doLoadOSSReportsLatest({
                    country: queryParams.countryCode,
                    companyId: queryParams.companyId,
                    dueDateBefore: queryParams.startDate,
                    dueDateAfter: queryParams.endDate,
                    reportType : queryParams.filingTypeId,
                    returnDisplayType : queryParams.returnDisplayType,
                    periodicity: queryParams.periodicity,
                    grouped : queryParams.grouped || "0"
                  }));
                } else {
                  dispatch(FILING_CONTROLLER.doLoadOSSReports({
                    country: queryParams.countryCode,
                    companyId: queryParams.companyId,
                    dueDateBefore: queryParams.startDate,
                    dueDateAfter: queryParams.endDate,
                    reportType : queryParams.filingTypeId,
                    returnDisplayType : 0,
                    periodicity: queryParams.periodicity,
                    grouped : queryParams.grouped || "1"
                  }));
                }
                break;
            default:
              dispatch(FILING_CONTROLLER.doLoadValues({
                type: queryParams.filingTypeId,
                countryCode: queryParams.countryCode,
                companyId: queryParams.companyId,
                dueDate: queryParams.dueDate,
                dueDateBefore: queryParams.startDate,
                dueDateAfter: queryParams.endDate,
                listingType: ECListingFlowPerTransactionTypesEnum.SALES
              }));
        }
      }
    },
    doClearSuccess: () => {
      dispatch(MANUAL_DOCUMENTS_CONTROLLER.clearManualDocumentSuccess());
    },
    onSelectFilingOption: (filingOption) => {
      log.debug('onSelectFilingOption: ', filingOption);
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doRemoveForm(USER_QUESTIONS_FORM));
      dispatch(USER_QUESTIONS_CONTROLLER.doUnload());
      dispatch(FILING_CONTROLLER.clearFilingDocumentDetails());
      dispatch(FILING_OPTIONS_CONTROLLER.selectFilingOption(filingOption));
    },
    doLoadUserQuestions: (params) => {
      log.debug('doLoadUserQuestions: ', params);
      dispatch(USER_QUESTIONS_CONTROLLER.doUnload());
      return dispatch(USER_QUESTIONS_CONTROLLER.doLoad(params));
    },
    generateFilingDocument: (formXmlId, filingTypeId, options, downloadInBrowser, callback) => {
      log.debug('generateFilingDocument(): formXmlId: %s, filingTypeId: %s, format: %s, options: ', formXmlId, filingTypeId, options);
      dispatch(FILING_CONTROLLER.doCreateFilingDocument(formXmlId, filingTypeId, options, downloadInBrowser, callback));
    },
    doRemoveForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doRemoveForm(USER_QUESTIONS_FORM));
    },
    getReturns: (params, callback) => {
      dispatch(FILING_CONTROLLER.getReturns(params, callback));
    },
    downloadReturns: (documentType, url, callback) => {
      dispatch(FILING_CONTROLLER.getReturnsDocument(documentType, url, callback));
    },
    downloadRawFormXml: (guid, callback) => {
      dispatch(FILING_CONTROLLER.getReturnRawFormXml(guid, callback));
    },
    prepareReturns: (returnDetails={}) => {
      dispatch(FILING_CONTROLLER.generateReturns(returnDetails));
    },
    prepareReturnsForIntrastat: (returnDetails={}, callback=()=>{}) => {
      dispatch(FILING_CONTROLLER.generateReturnsForIntrastat(returnDetails, callback));
    },
    prepareReturnsForVatReturn: (returnDetails={}, callback=()=>{}) => {
      dispatch(FILING_CONTROLLER.generateReturnsForVatReturn(returnDetails, callback));
    },
    getCanUserSaveToWorkflow : (callback) => {
      dispatch(FILING_CONTROLLER.getCanUserSaveToWorkflow(callback));
    },
    doSaveToWorkflow: (params, workflowCallback) => {
      dispatch(FILING_CONTROLLER.doSaveToWorkflow(params, workflowCallback));
    },
    doInitiateAutoSubmission: (params, callback) => {
      dispatch(FILING_CONTROLLER.doInitiateAutoSubmission(params, callback));
    },
    doCheckWorkflowInProgress: (params) => {
      dispatch(FILING_CONTROLLER.checkWorkflowInProgress(params));
    },
    doGetReturnApprovalStatus: (params) => dispatch(RETURN_APPROVALS_CONTROLLER.getStatus(params)),
    doSendReturnForApproval: (params) => dispatch(RETURN_APPROVALS_CONTROLLER.send(params)),
    doResetReturnApprovals: () => dispatch(RETURN_APPROVALS_CONTROLLER.reset()),
    onCloseVatBook: (requestBody) => {
      return dispatch(FILING_CONTROLLER.doCloseVatBook(requestBody));
    },
    onCloseReturn: (requestBody) => {
      return dispatch(FILING_CONTROLLER.doCloseReturn(requestBody));
    },
    checkReportAlreadySubmitted: (params) => {
      return dispatch(FILING_CONTROLLER.checkReportAlreadySubmitted(params));
    },
    doCreateAutoAdjustment: (params, callback) => {
      dispatch(MANUAL_DOCUMENTS_CONTROLLER.doCreateManualDocumentLatest(params, callback));
    },
    doUpdateBoxValueAutoCorrectFlag: (params, callback) => {
      dispatch(FILING_CONTROLLER.doUpdateBoxValueAutoCorrectFlag(params, callback));
    },
  }
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(FilingPage);